
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2844"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2844"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyM0p", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ef7c3885563104b0$export$ffb0004e005737fa; }, function (v) { return $ef7c3885563104b0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ef7c3885563104b0$export$34b9dba7ce09269b; }, function (v) { return $ef7c3885563104b0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ef7c3885563104b0$export$25062201e9e25d76; }, function (v) { return $ef7c3885563104b0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef7c3885563104b0$export$ffb0004e005737fa;
var $ef7c3885563104b0$export$34b9dba7ce09269b;
var $ef7c3885563104b0$export$25062201e9e25d76;
"use strict";
var $ef7c3885563104b0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ef7c3885563104b0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $ef7c3885563104b0$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $ef7c3885563104b0$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$ef7c3885563104b0$export$ffb0004e005737fa = $ef7c3885563104b0$var$REACT_FRAGMENT_TYPE;
$ef7c3885563104b0$export$34b9dba7ce09269b = $ef7c3885563104b0$var$jsxProd;
$ef7c3885563104b0$export$25062201e9e25d76 = $ef7c3885563104b0$var$jsxProd;

});

parcelRegister("bjR3q", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $83da9f8ce41d3d63$export$dca3b0875bd9a954; }, function (v) { return $83da9f8ce41d3d63$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $83da9f8ce41d3d63$export$16fa2f45be04daa8; }, function (v) { return $83da9f8ce41d3d63$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $83da9f8ce41d3d63$export$ffb0004e005737fa; }, function (v) { return $83da9f8ce41d3d63$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $83da9f8ce41d3d63$export$e2c29f18771995cb; }, function (v) { return $83da9f8ce41d3d63$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $83da9f8ce41d3d63$export$221d75b3f55bb0bd; }, function (v) { return $83da9f8ce41d3d63$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $83da9f8ce41d3d63$export$5f8d39834fd61797; }, function (v) { return $83da9f8ce41d3d63$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $83da9f8ce41d3d63$export$74bf444e3cd11ea5; }, function (v) { return $83da9f8ce41d3d63$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $83da9f8ce41d3d63$export$1ced07cd6b1985ce; }, function (v) { return $83da9f8ce41d3d63$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $83da9f8ce41d3d63$export$3ba232387fd5d6dd; }, function (v) { return $83da9f8ce41d3d63$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $83da9f8ce41d3d63$export$69a3209f1a06c04d; }, function (v) { return $83da9f8ce41d3d63$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $83da9f8ce41d3d63$export$e530037191fcd5d7; }, function (v) { return $83da9f8ce41d3d63$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $83da9f8ce41d3d63$export$fd42f52fd3ae1109; }, function (v) { return $83da9f8ce41d3d63$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $83da9f8ce41d3d63$export$c8a8987d4410bf2d; }, function (v) { return $83da9f8ce41d3d63$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $83da9f8ce41d3d63$export$7d1e3a5e95ceca43; }, function (v) { return $83da9f8ce41d3d63$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $83da9f8ce41d3d63$export$257a8862b851cb5b; }, function (v) { return $83da9f8ce41d3d63$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $83da9f8ce41d3d63$export$a8257692ac88316c; }, function (v) { return $83da9f8ce41d3d63$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $83da9f8ce41d3d63$export$488013bae63b21da; }, function (v) { return $83da9f8ce41d3d63$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $83da9f8ce41d3d63$export$7c73462e0d25e514; }, function (v) { return $83da9f8ce41d3d63$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $83da9f8ce41d3d63$export$7568632d0d33d16d; }, function (v) { return $83da9f8ce41d3d63$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8; }, function (v) { return $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $83da9f8ce41d3d63$export$1f96ae73734a86cc; }, function (v) { return $83da9f8ce41d3d63$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $83da9f8ce41d3d63$export$9a47ced3238df325; }, function (v) { return $83da9f8ce41d3d63$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $83da9f8ce41d3d63$export$35808ee640e87ca7; }, function (v) { return $83da9f8ce41d3d63$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $83da9f8ce41d3d63$export$fae74005e78b1a27; }, function (v) { return $83da9f8ce41d3d63$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e; }, function (v) { return $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $83da9f8ce41d3d63$export$6a7bc4e911dc01cf; }, function (v) { return $83da9f8ce41d3d63$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $83da9f8ce41d3d63$export$6d9c69b0de29b591; }, function (v) { return $83da9f8ce41d3d63$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $83da9f8ce41d3d63$export$f680877a34711e37; }, function (v) { return $83da9f8ce41d3d63$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $83da9f8ce41d3d63$export$d5a552a76deda3c2; }, function (v) { return $83da9f8ce41d3d63$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $83da9f8ce41d3d63$export$aaabe4eda9ed9969; }, function (v) { return $83da9f8ce41d3d63$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $83da9f8ce41d3d63$export$e5c5a5f917a5871c; }, function (v) { return $83da9f8ce41d3d63$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $83da9f8ce41d3d63$export$1538c33de8887b59; }, function (v) { return $83da9f8ce41d3d63$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $83da9f8ce41d3d63$export$fca7f784ae7a249a; }, function (v) { return $83da9f8ce41d3d63$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $83da9f8ce41d3d63$export$13e3392192263954; }, function (v) { return $83da9f8ce41d3d63$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $83da9f8ce41d3d63$export$b8f5890fc79d6aca; }, function (v) { return $83da9f8ce41d3d63$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $83da9f8ce41d3d63$export$60241385465d0a34; }, function (v) { return $83da9f8ce41d3d63$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $83da9f8ce41d3d63$export$306c0aa65ff9ec16; }, function (v) { return $83da9f8ce41d3d63$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $83da9f8ce41d3d63$export$7b286972b8d8ccbf; }, function (v) { return $83da9f8ce41d3d63$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $83da9f8ce41d3d63$export$83d89fbfd8236492; }, function (v) { return $83da9f8ce41d3d63$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $83da9f8ce41d3d63$export$dca3b0875bd9a954;
var $83da9f8ce41d3d63$export$16fa2f45be04daa8;
var $83da9f8ce41d3d63$export$ffb0004e005737fa;
var $83da9f8ce41d3d63$export$e2c29f18771995cb;
var $83da9f8ce41d3d63$export$221d75b3f55bb0bd;
var $83da9f8ce41d3d63$export$5f8d39834fd61797;
var $83da9f8ce41d3d63$export$74bf444e3cd11ea5;
var $83da9f8ce41d3d63$export$1ced07cd6b1985ce;
var $83da9f8ce41d3d63$export$3ba232387fd5d6dd;
var $83da9f8ce41d3d63$export$69a3209f1a06c04d;
var $83da9f8ce41d3d63$export$e530037191fcd5d7;
var $83da9f8ce41d3d63$export$fd42f52fd3ae1109;
var $83da9f8ce41d3d63$export$c8a8987d4410bf2d;
var $83da9f8ce41d3d63$export$7d1e3a5e95ceca43;
var $83da9f8ce41d3d63$export$257a8862b851cb5b;
var $83da9f8ce41d3d63$export$a8257692ac88316c;
var $83da9f8ce41d3d63$export$488013bae63b21da;
var $83da9f8ce41d3d63$export$7c73462e0d25e514;
var $83da9f8ce41d3d63$export$7568632d0d33d16d;
var $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8;
var $83da9f8ce41d3d63$export$1f96ae73734a86cc;
var $83da9f8ce41d3d63$export$9a47ced3238df325;
var $83da9f8ce41d3d63$export$35808ee640e87ca7;
var $83da9f8ce41d3d63$export$fae74005e78b1a27;
var $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e;
var $83da9f8ce41d3d63$export$6a7bc4e911dc01cf;
var $83da9f8ce41d3d63$export$6d9c69b0de29b591;
var $83da9f8ce41d3d63$export$f680877a34711e37;
var $83da9f8ce41d3d63$export$d5a552a76deda3c2;
var $83da9f8ce41d3d63$export$aaabe4eda9ed9969;
var $83da9f8ce41d3d63$export$e5c5a5f917a5871c;
var $83da9f8ce41d3d63$export$1538c33de8887b59;
var $83da9f8ce41d3d63$export$fca7f784ae7a249a;
var $83da9f8ce41d3d63$export$13e3392192263954;
var $83da9f8ce41d3d63$export$b8f5890fc79d6aca;
var $83da9f8ce41d3d63$export$60241385465d0a34;
var $83da9f8ce41d3d63$export$306c0aa65ff9ec16;
var $83da9f8ce41d3d63$export$7b286972b8d8ccbf;
var $83da9f8ce41d3d63$export$83d89fbfd8236492;

var $4TNnu = parcelRequire("4TNnu");
"use strict";
var $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $83da9f8ce41d3d63$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $83da9f8ce41d3d63$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $83da9f8ce41d3d63$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $83da9f8ce41d3d63$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $83da9f8ce41d3d63$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $83da9f8ce41d3d63$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $83da9f8ce41d3d63$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $83da9f8ce41d3d63$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $83da9f8ce41d3d63$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $83da9f8ce41d3d63$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $83da9f8ce41d3d63$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $83da9f8ce41d3d63$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $83da9f8ce41d3d63$var$assign = Object.assign, $83da9f8ce41d3d63$var$emptyObject = {};
function $83da9f8ce41d3d63$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $83da9f8ce41d3d63$var$emptyObject;
    this.updater = updater || $83da9f8ce41d3d63$var$ReactNoopUpdateQueue;
}
$83da9f8ce41d3d63$var$Component.prototype.isReactComponent = {};
$83da9f8ce41d3d63$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$83da9f8ce41d3d63$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $83da9f8ce41d3d63$var$ComponentDummy() {}
$83da9f8ce41d3d63$var$ComponentDummy.prototype = $83da9f8ce41d3d63$var$Component.prototype;
function $83da9f8ce41d3d63$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $83da9f8ce41d3d63$var$emptyObject;
    this.updater = updater || $83da9f8ce41d3d63$var$ReactNoopUpdateQueue;
}
var $83da9f8ce41d3d63$var$pureComponentPrototype = $83da9f8ce41d3d63$var$PureComponent.prototype = new $83da9f8ce41d3d63$var$ComponentDummy();
$83da9f8ce41d3d63$var$pureComponentPrototype.constructor = $83da9f8ce41d3d63$var$PureComponent;
$83da9f8ce41d3d63$var$assign($83da9f8ce41d3d63$var$pureComponentPrototype, $83da9f8ce41d3d63$var$Component.prototype);
$83da9f8ce41d3d63$var$pureComponentPrototype.isPureReactComponent = !0;
var $83da9f8ce41d3d63$var$isArrayImpl = Array.isArray, $83da9f8ce41d3d63$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $83da9f8ce41d3d63$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $83da9f8ce41d3d63$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $83da9f8ce41d3d63$var$cloneAndReplaceKey(oldElement, newKey) {
    return $83da9f8ce41d3d63$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $83da9f8ce41d3d63$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE;
}
function $83da9f8ce41d3d63$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex = /\/+/g;
function $83da9f8ce41d3d63$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $83da9f8ce41d3d63$var$escape("" + element.key) : index.toString(36);
}
function $83da9f8ce41d3d63$var$noop$1() {}
function $83da9f8ce41d3d63$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($83da9f8ce41d3d63$var$noop$1, $83da9f8ce41d3d63$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $83da9f8ce41d3d63$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE:
                case $83da9f8ce41d3d63$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $83da9f8ce41d3d63$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $83da9f8ce41d3d63$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $83da9f8ce41d3d63$var$getElementKey(children, 0) : nameSoFar, $83da9f8ce41d3d63$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $83da9f8ce41d3d63$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($83da9f8ce41d3d63$var$isValidElement(callback) && (callback = $83da9f8ce41d3d63$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($83da9f8ce41d3d63$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $83da9f8ce41d3d63$var$getElementKey(nameSoFar, i), invokeCallback += $83da9f8ce41d3d63$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $83da9f8ce41d3d63$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $83da9f8ce41d3d63$var$getElementKey(nameSoFar, i++), invokeCallback += $83da9f8ce41d3d63$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $83da9f8ce41d3d63$var$mapIntoArray($83da9f8ce41d3d63$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $83da9f8ce41d3d63$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $83da9f8ce41d3d63$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $83da9f8ce41d3d63$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $83da9f8ce41d3d63$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $4TNnu && "function" === typeof $4TNnu.emit) {
        $4TNnu.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $83da9f8ce41d3d63$var$noop() {}
$83da9f8ce41d3d63$export$dca3b0875bd9a954 = {
    map: $83da9f8ce41d3d63$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $83da9f8ce41d3d63$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $83da9f8ce41d3d63$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $83da9f8ce41d3d63$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$83da9f8ce41d3d63$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$83da9f8ce41d3d63$export$16fa2f45be04daa8 = $83da9f8ce41d3d63$var$Component;
$83da9f8ce41d3d63$export$ffb0004e005737fa = $83da9f8ce41d3d63$var$REACT_FRAGMENT_TYPE;
$83da9f8ce41d3d63$export$e2c29f18771995cb = $83da9f8ce41d3d63$var$REACT_PROFILER_TYPE;
$83da9f8ce41d3d63$export$221d75b3f55bb0bd = $83da9f8ce41d3d63$var$PureComponent;
$83da9f8ce41d3d63$export$5f8d39834fd61797 = $83da9f8ce41d3d63$var$REACT_STRICT_MODE_TYPE;
$83da9f8ce41d3d63$export$74bf444e3cd11ea5 = $83da9f8ce41d3d63$var$REACT_SUSPENSE_TYPE;
$83da9f8ce41d3d63$export$1ced07cd6b1985ce = $83da9f8ce41d3d63$var$ReactSharedInternals;
$83da9f8ce41d3d63$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$83da9f8ce41d3d63$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$83da9f8ce41d3d63$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $83da9f8ce41d3d63$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$83da9f8ce41d3d63$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $83da9f8ce41d3d63$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$83da9f8ce41d3d63$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $83da9f8ce41d3d63$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $83da9f8ce41d3d63$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$83da9f8ce41d3d63$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$83da9f8ce41d3d63$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $83da9f8ce41d3d63$var$ReactElement(type, key, void 0, void 0, null, props);
};
$83da9f8ce41d3d63$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$83da9f8ce41d3d63$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$83da9f8ce41d3d63$export$a8257692ac88316c = $83da9f8ce41d3d63$var$isValidElement;
$83da9f8ce41d3d63$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $83da9f8ce41d3d63$var$lazyInitializer
    };
};
$83da9f8ce41d3d63$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$83da9f8ce41d3d63$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $83da9f8ce41d3d63$var$ReactSharedInternals.T, currentTransition = {};
    $83da9f8ce41d3d63$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $83da9f8ce41d3d63$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($83da9f8ce41d3d63$var$noop, $83da9f8ce41d3d63$var$reportGlobalError);
    } catch (error) {
        $83da9f8ce41d3d63$var$reportGlobalError(error);
    } finally{
        $83da9f8ce41d3d63$var$ReactSharedInternals.T = prevTransition;
    }
};
$83da9f8ce41d3d63$export$f93f40ac0ca7e3a8 = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useCacheRefresh();
};
$83da9f8ce41d3d63$export$1f96ae73734a86cc = function(usable) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.use(usable);
};
$83da9f8ce41d3d63$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$83da9f8ce41d3d63$export$35808ee640e87ca7 = function(callback, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$83da9f8ce41d3d63$export$fae74005e78b1a27 = function(Context) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useContext(Context);
};
$83da9f8ce41d3d63$export$dc8fbce3eb94dc1e = function() {};
$83da9f8ce41d3d63$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$83da9f8ce41d3d63$export$6d9c69b0de29b591 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useEffect(create, deps);
};
$83da9f8ce41d3d63$export$f680877a34711e37 = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useId();
};
$83da9f8ce41d3d63$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$83da9f8ce41d3d63$export$aaabe4eda9ed9969 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$83da9f8ce41d3d63$export$e5c5a5f917a5871c = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$83da9f8ce41d3d63$export$1538c33de8887b59 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useMemo(create, deps);
};
$83da9f8ce41d3d63$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$83da9f8ce41d3d63$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$83da9f8ce41d3d63$export$b8f5890fc79d6aca = function(initialValue) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useRef(initialValue);
};
$83da9f8ce41d3d63$export$60241385465d0a34 = function(initialState) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useState(initialState);
};
$83da9f8ce41d3d63$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$83da9f8ce41d3d63$export$7b286972b8d8ccbf = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useTransition();
};
$83da9f8ce41d3d63$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});


parcelRegister("jpRqs", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $e229cb5c8b2cd629$export$882461b6382ed46c; }, function (v) { return $e229cb5c8b2cd629$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e229cb5c8b2cd629$export$757ceba2d55c277e; }, function (v) { return $e229cb5c8b2cd629$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $e229cb5c8b2cd629$export$83d89fbfd8236492; }, function (v) { return $e229cb5c8b2cd629$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e229cb5c8b2cd629$export$882461b6382ed46c;
var $e229cb5c8b2cd629$export$757ceba2d55c277e;
var $e229cb5c8b2cd629$export$83d89fbfd8236492;

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $4LCdk = parcelRequire("4LCdk");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");
function $e229cb5c8b2cd629$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $e229cb5c8b2cd629$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $e229cb5c8b2cd629$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e229cb5c8b2cd629$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $e229cb5c8b2cd629$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e229cb5c8b2cd629$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e229cb5c8b2cd629$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $e229cb5c8b2cd629$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $e229cb5c8b2cd629$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $e229cb5c8b2cd629$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $e229cb5c8b2cd629$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $e229cb5c8b2cd629$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $e229cb5c8b2cd629$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $e229cb5c8b2cd629$var$getComponentNameFromType(type.type) || "Memo";
        case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $e229cb5c8b2cd629$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $e229cb5c8b2cd629$var$ReactSharedInternals = $bh6RR.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e229cb5c8b2cd629$var$assign = Object.assign, $e229cb5c8b2cd629$var$prefix, $e229cb5c8b2cd629$var$suffix;
function $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $e229cb5c8b2cd629$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $e229cb5c8b2cd629$var$prefix = match && match[1] || "";
        $e229cb5c8b2cd629$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $e229cb5c8b2cd629$var$prefix + name + $e229cb5c8b2cd629$var$suffix;
}
var $e229cb5c8b2cd629$var$reentry = !1;
function $e229cb5c8b2cd629$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $e229cb5c8b2cd629$var$reentry) return "";
    $e229cb5c8b2cd629$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $e229cb5c8b2cd629$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $e229cb5c8b2cd629$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $e229cb5c8b2cd629$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $e229cb5c8b2cd629$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $e229cb5c8b2cd629$var$assertIsMounted(fiber) {
    if ($e229cb5c8b2cd629$var$getNearestMountedFiber(fiber) !== fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
}
function $e229cb5c8b2cd629$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $e229cb5c8b2cd629$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $e229cb5c8b2cd629$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $e229cb5c8b2cd629$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $e229cb5c8b2cd629$var$isArrayImpl = Array.isArray, $e229cb5c8b2cd629$var$ReactDOMSharedInternals = $6afFj.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e229cb5c8b2cd629$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $e229cb5c8b2cd629$var$valueStack = [], $e229cb5c8b2cd629$var$index = -1;
function $e229cb5c8b2cd629$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $e229cb5c8b2cd629$var$pop(cursor) {
    0 > $e229cb5c8b2cd629$var$index || (cursor.current = $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index], $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index] = null, $e229cb5c8b2cd629$var$index--);
}
function $e229cb5c8b2cd629$var$push(cursor, value) {
    $e229cb5c8b2cd629$var$index++;
    $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index] = cursor.current;
    cursor.current = value;
}
var $e229cb5c8b2cd629$var$contextStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$contextFiberStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$rootInstanceStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$hostTransitionProviderCursor = $e229cb5c8b2cd629$var$createCursor(null);
function $e229cb5c8b2cd629$var$pushHostContainer(fiber, nextRootInstance) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$rootInstanceStackCursor, nextRootInstance);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextFiberStackCursor, fiber);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $e229cb5c8b2cd629$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $e229cb5c8b2cd629$var$getOwnHostContext(fiber), nextRootInstance = $e229cb5c8b2cd629$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, nextRootInstance);
}
function $e229cb5c8b2cd629$var$popHostContainer() {
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextFiberStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$rootInstanceStackCursor);
}
function $e229cb5c8b2cd629$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$hostTransitionProviderCursor, fiber);
    var context = $e229cb5c8b2cd629$var$contextStackCursor.current;
    var JSCompiler_inline_result = $e229cb5c8b2cd629$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextFiberStackCursor, fiber), $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, JSCompiler_inline_result));
}
function $e229cb5c8b2cd629$var$popHostContext(fiber) {
    $e229cb5c8b2cd629$var$contextFiberStackCursor.current === fiber && ($e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor), $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextFiberStackCursor));
    $e229cb5c8b2cd629$var$hostTransitionProviderCursor.current === fiber && ($e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$hostTransitionProviderCursor), $e229cb5c8b2cd629$var$HostTransitionContext._currentValue = $e229cb5c8b2cd629$var$sharedNotPendingObject);
}
var $e229cb5c8b2cd629$var$hasOwnProperty = Object.prototype.hasOwnProperty, $e229cb5c8b2cd629$var$scheduleCallback$3 = $4LCdk.unstable_scheduleCallback, $e229cb5c8b2cd629$var$cancelCallback$1 = $4LCdk.unstable_cancelCallback, $e229cb5c8b2cd629$var$shouldYield = $4LCdk.unstable_shouldYield, $e229cb5c8b2cd629$var$requestPaint = $4LCdk.unstable_requestPaint, $e229cb5c8b2cd629$var$now = $4LCdk.unstable_now, $e229cb5c8b2cd629$var$getCurrentPriorityLevel = $4LCdk.unstable_getCurrentPriorityLevel, $e229cb5c8b2cd629$var$ImmediatePriority = $4LCdk.unstable_ImmediatePriority, $e229cb5c8b2cd629$var$UserBlockingPriority = $4LCdk.unstable_UserBlockingPriority, $e229cb5c8b2cd629$var$NormalPriority$1 = $4LCdk.unstable_NormalPriority, $e229cb5c8b2cd629$var$LowPriority = $4LCdk.unstable_LowPriority, $e229cb5c8b2cd629$var$IdlePriority = $4LCdk.unstable_IdlePriority, $e229cb5c8b2cd629$var$log$1 = $4LCdk.log, $e229cb5c8b2cd629$var$unstable_setDisableYieldValue = $4LCdk.unstable_setDisableYieldValue, $e229cb5c8b2cd629$var$rendererID = null, $e229cb5c8b2cd629$var$injectedHook = null;
function $e229cb5c8b2cd629$var$onCommitRoot(root) {
    if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onCommitFiberRoot) try {
        $e229cb5c8b2cd629$var$injectedHook.onCommitFiberRoot($e229cb5c8b2cd629$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $e229cb5c8b2cd629$var$log$1 && $e229cb5c8b2cd629$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.setStrictMode) try {
        $e229cb5c8b2cd629$var$injectedHook.setStrictMode($e229cb5c8b2cd629$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $e229cb5c8b2cd629$var$clz32 = Math.clz32 ? Math.clz32 : $e229cb5c8b2cd629$var$clz32Fallback, $e229cb5c8b2cd629$var$log = Math.log, $e229cb5c8b2cd629$var$LN2 = Math.LN2;
function $e229cb5c8b2cd629$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($e229cb5c8b2cd629$var$log(x) / $e229cb5c8b2cd629$var$LN2 | 0) | 0;
}
var $e229cb5c8b2cd629$var$nextTransitionLane = 128, $e229cb5c8b2cd629$var$nextRetryLane = 4194304;
function $e229cb5c8b2cd629$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $e229cb5c8b2cd629$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $e229cb5c8b2cd629$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e229cb5c8b2cd629$var$claimNextTransitionLane() {
    var lane = $e229cb5c8b2cd629$var$nextTransitionLane;
    $e229cb5c8b2cd629$var$nextTransitionLane <<= 1;
    0 === ($e229cb5c8b2cd629$var$nextTransitionLane & 4194176) && ($e229cb5c8b2cd629$var$nextTransitionLane = 128);
    return lane;
}
function $e229cb5c8b2cd629$var$claimNextRetryLane() {
    var lane = $e229cb5c8b2cd629$var$nextRetryLane;
    $e229cb5c8b2cd629$var$nextRetryLane <<= 1;
    0 === ($e229cb5c8b2cd629$var$nextRetryLane & 62914560) && ($e229cb5c8b2cd629$var$nextRetryLane = 4194304);
    return lane;
}
function $e229cb5c8b2cd629$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $e229cb5c8b2cd629$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $e229cb5c8b2cd629$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $e229cb5c8b2cd629$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $e229cb5c8b2cd629$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $e229cb5c8b2cd629$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $e229cb5c8b2cd629$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $e229cb5c8b2cd629$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $e229cb5c8b2cd629$var$resolveUpdatePriority() {
    var updatePriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $e229cb5c8b2cd629$var$getEventPriority(updatePriority.type);
}
function $e229cb5c8b2cd629$var$runWithPriority(priority, fn) {
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        return $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $e229cb5c8b2cd629$var$randomKey = Math.random().toString(36).slice(2), $e229cb5c8b2cd629$var$internalInstanceKey = "__reactFiber$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalPropsKey = "__reactProps$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalContainerInstanceKey = "__reactContainer$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlersKey = "__reactEvents$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlerListenersKey = "__reactListeners$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlesSetKey = "__reactHandles$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalRootNodeResourcesKey = "__reactResources$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalHoistableMarker = "__reactMarker$" + $e229cb5c8b2cd629$var$randomKey;
function $e229cb5c8b2cd629$var$detachDeletedInstance(node) {
    delete node[$e229cb5c8b2cd629$var$internalInstanceKey];
    delete node[$e229cb5c8b2cd629$var$internalPropsKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlersKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlerListenersKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlesSetKey];
}
function $e229cb5c8b2cd629$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$e229cb5c8b2cd629$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$e229cb5c8b2cd629$var$internalContainerInstanceKey] || parentNode[$e229cb5c8b2cd629$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $e229cb5c8b2cd629$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$e229cb5c8b2cd629$var$internalInstanceKey]) return parentNode;
                targetNode = $e229cb5c8b2cd629$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getInstanceFromNode(node) {
    if (node = node[$e229cb5c8b2cd629$var$internalInstanceKey] || node[$e229cb5c8b2cd629$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(33));
}
function $e229cb5c8b2cd629$var$getResourcesFromRoot(root) {
    var resources = root[$e229cb5c8b2cd629$var$internalRootNodeResourcesKey];
    resources || (resources = root[$e229cb5c8b2cd629$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $e229cb5c8b2cd629$var$markNodeAsHoistable(node) {
    node[$e229cb5c8b2cd629$var$internalHoistableMarker] = !0;
}
var $e229cb5c8b2cd629$var$allNativeEvents = new Set(), $e229cb5c8b2cd629$var$registrationNameDependencies = {};
function $e229cb5c8b2cd629$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $e229cb5c8b2cd629$var$registerDirectEvent(registrationName, dependencies);
    $e229cb5c8b2cd629$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $e229cb5c8b2cd629$var$registerDirectEvent(registrationName, dependencies) {
    $e229cb5c8b2cd629$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$e229cb5c8b2cd629$var$allNativeEvents.add(dependencies[registrationName]);
}
var $e229cb5c8b2cd629$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e229cb5c8b2cd629$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $e229cb5c8b2cd629$var$illegalAttributeNameCache = {}, $e229cb5c8b2cd629$var$validatedAttributeNameCache = {};
function $e229cb5c8b2cd629$var$isAttributeNameSafe(attributeName) {
    if ($e229cb5c8b2cd629$var$hasOwnProperty.call($e229cb5c8b2cd629$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($e229cb5c8b2cd629$var$hasOwnProperty.call($e229cb5c8b2cd629$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($e229cb5c8b2cd629$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $e229cb5c8b2cd629$var$validatedAttributeNameCache[attributeName] = !0;
    $e229cb5c8b2cd629$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $e229cb5c8b2cd629$var$setValueForAttribute(node, name, value) {
    if ($e229cb5c8b2cd629$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $e229cb5c8b2cd629$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $e229cb5c8b2cd629$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $e229cb5c8b2cd629$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $e229cb5c8b2cd629$var$trackValueOnNode(node) {
    var valueField = $e229cb5c8b2cd629$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $e229cb5c8b2cd629$var$track(node) {
    node._valueTracker || (node._valueTracker = $e229cb5c8b2cd629$var$trackValueOnNode(node));
}
function $e229cb5c8b2cd629$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $e229cb5c8b2cd629$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $e229cb5c8b2cd629$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $e229cb5c8b2cd629$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $e229cb5c8b2cd629$var$getToStringValue(value);
        } else element.value !== "" + $e229cb5c8b2cd629$var$getToStringValue(value) && (element.value = "" + $e229cb5c8b2cd629$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $e229cb5c8b2cd629$var$setDefaultValue(element, type, $e229cb5c8b2cd629$var$getToStringValue(value)) : null != defaultValue ? $e229cb5c8b2cd629$var$setDefaultValue(element, type, $e229cb5c8b2cd629$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $e229cb5c8b2cd629$var$getToStringValue(name) : element.removeAttribute("name");
}
function $e229cb5c8b2cd629$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $e229cb5c8b2cd629$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $e229cb5c8b2cd629$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $e229cb5c8b2cd629$var$setDefaultValue(node, type, value) {
    "number" === type && $e229cb5c8b2cd629$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $e229cb5c8b2cd629$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $e229cb5c8b2cd629$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $e229cb5c8b2cd629$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $e229cb5c8b2cd629$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $e229cb5c8b2cd629$var$getToStringValue(defaultValue) : "";
}
function $e229cb5c8b2cd629$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(92));
            if ($e229cb5c8b2cd629$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $e229cb5c8b2cd629$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $e229cb5c8b2cd629$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $e229cb5c8b2cd629$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $e229cb5c8b2cd629$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $e229cb5c8b2cd629$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $e229cb5c8b2cd629$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $e229cb5c8b2cd629$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $e229cb5c8b2cd629$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $e229cb5c8b2cd629$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e229cb5c8b2cd629$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $e229cb5c8b2cd629$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $e229cb5c8b2cd629$var$sanitizeURL(url) {
    return $e229cb5c8b2cd629$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $e229cb5c8b2cd629$var$currentReplayingEvent = null;
function $e229cb5c8b2cd629$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $e229cb5c8b2cd629$var$restoreTarget = null, $e229cb5c8b2cd629$var$restoreQueue = null;
function $e229cb5c8b2cd629$var$restoreStateOfTarget(target) {
    var internalInstance = $e229cb5c8b2cd629$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$e229cb5c8b2cd629$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $e229cb5c8b2cd629$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$e229cb5c8b2cd629$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(90));
                            $e229cb5c8b2cd629$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $e229cb5c8b2cd629$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $e229cb5c8b2cd629$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $e229cb5c8b2cd629$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $e229cb5c8b2cd629$var$isInsideEventHandler = !1;
function $e229cb5c8b2cd629$var$batchedUpdates$1(fn, a, b) {
    if ($e229cb5c8b2cd629$var$isInsideEventHandler) return fn(a, b);
    $e229cb5c8b2cd629$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($e229cb5c8b2cd629$var$isInsideEventHandler = !1, null !== $e229cb5c8b2cd629$var$restoreTarget || null !== $e229cb5c8b2cd629$var$restoreQueue) {
            if ($e229cb5c8b2cd629$var$flushSyncWork$1(), $e229cb5c8b2cd629$var$restoreTarget && (a = $e229cb5c8b2cd629$var$restoreTarget, fn = $e229cb5c8b2cd629$var$restoreQueue, $e229cb5c8b2cd629$var$restoreQueue = $e229cb5c8b2cd629$var$restoreTarget = null, $e229cb5c8b2cd629$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$e229cb5c8b2cd629$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $e229cb5c8b2cd629$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$e229cb5c8b2cd629$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !1;
if ($e229cb5c8b2cd629$var$canUseDOM) try {
    var $e229cb5c8b2cd629$var$options = {};
    Object.defineProperty($e229cb5c8b2cd629$var$options, "passive", {
        get: function() {
            $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $e229cb5c8b2cd629$var$options, $e229cb5c8b2cd629$var$options);
    window.removeEventListener("test", $e229cb5c8b2cd629$var$options, $e229cb5c8b2cd629$var$options);
} catch (e) {
    $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !1;
}
var $e229cb5c8b2cd629$var$root = null, $e229cb5c8b2cd629$var$startText = null, $e229cb5c8b2cd629$var$fallbackText = null;
function $e229cb5c8b2cd629$var$getData() {
    if ($e229cb5c8b2cd629$var$fallbackText) return $e229cb5c8b2cd629$var$fallbackText;
    var start, startValue = $e229cb5c8b2cd629$var$startText, startLength = startValue.length, end, endValue = "value" in $e229cb5c8b2cd629$var$root ? $e229cb5c8b2cd629$var$root.value : $e229cb5c8b2cd629$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $e229cb5c8b2cd629$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $e229cb5c8b2cd629$var$functionThatReturnsTrue() {
    return !0;
}
function $e229cb5c8b2cd629$var$functionThatReturnsFalse() {
    return !1;
}
function $e229cb5c8b2cd629$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $e229cb5c8b2cd629$var$functionThatReturnsTrue : $e229cb5c8b2cd629$var$functionThatReturnsFalse;
        this.isPropagationStopped = $e229cb5c8b2cd629$var$functionThatReturnsFalse;
        return this;
    }
    $e229cb5c8b2cd629$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $e229cb5c8b2cd629$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $e229cb5c8b2cd629$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $e229cb5c8b2cd629$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $e229cb5c8b2cd629$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e229cb5c8b2cd629$var$SyntheticEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$EventInterface), $e229cb5c8b2cd629$var$UIEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    view: 0,
    detail: 0
}), $e229cb5c8b2cd629$var$SyntheticUIEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$UIEventInterface), $e229cb5c8b2cd629$var$lastMovementX, $e229cb5c8b2cd629$var$lastMovementY, $e229cb5c8b2cd629$var$lastMouseEvent, $e229cb5c8b2cd629$var$MouseEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $e229cb5c8b2cd629$var$lastMouseEvent && ($e229cb5c8b2cd629$var$lastMouseEvent && "mousemove" === event.type ? ($e229cb5c8b2cd629$var$lastMovementX = event.screenX - $e229cb5c8b2cd629$var$lastMouseEvent.screenX, $e229cb5c8b2cd629$var$lastMovementY = event.screenY - $e229cb5c8b2cd629$var$lastMouseEvent.screenY) : $e229cb5c8b2cd629$var$lastMovementY = $e229cb5c8b2cd629$var$lastMovementX = 0, $e229cb5c8b2cd629$var$lastMouseEvent = event);
        return $e229cb5c8b2cd629$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $e229cb5c8b2cd629$var$lastMovementY;
    }
}), $e229cb5c8b2cd629$var$SyntheticMouseEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$MouseEventInterface), $e229cb5c8b2cd629$var$DragEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    dataTransfer: 0
}), $e229cb5c8b2cd629$var$SyntheticDragEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$DragEventInterface), $e229cb5c8b2cd629$var$FocusEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    relatedTarget: 0
}), $e229cb5c8b2cd629$var$SyntheticFocusEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$FocusEventInterface), $e229cb5c8b2cd629$var$AnimationEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e229cb5c8b2cd629$var$SyntheticAnimationEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$AnimationEventInterface), $e229cb5c8b2cd629$var$ClipboardEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $e229cb5c8b2cd629$var$SyntheticClipboardEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$ClipboardEventInterface), $e229cb5c8b2cd629$var$CompositionEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    data: 0
}), $e229cb5c8b2cd629$var$SyntheticCompositionEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$CompositionEventInterface), $e229cb5c8b2cd629$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e229cb5c8b2cd629$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e229cb5c8b2cd629$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e229cb5c8b2cd629$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $e229cb5c8b2cd629$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $e229cb5c8b2cd629$var$getEventModifierState() {
    return $e229cb5c8b2cd629$var$modifierStateGetter;
}
var $e229cb5c8b2cd629$var$KeyboardEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $e229cb5c8b2cd629$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $e229cb5c8b2cd629$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $e229cb5c8b2cd629$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $e229cb5c8b2cd629$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $e229cb5c8b2cd629$var$SyntheticKeyboardEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$KeyboardEventInterface), $e229cb5c8b2cd629$var$PointerEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e229cb5c8b2cd629$var$SyntheticPointerEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$PointerEventInterface), $e229cb5c8b2cd629$var$TouchEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState
}), $e229cb5c8b2cd629$var$SyntheticTouchEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$TouchEventInterface), $e229cb5c8b2cd629$var$TransitionEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e229cb5c8b2cd629$var$SyntheticTransitionEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$TransitionEventInterface), $e229cb5c8b2cd629$var$WheelEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e229cb5c8b2cd629$var$SyntheticWheelEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$WheelEventInterface), $e229cb5c8b2cd629$var$ToggleEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $e229cb5c8b2cd629$var$SyntheticToggleEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$ToggleEventInterface), $e229cb5c8b2cd629$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $e229cb5c8b2cd629$var$canUseCompositionEvent = $e229cb5c8b2cd629$var$canUseDOM && "CompositionEvent" in window, $e229cb5c8b2cd629$var$documentMode = null;
$e229cb5c8b2cd629$var$canUseDOM && "documentMode" in document && ($e229cb5c8b2cd629$var$documentMode = document.documentMode);
var $e229cb5c8b2cd629$var$canUseTextInputEvent = $e229cb5c8b2cd629$var$canUseDOM && "TextEvent" in window && !$e229cb5c8b2cd629$var$documentMode, $e229cb5c8b2cd629$var$useFallbackCompositionData = $e229cb5c8b2cd629$var$canUseDOM && (!$e229cb5c8b2cd629$var$canUseCompositionEvent || $e229cb5c8b2cd629$var$documentMode && 8 < $e229cb5c8b2cd629$var$documentMode && 11 >= $e229cb5c8b2cd629$var$documentMode), $e229cb5c8b2cd629$var$SPACEBAR_CHAR = String.fromCharCode(32), $e229cb5c8b2cd629$var$hasSpaceKeypress = !1;
function $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $e229cb5c8b2cd629$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $e229cb5c8b2cd629$var$isComposing = !1;
function $e229cb5c8b2cd629$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $e229cb5c8b2cd629$var$hasSpaceKeypress = !0;
            return $e229cb5c8b2cd629$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $e229cb5c8b2cd629$var$SPACEBAR_CHAR && $e229cb5c8b2cd629$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $e229cb5c8b2cd629$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($e229cb5c8b2cd629$var$isComposing) return "compositionend" === domEventName || !$e229cb5c8b2cd629$var$canUseCompositionEvent && $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $e229cb5c8b2cd629$var$getData(), $e229cb5c8b2cd629$var$fallbackText = $e229cb5c8b2cd629$var$startText = $e229cb5c8b2cd629$var$root = null, $e229cb5c8b2cd629$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $e229cb5c8b2cd629$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $e229cb5c8b2cd629$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e229cb5c8b2cd629$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$e229cb5c8b2cd629$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $e229cb5c8b2cd629$var$restoreTarget ? $e229cb5c8b2cd629$var$restoreQueue ? $e229cb5c8b2cd629$var$restoreQueue.push(target) : $e229cb5c8b2cd629$var$restoreQueue = [
        target
    ] : $e229cb5c8b2cd629$var$restoreTarget = target;
    inst = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $e229cb5c8b2cd629$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $e229cb5c8b2cd629$var$activeElement$1 = null, $e229cb5c8b2cd629$var$activeElementInst$1 = null;
function $e229cb5c8b2cd629$var$runEventInBatch(dispatchQueue) {
    $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, 0);
}
function $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst) {
    var targetNode = $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst);
    if ($e229cb5c8b2cd629$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $e229cb5c8b2cd629$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $e229cb5c8b2cd629$var$isInputEventSupported = !1;
if ($e229cb5c8b2cd629$var$canUseDOM) {
    var $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$283;
    if ($e229cb5c8b2cd629$var$canUseDOM) {
        var $e229cb5c8b2cd629$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$e229cb5c8b2cd629$var$isSupported$jscomp$inline_418) {
            var $e229cb5c8b2cd629$var$element$jscomp$inline_419 = document.createElement("div");
            $e229cb5c8b2cd629$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $e229cb5c8b2cd629$var$isSupported$jscomp$inline_418 = "function" === typeof $e229cb5c8b2cd629$var$element$jscomp$inline_419.oninput;
        }
        $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$283 = $e229cb5c8b2cd629$var$isSupported$jscomp$inline_418;
    } else $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$283 = !1;
    $e229cb5c8b2cd629$var$isInputEventSupported = $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $e229cb5c8b2cd629$var$stopWatchingForValueChange() {
    $e229cb5c8b2cd629$var$activeElement$1 && ($e229cb5c8b2cd629$var$activeElement$1.detachEvent("onpropertychange", $e229cb5c8b2cd629$var$handlePropertyChange), $e229cb5c8b2cd629$var$activeElementInst$1 = $e229cb5c8b2cd629$var$activeElement$1 = null);
}
function $e229cb5c8b2cd629$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $e229cb5c8b2cd629$var$getInstIfValueChanged($e229cb5c8b2cd629$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, $e229cb5c8b2cd629$var$activeElementInst$1, nativeEvent, $e229cb5c8b2cd629$var$getEventTarget(nativeEvent));
        $e229cb5c8b2cd629$var$batchedUpdates$1($e229cb5c8b2cd629$var$runEventInBatch, dispatchQueue);
    }
}
function $e229cb5c8b2cd629$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($e229cb5c8b2cd629$var$stopWatchingForValueChange(), $e229cb5c8b2cd629$var$activeElement$1 = target, $e229cb5c8b2cd629$var$activeElementInst$1 = targetInst, $e229cb5c8b2cd629$var$activeElement$1.attachEvent("onpropertychange", $e229cb5c8b2cd629$var$handlePropertyChange)) : "focusout" === domEventName && $e229cb5c8b2cd629$var$stopWatchingForValueChange();
}
function $e229cb5c8b2cd629$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged($e229cb5c8b2cd629$var$activeElementInst$1);
}
function $e229cb5c8b2cd629$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst);
}
function $e229cb5c8b2cd629$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst);
}
function $e229cb5c8b2cd629$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e229cb5c8b2cd629$var$objectIs = "function" === typeof Object.is ? Object.is : $e229cb5c8b2cd629$var$is;
function $e229cb5c8b2cd629$var$shallowEqual(objA, objB) {
    if ($e229cb5c8b2cd629$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$e229cb5c8b2cd629$var$hasOwnProperty.call(objB, currentKey) || !$e229cb5c8b2cd629$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $e229cb5c8b2cd629$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $e229cb5c8b2cd629$var$getNodeForCharacterOffset(root, offset) {
    var node = $e229cb5c8b2cd629$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $e229cb5c8b2cd629$var$getLeafNode(node);
    }
}
function $e229cb5c8b2cd629$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $e229cb5c8b2cd629$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $e229cb5c8b2cd629$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $e229cb5c8b2cd629$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $e229cb5c8b2cd629$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $e229cb5c8b2cd629$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $e229cb5c8b2cd629$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $e229cb5c8b2cd629$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $e229cb5c8b2cd629$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $e229cb5c8b2cd629$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $e229cb5c8b2cd629$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $e229cb5c8b2cd629$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $e229cb5c8b2cd629$var$skipSelectionChangeEvent = $e229cb5c8b2cd629$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $e229cb5c8b2cd629$var$activeElement = null, $e229cb5c8b2cd629$var$activeElementInst = null, $e229cb5c8b2cd629$var$lastSelection = null, $e229cb5c8b2cd629$var$mouseDown = !1;
function $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $e229cb5c8b2cd629$var$mouseDown || null == $e229cb5c8b2cd629$var$activeElement || $e229cb5c8b2cd629$var$activeElement !== $e229cb5c8b2cd629$var$getActiveElement(doc) || (doc = $e229cb5c8b2cd629$var$activeElement, "selectionStart" in doc && $e229cb5c8b2cd629$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $e229cb5c8b2cd629$var$lastSelection && $e229cb5c8b2cd629$var$shallowEqual($e229cb5c8b2cd629$var$lastSelection, doc) || ($e229cb5c8b2cd629$var$lastSelection = doc, doc = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners($e229cb5c8b2cd629$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $e229cb5c8b2cd629$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $e229cb5c8b2cd629$var$activeElement)));
}
function $e229cb5c8b2cd629$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $e229cb5c8b2cd629$var$vendorPrefixes = {
    animationend: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionEnd")
}, $e229cb5c8b2cd629$var$prefixedEventNames = {}, $e229cb5c8b2cd629$var$style = {};
$e229cb5c8b2cd629$var$canUseDOM && ($e229cb5c8b2cd629$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $e229cb5c8b2cd629$var$vendorPrefixes.animationend.animation, delete $e229cb5c8b2cd629$var$vendorPrefixes.animationiteration.animation, delete $e229cb5c8b2cd629$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $e229cb5c8b2cd629$var$vendorPrefixes.transitionend.transition);
function $e229cb5c8b2cd629$var$getVendorPrefixedEventName(eventName) {
    if ($e229cb5c8b2cd629$var$prefixedEventNames[eventName]) return $e229cb5c8b2cd629$var$prefixedEventNames[eventName];
    if (!$e229cb5c8b2cd629$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $e229cb5c8b2cd629$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $e229cb5c8b2cd629$var$style) return $e229cb5c8b2cd629$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $e229cb5c8b2cd629$var$ANIMATION_END = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationend"), $e229cb5c8b2cd629$var$ANIMATION_ITERATION = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationiteration"), $e229cb5c8b2cd629$var$ANIMATION_START = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationstart"), $e229cb5c8b2cd629$var$TRANSITION_RUN = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionrun"), $e229cb5c8b2cd629$var$TRANSITION_START = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionstart"), $e229cb5c8b2cd629$var$TRANSITION_CANCEL = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitioncancel"), $e229cb5c8b2cd629$var$TRANSITION_END = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionend"), $e229cb5c8b2cd629$var$topLevelEventsToReactNames = new Map(), $e229cb5c8b2cd629$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $e229cb5c8b2cd629$var$registerSimpleEvent(domEventName, reactName) {
    $e229cb5c8b2cd629$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $e229cb5c8b2cd629$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $e229cb5c8b2cd629$var$concurrentQueues = [], $e229cb5c8b2cd629$var$concurrentQueuesIndex = 0, $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes = 0;
function $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $e229cb5c8b2cd629$var$concurrentQueuesIndex, i = $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes = $e229cb5c8b2cd629$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var queue = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var update = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var lane = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = fiber;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = queue;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = update;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = lane;
    $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, null, null, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $e229cb5c8b2cd629$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $e229cb5c8b2cd629$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $e229cb5c8b2cd629$var$nestedUpdateCount) throw $e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = null, Error($e229cb5c8b2cd629$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $e229cb5c8b2cd629$var$emptyContextObject = {}, $e229cb5c8b2cd629$var$CapturedStacks = new WeakMap();
function $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $e229cb5c8b2cd629$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(source)
        };
        $e229cb5c8b2cd629$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(source)
    };
}
var $e229cb5c8b2cd629$var$forkStack = [], $e229cb5c8b2cd629$var$forkStackIndex = 0, $e229cb5c8b2cd629$var$treeForkProvider = null, $e229cb5c8b2cd629$var$treeForkCount = 0, $e229cb5c8b2cd629$var$idStack = [], $e229cb5c8b2cd629$var$idStackIndex = 0, $e229cb5c8b2cd629$var$treeContextProvider = null, $e229cb5c8b2cd629$var$treeContextId = 1, $e229cb5c8b2cd629$var$treeContextOverflow = "";
function $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, totalChildren) {
    $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex++] = $e229cb5c8b2cd629$var$treeForkCount;
    $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex++] = $e229cb5c8b2cd629$var$treeForkProvider;
    $e229cb5c8b2cd629$var$treeForkProvider = workInProgress;
    $e229cb5c8b2cd629$var$treeForkCount = totalChildren;
}
function $e229cb5c8b2cd629$var$pushTreeId(workInProgress, totalChildren, index) {
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextId;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextOverflow;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextProvider;
    $e229cb5c8b2cd629$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $e229cb5c8b2cd629$var$treeContextId;
    workInProgress = $e229cb5c8b2cd629$var$treeContextOverflow;
    var baseLength = 32 - $e229cb5c8b2cd629$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $e229cb5c8b2cd629$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $e229cb5c8b2cd629$var$treeContextId = 1 << 32 - $e229cb5c8b2cd629$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $e229cb5c8b2cd629$var$treeContextOverflow = length + workInProgress;
    } else $e229cb5c8b2cd629$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $e229cb5c8b2cd629$var$treeContextOverflow = workInProgress;
}
function $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($e229cb5c8b2cd629$var$pushTreeFork(workInProgress, 1), $e229cb5c8b2cd629$var$pushTreeId(workInProgress, 1, 0));
}
function $e229cb5c8b2cd629$var$popTreeContext(workInProgress) {
    for(; workInProgress === $e229cb5c8b2cd629$var$treeForkProvider;)$e229cb5c8b2cd629$var$treeForkProvider = $e229cb5c8b2cd629$var$forkStack[--$e229cb5c8b2cd629$var$forkStackIndex], $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex] = null, $e229cb5c8b2cd629$var$treeForkCount = $e229cb5c8b2cd629$var$forkStack[--$e229cb5c8b2cd629$var$forkStackIndex], $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex] = null;
    for(; workInProgress === $e229cb5c8b2cd629$var$treeContextProvider;)$e229cb5c8b2cd629$var$treeContextProvider = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null, $e229cb5c8b2cd629$var$treeContextOverflow = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null, $e229cb5c8b2cd629$var$treeContextId = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null;
}
var $e229cb5c8b2cd629$var$hydrationParentFiber = null, $e229cb5c8b2cd629$var$nextHydratableInstance = null, $e229cb5c8b2cd629$var$isHydrating = !1, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, $e229cb5c8b2cd629$var$HydrationMismatchException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(519));
function $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber) {
    var error = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(418, ""));
    $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, fiber));
    throw $e229cb5c8b2cd629$var$HydrationMismatchException;
}
function $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$e229cb5c8b2cd629$var$internalInstanceKey] = fiber;
    instance[$e229cb5c8b2cd629$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("cancel", instance);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $e229cb5c8b2cd629$var$mediaEventTypes.length; type++)$e229cb5c8b2cd629$var$listenToNonDelegatedEvent($e229cb5c8b2cd629$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", instance);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance);
            $e229cb5c8b2cd629$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $e229cb5c8b2cd629$var$track(instance);
            break;
        case "select":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance), $e229cb5c8b2cd629$var$initTextarea(instance, props.value, props.defaultValue, props.children), $e229cb5c8b2cd629$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $e229cb5c8b2cd629$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", instance), $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $e229cb5c8b2cd629$var$noop$1), instance = !0) : instance = !1;
    instance || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber);
}
function $e229cb5c8b2cd629$var$popToNextHostParent(fiber) {
    for($e229cb5c8b2cd629$var$hydrationParentFiber = fiber.return; $e229cb5c8b2cd629$var$hydrationParentFiber;)switch($e229cb5c8b2cd629$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $e229cb5c8b2cd629$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $e229cb5c8b2cd629$var$rootOrSingletonContext = !1;
            return;
        default:
            $e229cb5c8b2cd629$var$hydrationParentFiber = $e229cb5c8b2cd629$var$hydrationParentFiber.return;
    }
}
function $e229cb5c8b2cd629$var$popHydrationState(fiber) {
    if (fiber !== $e229cb5c8b2cd629$var$hydrationParentFiber) return !1;
    if (!$e229cb5c8b2cd629$var$isHydrating) return $e229cb5c8b2cd629$var$popToNextHostParent(fiber), $e229cb5c8b2cd629$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $e229cb5c8b2cd629$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $e229cb5c8b2cd629$var$nextHydratableInstance && $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber);
    $e229cb5c8b2cd629$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $e229cb5c8b2cd629$var$nextHydratableInstance = null;
        }
    } else $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$hydrationParentFiber ? $e229cb5c8b2cd629$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $e229cb5c8b2cd629$var$resetHydrationState() {
    $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$hydrationParentFiber = null;
    $e229cb5c8b2cd629$var$isHydrating = !1;
}
function $e229cb5c8b2cd629$var$queueHydrationError(error) {
    null === $e229cb5c8b2cd629$var$hydrationErrors ? $e229cb5c8b2cd629$var$hydrationErrors = [
        error
    ] : $e229cb5c8b2cd629$var$hydrationErrors.push(error);
}
var $e229cb5c8b2cd629$var$SuspenseException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(460)), $e229cb5c8b2cd629$var$SuspenseyCommitException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(474)), $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $e229cb5c8b2cd629$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $e229cb5c8b2cd629$var$noop$3() {}
function $e229cb5c8b2cd629$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($e229cb5c8b2cd629$var$noop$3, $e229cb5c8b2cd629$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $e229cb5c8b2cd629$var$SuspenseException) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($e229cb5c8b2cd629$var$noop$3, $e229cb5c8b2cd629$var$noop$3);
            else {
                thenableState = $e229cb5c8b2cd629$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $e229cb5c8b2cd629$var$SuspenseException) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $e229cb5c8b2cd629$var$suspendedThenable = thenable;
            throw $e229cb5c8b2cd629$var$SuspenseException;
    }
}
var $e229cb5c8b2cd629$var$suspendedThenable = null;
function $e229cb5c8b2cd629$var$getSuspendedThenable() {
    if (null === $e229cb5c8b2cd629$var$suspendedThenable) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(459));
    var thenable = $e229cb5c8b2cd629$var$suspendedThenable;
    $e229cb5c8b2cd629$var$suspendedThenable = null;
    return thenable;
}
var $e229cb5c8b2cd629$var$thenableState$1 = null, $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
function $e229cb5c8b2cd629$var$unwrapThenable(thenable) {
    var index = $e229cb5c8b2cd629$var$thenableIndexCounter$1;
    $e229cb5c8b2cd629$var$thenableIndexCounter$1 += 1;
    null === $e229cb5c8b2cd629$var$thenableState$1 && ($e229cb5c8b2cd629$var$thenableState$1 = []);
    return $e229cb5c8b2cd629$var$trackUsedThenable($e229cb5c8b2cd629$var$thenableState$1, thenable, index);
}
function $e229cb5c8b2cd629$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $e229cb5c8b2cd629$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $e229cb5c8b2cd629$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $e229cb5c8b2cd629$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $e229cb5c8b2cd629$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $e229cb5c8b2cd629$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $e229cb5c8b2cd629$var$REACT_LAZY_TYPE && $e229cb5c8b2cd629$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $e229cb5c8b2cd629$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $e229cb5c8b2cd629$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $e229cb5c8b2cd629$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $e229cb5c8b2cd629$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $e229cb5c8b2cd629$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return lanes = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e229cb5c8b2cd629$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return newChild = $e229cb5c8b2cd629$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $e229cb5c8b2cd629$var$REACT_LAZY_TYPE && $e229cb5c8b2cd629$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $e229cb5c8b2cd629$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE ? (lanes = $e229cb5c8b2cd629$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e229cb5c8b2cd629$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $e229cb5c8b2cd629$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($e229cb5c8b2cd629$var$getIteratorFn(newChild)) {
                key = $e229cb5c8b2cd629$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $e229cb5c8b2cd629$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $e229cb5c8b2cd629$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $e229cb5c8b2cd629$var$SuspenseException) throw x;
            var fiber = $e229cb5c8b2cd629$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $e229cb5c8b2cd629$var$reconcileChildFibers = $e229cb5c8b2cd629$var$createChildReconciler(!0), $e229cb5c8b2cd629$var$mountChildFibers = $e229cb5c8b2cd629$var$createChildReconciler(!1), $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor = $e229cb5c8b2cd629$var$createCursor(0);
function $e229cb5c8b2cd629$var$pushHiddenContext(fiber, context) {
    fiber = $e229cb5c8b2cd629$var$entangledRenderLanes;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor, fiber);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor, context);
    $e229cb5c8b2cd629$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $e229cb5c8b2cd629$var$reuseHiddenContextOnStack() {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor, $e229cb5c8b2cd629$var$entangledRenderLanes);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor, $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current);
}
function $e229cb5c8b2cd629$var$popHiddenContext() {
    $e229cb5c8b2cd629$var$entangledRenderLanes = $e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor.current;
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor);
}
var $e229cb5c8b2cd629$var$suspenseHandlerStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$shellBoundary = null;
function $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current & 1);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, handler);
    null === $e229cb5c8b2cd629$var$shellBoundary && (null === current || null !== $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current ? $e229cb5c8b2cd629$var$shellBoundary = handler : null !== current.memoizedState && ($e229cb5c8b2cd629$var$shellBoundary = handler));
}
function $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current), $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, fiber), null === $e229cb5c8b2cd629$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($e229cb5c8b2cd629$var$shellBoundary = fiber);
        }
    } else $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(fiber);
}
function $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack() {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current);
}
function $e229cb5c8b2cd629$var$popSuspenseHandler(fiber) {
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseHandlerStackCursor);
    $e229cb5c8b2cd629$var$shellBoundary === fiber && ($e229cb5c8b2cd629$var$shellBoundary = null);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
}
var $e229cb5c8b2cd629$var$suspenseStackCursor = $e229cb5c8b2cd629$var$createCursor(0);
function $e229cb5c8b2cd629$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $e229cb5c8b2cd629$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $e229cb5c8b2cd629$var$scheduleCallback$2 = $4LCdk.unstable_scheduleCallback, $e229cb5c8b2cd629$var$NormalPriority = $4LCdk.unstable_NormalPriority, $e229cb5c8b2cd629$var$CacheContext = {
    $$typeof: $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $e229cb5c8b2cd629$var$createCache() {
    return {
        controller: new $e229cb5c8b2cd629$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $e229cb5c8b2cd629$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $e229cb5c8b2cd629$var$scheduleCallback$2($e229cb5c8b2cd629$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $e229cb5c8b2cd629$var$currentEntangledListeners = null, $e229cb5c8b2cd629$var$currentEntangledPendingCount = 0, $e229cb5c8b2cd629$var$currentEntangledLane = 0, $e229cb5c8b2cd629$var$currentEntangledActionThenable = null;
function $e229cb5c8b2cd629$var$entangleAsyncAction(transition, thenable) {
    if (null === $e229cb5c8b2cd629$var$currentEntangledListeners) {
        var entangledListeners = $e229cb5c8b2cd629$var$currentEntangledListeners = [];
        $e229cb5c8b2cd629$var$currentEntangledPendingCount = 0;
        $e229cb5c8b2cd629$var$currentEntangledLane = $e229cb5c8b2cd629$var$requestTransitionLane();
        $e229cb5c8b2cd629$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $e229cb5c8b2cd629$var$currentEntangledPendingCount++;
    thenable.then($e229cb5c8b2cd629$var$pingEngtangledActionScope, $e229cb5c8b2cd629$var$pingEngtangledActionScope);
    return thenable;
}
function $e229cb5c8b2cd629$var$pingEngtangledActionScope() {
    if (0 === --$e229cb5c8b2cd629$var$currentEntangledPendingCount && null !== $e229cb5c8b2cd629$var$currentEntangledListeners) {
        null !== $e229cb5c8b2cd629$var$currentEntangledActionThenable && ($e229cb5c8b2cd629$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $e229cb5c8b2cd629$var$currentEntangledListeners;
        $e229cb5c8b2cd629$var$currentEntangledListeners = null;
        $e229cb5c8b2cd629$var$currentEntangledLane = 0;
        $e229cb5c8b2cd629$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $e229cb5c8b2cd629$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $e229cb5c8b2cd629$var$prevOnStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
$e229cb5c8b2cd629$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $e229cb5c8b2cd629$var$entangleAsyncAction(transition, returnValue);
    null !== $e229cb5c8b2cd629$var$prevOnStartTransitionFinish && $e229cb5c8b2cd629$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $e229cb5c8b2cd629$var$resumedCache = $e229cb5c8b2cd629$var$createCursor(null);
function $e229cb5c8b2cd629$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $e229cb5c8b2cd629$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $e229cb5c8b2cd629$var$workInProgressRoot.pooledCache;
}
function $e229cb5c8b2cd629$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$resumedCache, $e229cb5c8b2cd629$var$resumedCache.current) : $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$resumedCache, prevCachePool.pool);
}
function $e229cb5c8b2cd629$var$getSuspendedCache() {
    var cacheFromPool = $e229cb5c8b2cd629$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $e229cb5c8b2cd629$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $e229cb5c8b2cd629$var$renderLanes = 0, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null, $e229cb5c8b2cd629$var$currentHook = null, $e229cb5c8b2cd629$var$workInProgressHook = null, $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1, $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $e229cb5c8b2cd629$var$localIdCounter = 0, $e229cb5c8b2cd629$var$thenableIndexCounter = 0, $e229cb5c8b2cd629$var$thenableState = null, $e229cb5c8b2cd629$var$globalClientIdCounter = 0;
function $e229cb5c8b2cd629$var$throwInvalidHookError() {
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(321));
}
function $e229cb5c8b2cd629$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$e229cb5c8b2cd629$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $e229cb5c8b2cd629$var$renderLanes = nextRenderLanes;
    $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $e229cb5c8b2cd629$var$HooksDispatcherOnMount : $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate;
    $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $e229cb5c8b2cd629$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $e229cb5c8b2cd629$var$finishRenderingHooks(current) {
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $e229cb5c8b2cd629$var$currentHook && null !== $e229cb5c8b2cd629$var$currentHook.next;
    $e229cb5c8b2cd629$var$renderLanes = 0;
    $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1;
    $e229cb5c8b2cd629$var$thenableIndexCounter = 0;
    $e229cb5c8b2cd629$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(300));
    null === current || $e229cb5c8b2cd629$var$didReceiveUpdate || (current = current.dependencies, null !== current && $e229cb5c8b2cd629$var$checkIfContextChanged(current) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0));
}
function $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass && ($e229cb5c8b2cd629$var$thenableState = null);
        $e229cb5c8b2cd629$var$thenableIndexCounter = 0;
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $e229cb5c8b2cd629$var$TransitionAwareHostComponent() {
    var dispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $e229cb5c8b2cd629$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $e229cb5c8b2cd629$var$currentHook ? $e229cb5c8b2cd629$var$currentHook.memoizedState : null) !== dispatcher && ($e229cb5c8b2cd629$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $e229cb5c8b2cd629$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $e229cb5c8b2cd629$var$localIdCounter;
    $e229cb5c8b2cd629$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $e229cb5c8b2cd629$var$resetHooksOnUnwind(workInProgress) {
    if ($e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1;
    }
    $e229cb5c8b2cd629$var$renderLanes = 0;
    $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $e229cb5c8b2cd629$var$thenableIndexCounter = $e229cb5c8b2cd629$var$localIdCounter = 0;
    $e229cb5c8b2cd629$var$thenableState = null;
}
function $e229cb5c8b2cd629$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.memoizedState = $e229cb5c8b2cd629$var$workInProgressHook = hook : $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$workInProgressHook.next = hook;
    return $e229cb5c8b2cd629$var$workInProgressHook;
}
function $e229cb5c8b2cd629$var$updateWorkInProgressHook() {
    if (null === $e229cb5c8b2cd629$var$currentHook) {
        var nextCurrentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $e229cb5c8b2cd629$var$currentHook.next;
    var nextWorkInProgressHook = null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.memoizedState : $e229cb5c8b2cd629$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $e229cb5c8b2cd629$var$workInProgressHook = nextWorkInProgressHook, $e229cb5c8b2cd629$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(467));
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(310));
        }
        $e229cb5c8b2cd629$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $e229cb5c8b2cd629$var$currentHook.memoizedState,
            baseState: $e229cb5c8b2cd629$var$currentHook.baseState,
            baseQueue: $e229cb5c8b2cd629$var$currentHook.baseQueue,
            queue: $e229cb5c8b2cd629$var$currentHook.queue,
            next: null
        };
        null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.memoizedState = $e229cb5c8b2cd629$var$workInProgressHook = nextCurrentHook : $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$workInProgressHook.next = nextCurrentHook;
    }
    return $e229cb5c8b2cd629$var$workInProgressHook;
}
var $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue;
$e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $e229cb5c8b2cd629$var$useThenable(thenable) {
    var index = $e229cb5c8b2cd629$var$thenableIndexCounter;
    $e229cb5c8b2cd629$var$thenableIndexCounter += 1;
    null === $e229cb5c8b2cd629$var$thenableState && ($e229cb5c8b2cd629$var$thenableState = []);
    thenable = $e229cb5c8b2cd629$var$trackUsedThenable($e229cb5c8b2cd629$var$thenableState, thenable, index);
    index = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1;
    null === (null === $e229cb5c8b2cd629$var$workInProgressHook ? index.memoizedState : $e229cb5c8b2cd629$var$workInProgressHook.next) && (index = index.alternate, $e229cb5c8b2cd629$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $e229cb5c8b2cd629$var$HooksDispatcherOnMount : $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $e229cb5c8b2cd629$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $e229cb5c8b2cd629$var$useThenable(usable);
        if (usable.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return $e229cb5c8b2cd629$var$readContext(usable);
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(438, String(usable)));
}
function $e229cb5c8b2cd629$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $e229cb5c8b2cd629$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $e229cb5c8b2cd629$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $e229cb5c8b2cd629$var$updateReducer(reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    return $e229cb5c8b2cd629$var$updateReducerImpl(hook, $e229cb5c8b2cd629$var$currentHook, reducer);
}
function $e229cb5c8b2cd629$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($e229cb5c8b2cd629$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $e229cb5c8b2cd629$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($e229cb5c8b2cd629$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $e229cb5c8b2cd629$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.lanes |= revertLane, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.lanes |= updateLane, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$e229cb5c8b2cd629$var$objectIs(pendingQueue, hook.memoizedState) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $e229cb5c8b2cd629$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $e229cb5c8b2cd629$var$rerenderReducer(reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $e229cb5c8b2cd629$var$objectIs(newState, hook.memoizedState) || ($e229cb5c8b2cd629$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $e229cb5c8b2cd629$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1, hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $e229cb5c8b2cd629$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$e229cb5c8b2cd629$var$objectIs(($e229cb5c8b2cd629$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $e229cb5c8b2cd629$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $e229cb5c8b2cd629$var$updateEffect($e229cb5c8b2cd629$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $e229cb5c8b2cd629$var$workInProgressHook && $e229cb5c8b2cd629$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $e229cb5c8b2cd629$var$pushEffect(9, $e229cb5c8b2cd629$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $e229cb5c8b2cd629$var$workInProgressRoot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 60) || $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $e229cb5c8b2cd629$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) && $e229cb5c8b2cd629$var$forceStoreRerender(fiber);
}
function $e229cb5c8b2cd629$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) && $e229cb5c8b2cd629$var$forceStoreRerender(fiber);
    });
}
function $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$e229cb5c8b2cd629$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $e229cb5c8b2cd629$var$forceStoreRerender(fiber) {
    var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $e229cb5c8b2cd629$var$mountStateImpl(initialState) {
    var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $e229cb5c8b2cd629$var$updateReducerImpl(hook, $e229cb5c8b2cd629$var$currentHook, "function" === typeof reducer ? reducer : $e229cb5c8b2cd629$var$basicStateReducer);
}
function $e229cb5c8b2cd629$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $e229cb5c8b2cd629$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, currentTransition = {};
        $e229cb5c8b2cd629$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error);
        } finally{
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error$60);
    }
}
function $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error);
    }) : $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, node, returnValue);
}
function $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $e229cb5c8b2cd629$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, nextState)));
}
function $e229cb5c8b2cd629$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $e229cb5c8b2cd629$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $e229cb5c8b2cd629$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $e229cb5c8b2cd629$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $e229cb5c8b2cd629$var$mountActionState(action, initialStateProp) {
    if ($e229cb5c8b2cd629$var$isHydrating) {
        var ssrFormState = $e229cb5c8b2cd629$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1;
                if ($e229cb5c8b2cd629$var$isHydrating) {
                    if ($e229cb5c8b2cd629$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $e229cb5c8b2cd629$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $e229cb5c8b2cd629$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $e229cb5c8b2cd629$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $e229cb5c8b2cd629$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e229cb5c8b2cd629$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $e229cb5c8b2cd629$var$dispatchSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $e229cb5c8b2cd629$var$mountStateImpl(!1);
    inRootOrSingleton = $e229cb5c8b2cd629$var$dispatchOptimisticSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $e229cb5c8b2cd629$var$dispatchActionState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $e229cb5c8b2cd629$var$updateActionState(action) {
    var stateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    return $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, $e229cb5c8b2cd629$var$currentHook, action);
}
function $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $e229cb5c8b2cd629$var$updateReducerImpl(stateHook, currentStateHook, $e229cb5c8b2cd629$var$actionStateReducer)[0];
    stateHook = $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $e229cb5c8b2cd629$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($e229cb5c8b2cd629$var$currentlyRenderingFiber$1.flags |= 2048, $e229cb5c8b2cd629$var$pushEffect(9, $e229cb5c8b2cd629$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $e229cb5c8b2cd629$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $e229cb5c8b2cd629$var$rerenderActionState(action) {
    var stateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), currentStateHook = $e229cb5c8b2cd629$var$currentHook;
    if (null !== currentStateHook) return $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $e229cb5c8b2cd629$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $e229cb5c8b2cd629$var$updateRef() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $e229cb5c8b2cd629$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $e229cb5c8b2cd629$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $e229cb5c8b2cd629$var$currentHook && null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, $e229cb5c8b2cd629$var$currentHook.memoizedState.deps) ? hook.memoizedState = $e229cb5c8b2cd629$var$pushEffect(hookFlags, create, inst, deps) : ($e229cb5c8b2cd629$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $e229cb5c8b2cd629$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $e229cb5c8b2cd629$var$mountEffect(create, deps) {
    $e229cb5c8b2cd629$var$mountEffectImpl(8390656, 8, create, deps);
}
function $e229cb5c8b2cd629$var$updateEffect(create, deps) {
    $e229cb5c8b2cd629$var$updateEffectImpl(2048, 8, create, deps);
}
function $e229cb5c8b2cd629$var$updateInsertionEffect(create, deps) {
    return $e229cb5c8b2cd629$var$updateEffectImpl(4, 2, create, deps);
}
function $e229cb5c8b2cd629$var$updateLayoutEffect(create, deps) {
    return $e229cb5c8b2cd629$var$updateEffectImpl(4, 4, create, deps);
}
function $e229cb5c8b2cd629$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $e229cb5c8b2cd629$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $e229cb5c8b2cd629$var$updateEffectImpl(4, 4, $e229cb5c8b2cd629$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $e229cb5c8b2cd629$var$mountDebugValue() {}
function $e229cb5c8b2cd629$var$updateCallback(callback, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $e229cb5c8b2cd629$var$updateMemo(nextCreate, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $e229cb5c8b2cd629$var$requestDeferredLane();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.lanes |= hook;
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($e229cb5c8b2cd629$var$objectIs(value, prevValue)) return value;
    if (null !== $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current) return hook = $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue), $e229cb5c8b2cd629$var$objectIs(hook, prevValue) || ($e229cb5c8b2cd629$var$didReceiveUpdate = !0), hook;
    if (0 === ($e229cb5c8b2cd629$var$renderLanes & 42)) return $e229cb5c8b2cd629$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $e229cb5c8b2cd629$var$requestDeferredLane();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber$1.lanes |= hook;
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $e229cb5c8b2cd629$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, currentTransition = {};
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = currentTransition;
    $e229cb5c8b2cd629$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $e229cb5c8b2cd629$var$chainThenableValue(returnValue, finishedState);
            $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $e229cb5c8b2cd629$var$requestUpdateLane(fiber));
        } else $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, finishedState, $e229cb5c8b2cd629$var$requestUpdateLane(fiber));
    } catch (error) {
        $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $e229cb5c8b2cd629$var$requestUpdateLane());
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$noop$2() {}
function $e229cb5c8b2cd629$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(476));
    var queue = $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber).queue;
    $e229cb5c8b2cd629$var$startTransition(formFiber, queue, pendingState, $e229cb5c8b2cd629$var$sharedNotPendingObject, null === action ? $e229cb5c8b2cd629$var$noop$2 : function() {
        $e229cb5c8b2cd629$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $e229cb5c8b2cd629$var$sharedNotPendingObject,
        baseState: $e229cb5c8b2cd629$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
            lastRenderedState: $e229cb5c8b2cd629$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $e229cb5c8b2cd629$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $e229cb5c8b2cd629$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $e229cb5c8b2cd629$var$requestUpdateLane());
}
function $e229cb5c8b2cd629$var$useHostTransitionStatus() {
    return $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$HostTransitionContext);
}
function $e229cb5c8b2cd629$var$updateId() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$updateRefresh() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
                fiber = $e229cb5c8b2cd629$var$createUpdate(lane);
                var root$63 = $e229cb5c8b2cd629$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root$63, provider, lane), $e229cb5c8b2cd629$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $e229cb5c8b2cd629$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $e229cb5c8b2cd629$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber) ? $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, action) : (action = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(action, fiber, lane), $e229cb5c8b2cd629$var$entangleTransitionUpdate(action, queue, lane)));
}
function $e229cb5c8b2cd629$var$dispatchSetState(fiber, queue, action) {
    var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($e229cb5c8b2cd629$var$objectIs(eagerState, currentState)) return $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, 0), null === $e229cb5c8b2cd629$var$workInProgressRoot && $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(action, fiber, lane), $e229cb5c8b2cd629$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $e229cb5c8b2cd629$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $e229cb5c8b2cd629$var$currentlyRenderingFiber$1;
}
function $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, update) {
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $e229cb5c8b2cd629$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $e229cb5c8b2cd629$var$markRootEntangled(root, lane);
    }
}
var $e229cb5c8b2cd629$var$ContextOnlyDispatcher = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useContext: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useImperativeHandle: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useLayoutEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useInsertionEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useMemo: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useReducer: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useRef: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useDebugValue: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useDeferredValue: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useTransition: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useSyncExternalStore: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useId: $e229cb5c8b2cd629$var$throwInvalidHookError
};
$e229cb5c8b2cd629$var$ContextOnlyDispatcher.useCacheRefresh = $e229cb5c8b2cd629$var$throwInvalidHookError;
$e229cb5c8b2cd629$var$ContextOnlyDispatcher.useMemoCache = $e229cb5c8b2cd629$var$throwInvalidHookError;
$e229cb5c8b2cd629$var$ContextOnlyDispatcher.useHostTransitionStatus = $e229cb5c8b2cd629$var$throwInvalidHookError;
$e229cb5c8b2cd629$var$ContextOnlyDispatcher.useFormState = $e229cb5c8b2cd629$var$throwInvalidHookError;
$e229cb5c8b2cd629$var$ContextOnlyDispatcher.useActionState = $e229cb5c8b2cd629$var$throwInvalidHookError;
$e229cb5c8b2cd629$var$ContextOnlyDispatcher.useOptimistic = $e229cb5c8b2cd629$var$throwInvalidHookError;
var $e229cb5c8b2cd629$var$HooksDispatcherOnMount = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: function(callback, deps) {
        $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $e229cb5c8b2cd629$var$mountEffectImpl(4194308, 4, $e229cb5c8b2cd629$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $e229cb5c8b2cd629$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $e229cb5c8b2cd629$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $e229cb5c8b2cd629$var$dispatchReducerAction.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $e229cb5c8b2cd629$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $e229cb5c8b2cd629$var$dispatchSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        return $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $e229cb5c8b2cd629$var$mountStateImpl(!1);
        stateHook = $e229cb5c8b2cd629$var$startTransition.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1, hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        if ($e229cb5c8b2cd629$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $e229cb5c8b2cd629$var$workInProgressRoot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(349));
            0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 60) || $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $e229cb5c8b2cd629$var$mountEffect($e229cb5c8b2cd629$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $e229cb5c8b2cd629$var$pushEffect(9, $e229cb5c8b2cd629$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook(), identifierPrefix = $e229cb5c8b2cd629$var$workInProgressRoot.identifierPrefix;
        if ($e229cb5c8b2cd629$var$isHydrating) {
            var JSCompiler_inline_result = $e229cb5c8b2cd629$var$treeContextOverflow;
            var idWithLeadingBit = $e229cb5c8b2cd629$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $e229cb5c8b2cd629$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $e229cb5c8b2cd629$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $e229cb5c8b2cd629$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = $e229cb5c8b2cd629$var$refreshCache.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1);
    }
};
$e229cb5c8b2cd629$var$HooksDispatcherOnMount.useMemoCache = $e229cb5c8b2cd629$var$useMemoCache;
$e229cb5c8b2cd629$var$HooksDispatcherOnMount.useHostTransitionStatus = $e229cb5c8b2cd629$var$useHostTransitionStatus;
$e229cb5c8b2cd629$var$HooksDispatcherOnMount.useFormState = $e229cb5c8b2cd629$var$mountActionState;
$e229cb5c8b2cd629$var$HooksDispatcherOnMount.useActionState = $e229cb5c8b2cd629$var$mountActionState;
$e229cb5c8b2cd629$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $e229cb5c8b2cd629$var$dispatchOptimisticSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$updateCallback,
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$updateEffect,
    useImperativeHandle: $e229cb5c8b2cd629$var$updateImperativeHandle,
    useInsertionEffect: $e229cb5c8b2cd629$var$updateInsertionEffect,
    useLayoutEffect: $e229cb5c8b2cd629$var$updateLayoutEffect,
    useMemo: $e229cb5c8b2cd629$var$updateMemo,
    useReducer: $e229cb5c8b2cd629$var$updateReducer,
    useRef: $e229cb5c8b2cd629$var$updateRef,
    useState: function() {
        return $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer);
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, $e229cb5c8b2cd629$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer)[0], start = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e229cb5c8b2cd629$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e229cb5c8b2cd629$var$updateSyncExternalStore,
    useId: $e229cb5c8b2cd629$var$updateId
};
$e229cb5c8b2cd629$var$HooksDispatcherOnUpdate.useCacheRefresh = $e229cb5c8b2cd629$var$updateRefresh;
$e229cb5c8b2cd629$var$HooksDispatcherOnUpdate.useMemoCache = $e229cb5c8b2cd629$var$useMemoCache;
$e229cb5c8b2cd629$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $e229cb5c8b2cd629$var$useHostTransitionStatus;
$e229cb5c8b2cd629$var$HooksDispatcherOnUpdate.useFormState = $e229cb5c8b2cd629$var$updateActionState;
$e229cb5c8b2cd629$var$HooksDispatcherOnUpdate.useActionState = $e229cb5c8b2cd629$var$updateActionState;
$e229cb5c8b2cd629$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    return $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, $e229cb5c8b2cd629$var$currentHook, passthrough, reducer);
};
var $e229cb5c8b2cd629$var$HooksDispatcherOnRerender = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$updateCallback,
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$updateEffect,
    useImperativeHandle: $e229cb5c8b2cd629$var$updateImperativeHandle,
    useInsertionEffect: $e229cb5c8b2cd629$var$updateInsertionEffect,
    useLayoutEffect: $e229cb5c8b2cd629$var$updateLayoutEffect,
    useMemo: $e229cb5c8b2cd629$var$updateMemo,
    useReducer: $e229cb5c8b2cd629$var$rerenderReducer,
    useRef: $e229cb5c8b2cd629$var$updateRef,
    useState: function() {
        return $e229cb5c8b2cd629$var$rerenderReducer($e229cb5c8b2cd629$var$basicStateReducer);
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return null === $e229cb5c8b2cd629$var$currentHook ? $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue) : $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, $e229cb5c8b2cd629$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e229cb5c8b2cd629$var$rerenderReducer($e229cb5c8b2cd629$var$basicStateReducer)[0], start = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e229cb5c8b2cd629$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e229cb5c8b2cd629$var$updateSyncExternalStore,
    useId: $e229cb5c8b2cd629$var$updateId
};
$e229cb5c8b2cd629$var$HooksDispatcherOnRerender.useCacheRefresh = $e229cb5c8b2cd629$var$updateRefresh;
$e229cb5c8b2cd629$var$HooksDispatcherOnRerender.useMemoCache = $e229cb5c8b2cd629$var$useMemoCache;
$e229cb5c8b2cd629$var$HooksDispatcherOnRerender.useHostTransitionStatus = $e229cb5c8b2cd629$var$useHostTransitionStatus;
$e229cb5c8b2cd629$var$HooksDispatcherOnRerender.useFormState = $e229cb5c8b2cd629$var$rerenderActionState;
$e229cb5c8b2cd629$var$HooksDispatcherOnRerender.useActionState = $e229cb5c8b2cd629$var$rerenderActionState;
$e229cb5c8b2cd629$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    if (null !== $e229cb5c8b2cd629$var$currentHook) return $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, $e229cb5c8b2cd629$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $e229cb5c8b2cd629$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $e229cb5c8b2cd629$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $e229cb5c8b2cd629$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(payload, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(payload, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(callback, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(callback, inst, lane));
    }
};
function $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$e229cb5c8b2cd629$var$shallowEqual(oldProps, newProps) || !$e229cb5c8b2cd629$var$shallowEqual(oldState, newState) : !0;
}
function $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $e229cb5c8b2cd629$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $e229cb5c8b2cd629$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $e229cb5c8b2cd629$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $4TNnu && "function" === typeof $4TNnu.emit) {
        $4TNnu.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $e229cb5c8b2cd629$var$defaultOnUncaughtError(error) {
    $e229cb5c8b2cd629$var$reportGlobalError(error);
}
function $e229cb5c8b2cd629$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $e229cb5c8b2cd629$var$defaultOnRecoverableError(error) {
    $e229cb5c8b2cd629$var$reportGlobalError(error);
}
function $e229cb5c8b2cd629$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $e229cb5c8b2cd629$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $e229cb5c8b2cd629$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $e229cb5c8b2cd629$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $e229cb5c8b2cd629$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $e229cb5c8b2cd629$var$createClassErrorUpdate(lane) {
    lane = $e229cb5c8b2cd629$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $e229cb5c8b2cd629$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $e229cb5c8b2cd629$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $e229cb5c8b2cd629$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed ? $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $e229cb5c8b2cd629$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $e229cb5c8b2cd629$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $e229cb5c8b2cd629$var$shellBoundary ? $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes);
        $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($e229cb5c8b2cd629$var$isHydrating) return returnFiber = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $e229cb5c8b2cd629$var$HydrationMismatchException && (root = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(422), {
        cause: value
    }), $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $e229cb5c8b2cd629$var$HydrationMismatchException && (returnFiber = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(423), {
        cause: value
    }), $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $e229cb5c8b2cd629$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors ? $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $e229cb5c8b2cd629$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed || !$e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $e229cb5c8b2cd629$var$createClassErrorUpdate(rootRenderLanes), $e229cb5c8b2cd629$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $e229cb5c8b2cd629$var$SelectiveHydrationException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(461)), $e229cb5c8b2cd629$var$didReceiveUpdate = !1;
function $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $e229cb5c8b2cd629$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $e229cb5c8b2cd629$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    nextProps = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && key && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$e229cb5c8b2cd629$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $e229cb5c8b2cd629$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $e229cb5c8b2cd629$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($e229cb5c8b2cd629$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($e229cb5c8b2cd629$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $e229cb5c8b2cd629$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $e229cb5c8b2cd629$var$pushHiddenContext(workInProgress, prevState) : $e229cb5c8b2cd629$var$reuseHiddenContextOnStack(), $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($e229cb5c8b2cd629$var$pushTransition(workInProgress, prevState.cachePool), $e229cb5c8b2cd629$var$pushHiddenContext(workInProgress, prevState), $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null), $e229cb5c8b2cd629$var$reuseHiddenContextOnStack(), $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress));
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $e229cb5c8b2cd629$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $e229cb5c8b2cd629$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null);
    $e229cb5c8b2cd629$var$reuseHiddenContextOnStack();
    $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $e229cb5c8b2cd629$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    Component = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && nextProps && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $e229cb5c8b2cd629$var$finishRenderingHooks(current);
    Component = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && Component && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $e229cb5c8b2cd629$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $e229cb5c8b2cd629$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $e229cb5c8b2cd629$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $e229cb5c8b2cd629$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $e229cb5c8b2cd629$var$readContext(contextType) : $e229cb5c8b2cd629$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $e229cb5c8b2cd629$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $e229cb5c8b2cd629$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $e229cb5c8b2cd629$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $e229cb5c8b2cd629$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $e229cb5c8b2cd629$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $e229cb5c8b2cd629$var$hasForceUpdate || $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $e229cb5c8b2cd629$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $e229cb5c8b2cd629$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $e229cb5c8b2cd629$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $e229cb5c8b2cd629$var$hasForceUpdate || null !== current && null !== current.dependencies && $e229cb5c8b2cd629$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $e229cb5c8b2cd629$var$hasForceUpdate || $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $e229cb5c8b2cd629$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $e229cb5c8b2cd629$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $e229cb5c8b2cd629$var$resetHydrationState();
    workInProgress.flags |= 256;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $e229cb5c8b2cd629$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $e229cb5c8b2cd629$var$getSuspendedCache()
    };
}
function $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $e229cb5c8b2cd629$var$workInProgressDeferredLane);
    return current;
}
function $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($e229cb5c8b2cd629$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($e229cb5c8b2cd629$var$isHydrating) {
            showFallback ? $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($e229cb5c8b2cd629$var$isHydrating) {
                var nextInstance = $e229cb5c8b2cd629$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $e229cb5c8b2cd629$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $e229cb5c8b2cd629$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $e229cb5c8b2cd629$var$treeContextProvider ? {
                            id: $e229cb5c8b2cd629$var$treeContextId,
                            overflow: $e229cb5c8b2cd629$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $e229cb5c8b2cd629$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $e229cb5c8b2cd629$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, nextProps;
        $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $e229cb5c8b2cd629$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $e229cb5c8b2cd629$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($e229cb5c8b2cd629$var$didReceiveUpdate || $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $e229cb5c8b2cd629$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $e229cb5c8b2cd629$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(current, nextProps), $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $e229cb5c8b2cd629$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
            workInProgress = $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $e229cb5c8b2cd629$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(nextInstance.nextSibling), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$isHydrating = !0, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, null !== current && ($e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextId, $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextOverflow, $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextProvider, $e229cb5c8b2cd629$var$treeContextId = current.id, $e229cb5c8b2cd629$var$treeContextOverflow = current.overflow, $e229cb5c8b2cd629$var$treeContextProvider = workInProgress), workInProgress = $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $e229cb5c8b2cd629$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $e229cb5c8b2cd629$var$createWorkInProgress(digest, showFallback) : (showFallback = $e229cb5c8b2cd629$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $e229cb5c8b2cd629$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $e229cb5c8b2cd629$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, nextProps;
    $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $e229cb5c8b2cd629$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $e229cb5c8b2cd629$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $e229cb5c8b2cd629$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $e229cb5c8b2cd629$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $e229cb5c8b2cd629$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $e229cb5c8b2cd629$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $e229cb5c8b2cd629$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $e229cb5c8b2cd629$var$checkIfContextChanged(current) ? !0 : !1;
}
function $e229cb5c8b2cd629$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, current.memoizedState.cache);
            $e229cb5c8b2cd629$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $e229cb5c8b2cd629$var$pushHostContext(workInProgress);
            break;
        case 4:
            $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, current.memoizedState.cache);
    }
    return $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $e229cb5c8b2cd629$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $e229cb5c8b2cd629$var$didReceiveUpdate = !0;
        else {
            if (!$e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $e229cb5c8b2cd629$var$didReceiveUpdate = !1, $e229cb5c8b2cd629$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $e229cb5c8b2cd629$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $e229cb5c8b2cd629$var$didReceiveUpdate = !1, $e229cb5c8b2cd629$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $e229cb5c8b2cd629$var$pushTreeId(workInProgress, $e229cb5c8b2cd629$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $e229cb5c8b2cd629$var$shouldConstruct(lazyComponent) ? (current = $e229cb5c8b2cd629$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $e229cb5c8b2cd629$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $e229cb5c8b2cd629$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $e229cb5c8b2cd629$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $e229cb5c8b2cd629$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $e229cb5c8b2cd629$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $e229cb5c8b2cd629$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $e229cb5c8b2cd629$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $e229cb5c8b2cd629$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress);
                $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, nextProps);
                nextProps !== init.cache && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, [
                    $e229cb5c8b2cd629$var$CacheContext
                ], renderLanes, !0);
                $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(Error($e229cb5c8b2cd629$var$formatProdErrorMessage(424)), workInProgress);
                        $e229cb5c8b2cd629$var$queueHydrationError(lazyComponent);
                        workInProgress = $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$isHydrating = !0, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !0, renderLanes = $e229cb5c8b2cd629$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $e229cb5c8b2cd629$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $e229cb5c8b2cd629$var$markRef(current, workInProgress), null === current ? (renderLanes = $e229cb5c8b2cd629$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $e229cb5c8b2cd629$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer($e229cb5c8b2cd629$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress, lazyComponent[$e229cb5c8b2cd629$var$internalPropsKey] = current, $e229cb5c8b2cd629$var$setInitialProperties(lazyComponent, renderLanes, current), $e229cb5c8b2cd629$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $e229cb5c8b2cd629$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $e229cb5c8b2cd629$var$pushHostContext(workInProgress), null === current && $e229cb5c8b2cd629$var$isHydrating && (lazyComponent = workInProgress.stateNode = $e229cb5c8b2cd629$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootInstanceStackCursor.current), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$rootOrSingletonContext = !0, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $e229cb5c8b2cd629$var$isHydrating ? $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $e229cb5c8b2cd629$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $e229cb5c8b2cd629$var$isHydrating) {
                if (init = lazyComponent = $e229cb5c8b2cd629$var$nextHydratableInstance) lazyComponent = $e229cb5c8b2cd629$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(lazyComponent.firstChild), $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            }
            $e229cb5c8b2cd629$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $e229cb5c8b2cd629$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $e229cb5c8b2cd629$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, $e229cb5c8b2cd629$var$TransitionAwareHostComponent, null, null, renderLanes), $e229cb5c8b2cd629$var$HostTransitionContext._currentValue = init);
            $e229cb5c8b2cd629$var$markRef(current, workInProgress);
            $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $e229cb5c8b2cd629$var$isHydrating) {
                if (current = renderLanes = $e229cb5c8b2cd629$var$nextHydratableInstance) renderLanes = $e229cb5c8b2cd629$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $e229cb5c8b2cd629$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $e229cb5c8b2cd629$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress), init = $e229cb5c8b2cd629$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $e229cb5c8b2cd629$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress), lazyComponent = $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext), null === current ? (init = $e229cb5c8b2cd629$var$peekCacheFromPool(), null === init && (init = $e229cb5c8b2cd629$var$workInProgressRoot, nextProps = $e229cb5c8b2cd629$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $e229cb5c8b2cd629$var$initializeUpdateQueue(workInProgress), $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress), $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, null, null, renderLanes), $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, [
                $e229cb5c8b2cd629$var$CacheContext
            ], renderLanes, !0))), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $e229cb5c8b2cd629$var$valueCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$currentlyRenderingFiber = null, $e229cb5c8b2cd629$var$lastContextDependency = null;
function $e229cb5c8b2cd629$var$pushProvider(providerFiber, context, nextValue) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $e229cb5c8b2cd629$var$popProvider(context) {
    context._currentValue = $e229cb5c8b2cd629$var$valueCursor.current;
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$valueCursor);
}
function $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $e229cb5c8b2cd629$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $e229cb5c8b2cd629$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($e229cb5c8b2cd629$var$HostTransitionContext) : current = [
                $e229cb5c8b2cd629$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $e229cb5c8b2cd629$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$e229cb5c8b2cd629$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = workInProgress;
    $e229cb5c8b2cd629$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $e229cb5c8b2cd629$var$readContext(context) {
    return $e229cb5c8b2cd629$var$readContextForConsumer($e229cb5c8b2cd629$var$currentlyRenderingFiber, context);
}
function $e229cb5c8b2cd629$var$readContextDuringReconciliation(consumer, context) {
    null === $e229cb5c8b2cd629$var$currentlyRenderingFiber && $e229cb5c8b2cd629$var$prepareToReadContext(consumer);
    return $e229cb5c8b2cd629$var$readContextForConsumer(consumer, context);
}
function $e229cb5c8b2cd629$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $e229cb5c8b2cd629$var$lastContextDependency) {
        if (null === consumer) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(308));
        $e229cb5c8b2cd629$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$lastContextDependency.next = context;
    return value;
}
var $e229cb5c8b2cd629$var$hasForceUpdate = !1;
function $e229cb5c8b2cd629$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $e229cb5c8b2cd629$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e229cb5c8b2cd629$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
        $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $e229cb5c8b2cd629$var$markRootEntangled(root, lane);
    }
}
function $e229cb5c8b2cd629$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !1;
function $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $e229cb5c8b2cd629$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $e229cb5c8b2cd629$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $e229cb5c8b2cd629$var$currentEntangledLane && ($e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $e229cb5c8b2cd629$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $e229cb5c8b2cd629$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $e229cb5c8b2cd629$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $e229cb5c8b2cd629$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$e229cb5c8b2cd629$var$callCallback(callbacks[updateQueue], context);
}
function $e229cb5c8b2cd629$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $e229cb5c8b2cd629$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $e229cb5c8b2cd629$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e229cb5c8b2cd629$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e229cb5c8b2cd629$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $e229cb5c8b2cd629$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $e229cb5c8b2cd629$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$e229cb5c8b2cd629$var$internalPropsKey] = newProps;
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $e229cb5c8b2cd629$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $e229cb5c8b2cd629$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $e229cb5c8b2cd629$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = !1, $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = !1, $e229cb5c8b2cd629$var$needsFormReset = !1, $e229cb5c8b2cd629$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $e229cb5c8b2cd629$var$nextEffect = null, $e229cb5c8b2cd629$var$shouldFireAfterActiveInstanceBlur = !1;
function $e229cb5c8b2cd629$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $e229cb5c8b2cd629$var$eventsEnabled = $e229cb5c8b2cd629$var$_enabled;
    root = $e229cb5c8b2cd629$var$getActiveElementDeep(root);
    if ($e229cb5c8b2cd629$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $e229cb5c8b2cd629$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $e229cb5c8b2cd629$var$_enabled = !1;
    for($e229cb5c8b2cd629$var$nextEffect = firstChild; null !== $e229cb5c8b2cd629$var$nextEffect;)if (firstChild = $e229cb5c8b2cd629$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $e229cb5c8b2cd629$var$nextEffect = root;
    else for(; null !== $e229cb5c8b2cd629$var$nextEffect;){
        firstChild = $e229cb5c8b2cd629$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $e229cb5c8b2cd629$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $e229cb5c8b2cd629$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $e229cb5c8b2cd629$var$nextEffect = root;
            break;
        }
        $e229cb5c8b2cd629$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $e229cb5c8b2cd629$var$shouldFireAfterActiveInstanceBlur;
    $e229cb5c8b2cd629$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $e229cb5c8b2cd629$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostMount(finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
                $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevProps;
                ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return) : $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $e229cb5c8b2cd629$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $e229cb5c8b2cd629$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $e229cb5c8b2cd629$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $e229cb5c8b2cd629$var$hostParent = null, $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
function $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onCommitFiberUnmount) try {
        $e229cb5c8b2cd629$var$injectedHook.onCommitFiberUnmount($e229cb5c8b2cd629$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $e229cb5c8b2cd629$var$hostParent, prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParent = deletedFiber.stateNode;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $e229cb5c8b2cd629$var$detachDeletedInstance(deletedFiber);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParent;
            var prevHostParentIsContainer$119 = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParent = null;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$hostParent = prevHostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $e229cb5c8b2cd629$var$hostParent) {
                if ($e229cb5c8b2cd629$var$hostParentIsContainer) try {
                    finishedRoot = $e229cb5c8b2cd629$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $e229cb5c8b2cd629$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $e229cb5c8b2cd629$var$hostParent && ($e229cb5c8b2cd629$var$hostParentIsContainer ? (nearestMountedAncestor = $e229cb5c8b2cd629$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $e229cb5c8b2cd629$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $e229cb5c8b2cd629$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $e229cb5c8b2cd629$var$retryIfBlockedOn(nearestMountedAncestor)) : $e229cb5c8b2cd629$var$clearSuspenseBoundary($e229cb5c8b2cd629$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $e229cb5c8b2cd629$var$hostParent;
            prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParent = deletedFiber.stateNode.containerInfo;
            $e229cb5c8b2cd629$var$hostParentIsContainer = !0;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || ($e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = (prevHostParent = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $e229cb5c8b2cd629$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $e229cb5c8b2cd629$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $e229cb5c8b2cd629$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $e229cb5c8b2cd629$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $e229cb5c8b2cd629$var$hostParent = parent.stateNode;
                    $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $e229cb5c8b2cd629$var$hostParent = parent.stateNode.containerInfo;
                    $e229cb5c8b2cd629$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $e229cb5c8b2cd629$var$hostParent = parent.stateNode.containerInfo;
                    $e229cb5c8b2cd629$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $e229cb5c8b2cd629$var$hostParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(160));
        $e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $e229cb5c8b2cd629$var$hostParent = null;
        $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $e229cb5c8b2cd629$var$currentHoistableRoot = null;
function $e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($e229cb5c8b2cd629$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $e229cb5c8b2cd629$var$commitHookEffectListMount(3, finishedWork), $e229cb5c8b2cd629$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            flags & 64 && $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$e229cb5c8b2cd629$var$internalHoistableMarker] || currentResource[$e229cb5c8b2cd629$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $e229cb5c8b2cd629$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
                                        $e229cb5c8b2cd629$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $e229cb5c8b2cd629$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $e229cb5c8b2cd629$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $e229cb5c8b2cd629$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $e229cb5c8b2cd629$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
                                $e229cb5c8b2cd629$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$e229cb5c8b2cd629$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $e229cb5c8b2cd629$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$e229cb5c8b2cd629$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $e229cb5c8b2cd629$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($e229cb5c8b2cd629$var$needsFormReset = !0);
            break;
        case 6:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $e229cb5c8b2cd629$var$tagCaches = null;
            hoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(root.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$currentHoistableRoot = hoistableRoot;
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $e229cb5c8b2cd629$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $e229cb5c8b2cd629$var$needsFormReset && ($e229cb5c8b2cd629$var$needsFormReset = !1, $e229cb5c8b2cd629$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            $e229cb5c8b2cd629$var$currentHoistableRoot = flags;
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($e229cb5c8b2cd629$var$globalMostRecentFallbackTime = $e229cb5c8b2cd629$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden;
            type = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
            $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = nodeName || node;
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = type || nextNode;
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = type;
            $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = nodeName;
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork), $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
    }
}
function $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($e229cb5c8b2cd629$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                        $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($e229cb5c8b2cd629$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                        $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                        $e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $e229cb5c8b2cd629$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $e229cb5c8b2cd629$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$e229cb5c8b2cd629$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostMount(finishedWork);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $e229cb5c8b2cd629$var$releaseCache(previousCache));
}
function $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $e229cb5c8b2cd629$var$releaseCache(current));
}
function $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e229cb5c8b2cd629$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $e229cb5c8b2cd629$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $e229cb5c8b2cd629$var$suspenseyCommitFlag = 8192;
function $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $e229cb5c8b2cd629$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $e229cb5c8b2cd629$var$suspenseyCommitFlag && null !== fiber.memoizedState && $e229cb5c8b2cd629$var$suspendResource($e229cb5c8b2cd629$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $e229cb5c8b2cd629$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $e229cb5c8b2cd629$var$suspenseyCommitFlag, $e229cb5c8b2cd629$var$suspenseyCommitFlag = 16777216, $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber), $e229cb5c8b2cd629$var$suspenseyCommitFlag = previousHoistableRoot) : $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e229cb5c8b2cd629$var$nextEffect = childToDelete;
            $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $e229cb5c8b2cd629$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e229cb5c8b2cd629$var$nextEffect = childToDelete;
            $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $e229cb5c8b2cd629$var$nextEffect;){
        var fiber = $e229cb5c8b2cd629$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $e229cb5c8b2cd629$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $e229cb5c8b2cd629$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $e229cb5c8b2cd629$var$nextEffect;){
            cache = $e229cb5c8b2cd629$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $e229cb5c8b2cd629$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $e229cb5c8b2cd629$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $e229cb5c8b2cd629$var$nextEffect = sibling;
                break a;
            }
            $e229cb5c8b2cd629$var$nextEffect = returnFiber;
        }
    }
}
function $e229cb5c8b2cd629$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e229cb5c8b2cd629$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $e229cb5c8b2cd629$var$FiberNode(tag, pendingProps, key, mode);
}
function $e229cb5c8b2cd629$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $e229cb5c8b2cd629$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $e229cb5c8b2cd629$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $e229cb5c8b2cd629$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $e229cb5c8b2cd629$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $e229cb5c8b2cd629$var$isHostHoistableType(type, pendingProps, $e229cb5c8b2cd629$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE:
            return $e229cb5c8b2cd629$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_OFFSCREEN_TYPE:
            return $e229cb5c8b2cd629$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_PROVIDER_TYPE:
                case $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $e229cb5c8b2cd629$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $e229cb5c8b2cd629$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $e229cb5c8b2cd629$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $e229cb5c8b2cd629$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $e229cb5c8b2cd629$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $e229cb5c8b2cd629$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $e229cb5c8b2cd629$var$createFiberFromText(content, mode, lanes) {
    content = $e229cb5c8b2cd629$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $e229cb5c8b2cd629$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $e229cb5c8b2cd629$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $e229cb5c8b2cd629$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$e229cb5c8b2cd629$var$preloadResource(resource)) {
        resource = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 4194176) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes ? null !== $e229cb5c8b2cd629$var$shellBoundary : ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 62914560) !== $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && 0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912) || resource !== $e229cb5c8b2cd629$var$shellBoundary)) throw $e229cb5c8b2cd629$var$suspendedThenable = $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable, $e229cb5c8b2cd629$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $e229cb5c8b2cd629$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $e229cb5c8b2cd629$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$e229cb5c8b2cd629$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $e229cb5c8b2cd629$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $e229cb5c8b2cd629$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $e229cb5c8b2cd629$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 1:
            return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
            $e229cb5c8b2cd629$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $e229cb5c8b2cd629$var$popHydrationState(workInProgress) ? $e229cb5c8b2cd629$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $e229cb5c8b2cd629$var$hydrationErrors && ($e229cb5c8b2cd629$var$queueRecoverableErrors($e229cb5c8b2cd629$var$hydrationErrors), $e229cb5c8b2cd629$var$hydrationErrors = null));
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($e229cb5c8b2cd629$var$markUpdate(workInProgress), null !== renderLanes ? ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($e229cb5c8b2cd629$var$markUpdate(workInProgress), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $e229cb5c8b2cd629$var$popHostContext(workInProgress);
            renderLanes = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $e229cb5c8b2cd629$var$contextStackCursor.current;
                $e229cb5c8b2cd629$var$popHydrationState(workInProgress) ? $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $e229cb5c8b2cd629$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $e229cb5c8b2cd629$var$markUpdate(workInProgress));
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $e229cb5c8b2cd629$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $e229cb5c8b2cd629$var$contextStackCursor.current;
                if ($e229cb5c8b2cd629$var$popHydrationState(workInProgress)) $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer($e229cb5c8b2cd629$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script></script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    current[$e229cb5c8b2cd629$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($e229cb5c8b2cd629$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
                }
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                current = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current;
                if ($e229cb5c8b2cd629$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $e229cb5c8b2cd629$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $e229cb5c8b2cd629$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
                } else current = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $e229cb5c8b2cd629$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
                        type[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    } else $e229cb5c8b2cd629$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $e229cb5c8b2cd629$var$hydrationErrors && ($e229cb5c8b2cd629$var$queueRecoverableErrors($e229cb5c8b2cd629$var$hydrationErrors), $e229cb5c8b2cd629$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), workInProgress;
                    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $e229cb5c8b2cd629$var$popHostContainer(), null === current && $e229cb5c8b2cd629$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 10:
            return $e229cb5c8b2cd629$var$popProvider(workInProgress.type), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 19:
            $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $e229cb5c8b2cd629$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $e229cb5c8b2cd629$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $e229cb5c8b2cd629$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$e229cb5c8b2cd629$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $e229cb5c8b2cd629$var$now() > $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $e229cb5c8b2cd629$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $e229cb5c8b2cd629$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, current), $e229cb5c8b2cd629$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$e229cb5c8b2cd629$var$isHydrating) return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
                    } else 2 * $e229cb5c8b2cd629$var$now() - type.renderingStartTime > $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $e229cb5c8b2cd629$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $e229cb5c8b2cd629$var$now(), workInProgress.sibling = null, current = $e229cb5c8b2cd629$var$suspenseStackCursor.current, $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $e229cb5c8b2cd629$var$unwindWork(current, workInProgress) {
    $e229cb5c8b2cd629$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), $e229cb5c8b2cd629$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $e229cb5c8b2cd629$var$popHostContext(workInProgress), null;
        case 13:
            $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(340));
                $e229cb5c8b2cd629$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor), null;
        case 4:
            return $e229cb5c8b2cd629$var$popHostContainer(), null;
        case 10:
            return $e229cb5c8b2cd629$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$popHiddenContext(), null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $e229cb5c8b2cd629$var$unwindInterruptedWork(current, interruptedWork) {
    $e229cb5c8b2cd629$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
            $e229cb5c8b2cd629$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $e229cb5c8b2cd629$var$popHostContext(interruptedWork);
            break;
        case 4:
            $e229cb5c8b2cd629$var$popHostContainer();
            break;
        case 13:
            $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
            break;
        case 10:
            $e229cb5c8b2cd629$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            $e229cb5c8b2cd629$var$popHiddenContext();
            null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache);
            break;
        case 24:
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
    }
}
var $e229cb5c8b2cd629$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $e229cb5c8b2cd629$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $e229cb5c8b2cd629$var$executionContext = 0, $e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgress = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0, $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = !1, $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = !1, $e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !1, $e229cb5c8b2cd629$var$entangledRenderLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 0, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootPingedLanes = 0, $e229cb5c8b2cd629$var$workInProgressDeferredLane = 0, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = null, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = null, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $e229cb5c8b2cd629$var$globalMostRecentFallbackTime = 0, $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = Infinity, $e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = null, $e229cb5c8b2cd629$var$rootDoesHavePassiveEffects = !1, $e229cb5c8b2cd629$var$rootWithPendingPassiveEffects = null, $e229cb5c8b2cd629$var$pendingPassiveEffectsLanes = 0, $e229cb5c8b2cd629$var$pendingPassiveEffectsRemainingLanes = 0, $e229cb5c8b2cd629$var$pendingPassiveTransitions = null, $e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = null;
function $e229cb5c8b2cd629$var$requestUpdateLane() {
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2) && 0 !== $e229cb5c8b2cd629$var$workInProgressRootRenderLanes) return $e229cb5c8b2cd629$var$workInProgressRootRenderLanes & -$e229cb5c8b2cd629$var$workInProgressRootRenderLanes;
    if (null !== $e229cb5c8b2cd629$var$ReactSharedInternals.T) {
        var actionScopeLane = $e229cb5c8b2cd629$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $e229cb5c8b2cd629$var$requestTransitionLane();
    }
    return $e229cb5c8b2cd629$var$resolveUpdatePriority();
}
function $e229cb5c8b2cd629$var$requestDeferredLane() {
    0 === $e229cb5c8b2cd629$var$workInProgressDeferredLane && ($e229cb5c8b2cd629$var$workInProgressDeferredLane = 0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912) || $e229cb5c8b2cd629$var$isHydrating ? $e229cb5c8b2cd629$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $e229cb5c8b2cd629$var$workInProgressDeferredLane;
}
function $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $e229cb5c8b2cd629$var$workInProgressRoot && 2 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $e229cb5c8b2cd629$var$prepareFreshStack(root, 0), $e229cb5c8b2cd629$var$markRootSuspended(root, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1);
    $e229cb5c8b2cd629$var$markRootUpdated$1(root, lane);
    if (0 === ($e229cb5c8b2cd629$var$executionContext & 2) || root !== $e229cb5c8b2cd629$var$workInProgressRoot) root === $e229cb5c8b2cd629$var$workInProgressRoot && (0 === ($e229cb5c8b2cd629$var$executionContext & 2) && ($e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && $e229cb5c8b2cd629$var$markRootSuspended(root, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1)), $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
}
function $e229cb5c8b2cd629$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $e229cb5c8b2cd629$var$renderRootConcurrent(root$jscomp$0, lanes) : $e229cb5c8b2cd629$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $e229cb5c8b2cd629$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $e229cb5c8b2cd629$var$markRootSuspended(root$jscomp$0, lanes, 0, !$e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$e229cb5c8b2cd629$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $e229cb5c8b2cd629$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($e229cb5c8b2cd629$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $e229cb5c8b2cd629$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors;
                            $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $e229cb5c8b2cd629$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $e229cb5c8b2cd629$var$prepareFreshStack(root$jscomp$0, 0);
                $e229cb5c8b2cd629$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $e229cb5c8b2cd629$var$markRootSuspended(shouldTimeSlice, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !$e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $e229cb5c8b2cd629$var$globalMostRecentFallbackTime + 300 - $e229cb5c8b2cd629$var$now(), 10 < renderWasConcurrent)) {
                    $e229cb5c8b2cd629$var$markRootSuspended(shouldTimeSlice, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !$e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $e229cb5c8b2cd629$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $e229cb5c8b2cd629$var$scheduleTimeout($e229cb5c8b2cd629$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, $e229cb5c8b2cd629$var$workInProgressTransitions, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $e229cb5c8b2cd629$var$commitRootWhenReady(shouldTimeSlice, forceSync, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, $e229cb5c8b2cd629$var$workInProgressTransitions, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(root$jscomp$0);
}
function $e229cb5c8b2cd629$var$queueRecoverableErrors(errors) {
    null === $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors ? $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = errors : $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors.push.apply($e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, errors);
}
function $e229cb5c8b2cd629$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($e229cb5c8b2cd629$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $e229cb5c8b2cd629$var$noop
        }, $e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $e229cb5c8b2cd629$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($e229cb5c8b2cd629$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $e229cb5c8b2cd629$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $e229cb5c8b2cd629$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $e229cb5c8b2cd629$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$e229cb5c8b2cd629$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $e229cb5c8b2cd629$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$e229cb5c8b2cd629$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $e229cb5c8b2cd629$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $e229cb5c8b2cd629$var$flushSyncWork$1() {
    return 0 === ($e229cb5c8b2cd629$var$executionContext & 6) ? ($e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $e229cb5c8b2cd629$var$resetWorkInProgressStack() {
    if (null !== $e229cb5c8b2cd629$var$workInProgress) {
        if (0 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) var interruptedWork = $e229cb5c8b2cd629$var$workInProgress.return;
        else interruptedWork = $e229cb5c8b2cd629$var$workInProgress, $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null, $e229cb5c8b2cd629$var$resetHooksOnUnwind(interruptedWork), $e229cb5c8b2cd629$var$thenableState$1 = null, $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0, interruptedWork = $e229cb5c8b2cd629$var$workInProgress;
        for(; null !== interruptedWork;)$e229cb5c8b2cd629$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $e229cb5c8b2cd629$var$workInProgress = null;
    }
}
function $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $e229cb5c8b2cd629$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
    $e229cb5c8b2cd629$var$workInProgressRoot = root;
    $e229cb5c8b2cd629$var$workInProgress = timeoutHandle = $e229cb5c8b2cd629$var$createWorkInProgress(root.current, null);
    $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = lanes;
    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
    $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, lanes);
    $e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !1;
    $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = $e229cb5c8b2cd629$var$workInProgressDeferredLane = $e229cb5c8b2cd629$var$workInProgressRootPingedLanes = $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes = $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes = $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 0;
    $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = null;
    $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $e229cb5c8b2cd629$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $e229cb5c8b2cd629$var$entangledRenderLanes = lanes;
    $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $e229cb5c8b2cd629$var$handleThrow(root, thrownValue) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    thrownValue === $e229cb5c8b2cd629$var$SuspenseException ? (thrownValue = $e229cb5c8b2cd629$var$getSuspendedThenable(), $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 3) : thrownValue === $e229cb5c8b2cd629$var$SuspenseyCommitException ? (thrownValue = $e229cb5c8b2cd629$var$getSuspendedThenable(), $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 4) : $e229cb5c8b2cd629$var$workInProgressSuspendedReason = thrownValue === $e229cb5c8b2cd629$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $e229cb5c8b2cd629$var$workInProgressThrownValue = thrownValue;
    null === $e229cb5c8b2cd629$var$workInProgress && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1, $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $e229cb5c8b2cd629$var$pushDispatcher() {
    var prevDispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.H;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $e229cb5c8b2cd629$var$ContextOnlyDispatcher : prevDispatcher;
}
function $e229cb5c8b2cd629$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.A;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = $e229cb5c8b2cd629$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible() {
    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 4;
    $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings || ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 4194176) !== $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && null !== $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current || ($e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = !0);
    0 === ($e229cb5c8b2cd629$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $e229cb5c8b2cd629$var$workInProgressRoot || $e229cb5c8b2cd629$var$markRootSuspended($e229cb5c8b2cd629$var$workInProgressRoot, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1);
}
function $e229cb5c8b2cd629$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
    $e229cb5c8b2cd629$var$executionContext |= 2;
    var prevDispatcher = $e229cb5c8b2cd629$var$pushDispatcher(), prevAsyncDispatcher = $e229cb5c8b2cd629$var$pushAsyncDispatcher();
    if ($e229cb5c8b2cd629$var$workInProgressRoot !== root || $e229cb5c8b2cd629$var$workInProgressRootRenderLanes !== lanes) $e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && null !== $e229cb5c8b2cd629$var$workInProgress) {
            var unitOfWork = $e229cb5c8b2cd629$var$workInProgress, thrownValue = $e229cb5c8b2cd629$var$workInProgressThrownValue;
            switch($e229cb5c8b2cd629$var$workInProgressSuspendedReason){
                case 8:
                    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $e229cb5c8b2cd629$var$workInProgressSuspendedReason;
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $e229cb5c8b2cd629$var$workInProgressSuspendedReason, $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $e229cb5c8b2cd629$var$workLoopSync();
        exitStatus = $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $e229cb5c8b2cd629$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = prevDispatcher;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $e229cb5c8b2cd629$var$workInProgress && ($e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0, $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $e229cb5c8b2cd629$var$workLoopSync() {
    for(; null !== $e229cb5c8b2cd629$var$workInProgress;)$e229cb5c8b2cd629$var$performUnitOfWork($e229cb5c8b2cd629$var$workInProgress);
}
function $e229cb5c8b2cd629$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
    $e229cb5c8b2cd629$var$executionContext |= 2;
    var prevDispatcher = $e229cb5c8b2cd629$var$pushDispatcher(), prevAsyncDispatcher = $e229cb5c8b2cd629$var$pushAsyncDispatcher();
    $e229cb5c8b2cd629$var$workInProgressRoot !== root || $e229cb5c8b2cd629$var$workInProgressRootRenderLanes !== lanes ? ($e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = $e229cb5c8b2cd629$var$now() + 500, $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes)) : $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && null !== $e229cb5c8b2cd629$var$workInProgress) {
            lanes = $e229cb5c8b2cd629$var$workInProgress;
            var thrownValue = $e229cb5c8b2cd629$var$workInProgressThrownValue;
            b: switch($e229cb5c8b2cd629$var$workInProgressSuspendedReason){
                case 1:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($e229cb5c8b2cd629$var$isThenableResolved(thrownValue)) {
                        $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                        $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                        $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason && $e229cb5c8b2cd629$var$workInProgressRoot === root && ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 7);
                        $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $e229cb5c8b2cd629$var$isThenableResolved(thrownValue) ? ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(lanes)) : ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($e229cb5c8b2cd629$var$workInProgress.tag){
                        case 26:
                            resource = $e229cb5c8b2cd629$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $e229cb5c8b2cd629$var$workInProgress;
                            if (resource ? $e229cb5c8b2cd629$var$preloadResource(resource) : 1) {
                                $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                                $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $e229cb5c8b2cd629$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($e229cb5c8b2cd629$var$workInProgress = returnFiber, $e229cb5c8b2cd629$var$completeUnitOfWork(returnFiber)) : $e229cb5c8b2cd629$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
                    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(462));
            }
        }
        $e229cb5c8b2cd629$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $e229cb5c8b2cd629$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = prevDispatcher;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
    if (null !== $e229cb5c8b2cd629$var$workInProgress) return 0;
    $e229cb5c8b2cd629$var$workInProgressRoot = null;
    $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0;
    $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates();
    return $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
}
function $e229cb5c8b2cd629$var$workLoopConcurrent() {
    for(; null !== $e229cb5c8b2cd629$var$workInProgress && !$e229cb5c8b2cd629$var$shouldYield();)$e229cb5c8b2cd629$var$performUnitOfWork($e229cb5c8b2cd629$var$workInProgress);
}
function $e229cb5c8b2cd629$var$performUnitOfWork(unitOfWork) {
    var next = $e229cb5c8b2cd629$var$beginWork(unitOfWork.alternate, unitOfWork, $e229cb5c8b2cd629$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) : $e229cb5c8b2cd629$var$workInProgress = next;
}
function $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $e229cb5c8b2cd629$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $e229cb5c8b2cd629$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $e229cb5c8b2cd629$var$resetHooksOnUnwind(next);
        default:
            $e229cb5c8b2cd629$var$unwindInterruptedWork(current, next), next = $e229cb5c8b2cd629$var$workInProgress = $e229cb5c8b2cd629$var$resetWorkInProgress(next, $e229cb5c8b2cd629$var$entangledRenderLanes), next = $e229cb5c8b2cd629$var$beginWork(current, next, $e229cb5c8b2cd629$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) : $e229cb5c8b2cd629$var$workInProgress = next;
}
function $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$resetHooksOnUnwind(unitOfWork);
    $e229cb5c8b2cd629$var$thenableState$1 = null;
    $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($e229cb5c8b2cd629$var$throwException(root, returnFiber, unitOfWork, thrownValue, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes)) {
            $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1;
            $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current));
            $e229cb5c8b2cd629$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $e229cb5c8b2cd629$var$workInProgress = returnFiber, error;
        $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1;
        $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current));
        $e229cb5c8b2cd629$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($e229cb5c8b2cd629$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($e229cb5c8b2cd629$var$workInProgressRootIsPrerendering || 0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $e229cb5c8b2cd629$var$unwindUnitOfWork(unitOfWork, root);
    } else $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork);
}
function $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $e229cb5c8b2cd629$var$unwindUnitOfWork(completedWork, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $e229cb5c8b2cd629$var$completeWork(completedWork.alternate, completedWork, $e229cb5c8b2cd629$var$entangledRenderLanes);
        if (null !== next) {
            $e229cb5c8b2cd629$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $e229cb5c8b2cd629$var$workInProgress = completedWork;
            return;
        }
        $e229cb5c8b2cd629$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 5);
}
function $e229cb5c8b2cd629$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $e229cb5c8b2cd629$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $e229cb5c8b2cd629$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $e229cb5c8b2cd629$var$workInProgress = unitOfWork;
            return;
        }
        $e229cb5c8b2cd629$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 6;
    $e229cb5c8b2cd629$var$workInProgress = null;
}
function $e229cb5c8b2cd629$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, previousUpdateLanePriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2, $e229cb5c8b2cd629$var$ReactSharedInternals.T = null, $e229cb5c8b2cd629$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $e229cb5c8b2cd629$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $e229cb5c8b2cd629$var$flushPassiveEffects();
    while (null !== $e229cb5c8b2cd629$var$rootWithPendingPassiveEffects);
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes;
    $e229cb5c8b2cd629$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $e229cb5c8b2cd629$var$workInProgressRoot && ($e229cb5c8b2cd629$var$workInProgress = $e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $e229cb5c8b2cd629$var$rootDoesHavePassiveEffects || ($e229cb5c8b2cd629$var$rootDoesHavePassiveEffects = !0, $e229cb5c8b2cd629$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $e229cb5c8b2cd629$var$pendingPassiveTransitions = transitions, $e229cb5c8b2cd629$var$scheduleCallback$1($e229cb5c8b2cd629$var$NormalPriority$1, function() {
        $e229cb5c8b2cd629$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $e229cb5c8b2cd629$var$ReactSharedInternals.T, $e229cb5c8b2cd629$var$ReactSharedInternals.T = null, spawnedLane = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2, updatedLanes = $e229cb5c8b2cd629$var$executionContext, $e229cb5c8b2cd629$var$executionContext |= 4, $e229cb5c8b2cd629$var$commitBeforeMutationEffects(root, finishedWork), $e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(finishedWork, root), $e229cb5c8b2cd629$var$restoreSelection($e229cb5c8b2cd629$var$selectionInformation, root.containerInfo), $e229cb5c8b2cd629$var$_enabled = !!$e229cb5c8b2cd629$var$eventsEnabled, $e229cb5c8b2cd629$var$selectionInformation = $e229cb5c8b2cd629$var$eventsEnabled = null, root.current = finishedWork, $e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $e229cb5c8b2cd629$var$requestPaint(), $e229cb5c8b2cd629$var$executionContext = updatedLanes, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = spawnedLane, $e229cb5c8b2cd629$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $e229cb5c8b2cd629$var$rootDoesHavePassiveEffects ? ($e229cb5c8b2cd629$var$rootDoesHavePassiveEffects = !1, $e229cb5c8b2cd629$var$rootWithPendingPassiveEffects = root, $e229cb5c8b2cd629$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $e229cb5c8b2cd629$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $e229cb5c8b2cd629$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($e229cb5c8b2cd629$var$pendingPassiveEffectsLanes & 3) && $e229cb5c8b2cd629$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $e229cb5c8b2cd629$var$rootWithNestedUpdates ? $e229cb5c8b2cd629$var$nestedUpdateCount++ : ($e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = root) : $e229cb5c8b2cd629$var$nestedUpdateCount = 0;
    $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $e229cb5c8b2cd629$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $e229cb5c8b2cd629$var$releaseCache(remainingLanes)));
}
function $e229cb5c8b2cd629$var$flushPassiveEffects() {
    if (null !== $e229cb5c8b2cd629$var$rootWithPendingPassiveEffects) {
        var root$170 = $e229cb5c8b2cd629$var$rootWithPendingPassiveEffects, remainingLanes = $e229cb5c8b2cd629$var$pendingPassiveEffectsRemainingLanes;
        $e229cb5c8b2cd629$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $e229cb5c8b2cd629$var$lanesToEventPriority($e229cb5c8b2cd629$var$pendingPassiveEffectsLanes), prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
        try {
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            if (null === $e229cb5c8b2cd629$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $e229cb5c8b2cd629$var$pendingPassiveTransitions;
                $e229cb5c8b2cd629$var$pendingPassiveTransitions = null;
                var root = $e229cb5c8b2cd629$var$rootWithPendingPassiveEffects, lanes = $e229cb5c8b2cd629$var$pendingPassiveEffectsLanes;
                $e229cb5c8b2cd629$var$rootWithPendingPassiveEffects = null;
                $e229cb5c8b2cd629$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(331));
                var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
                $e229cb5c8b2cd629$var$executionContext |= 4;
                $e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(root.current);
                $e229cb5c8b2cd629$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
                $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onPostCommitFiberRoot) try {
                    $e229cb5c8b2cd629$var$injectedHook.onPostCommitFiberRoot($e229cb5c8b2cd629$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition, $e229cb5c8b2cd629$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $e229cb5c8b2cd629$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $e229cb5c8b2cd629$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($e229cb5c8b2cd629$var$markRootUpdated$1(rootFiber, 2), $e229cb5c8b2cd629$var$ensureRootIsScheduled(rootFiber));
}
function $e229cb5c8b2cd629$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed || !$e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $e229cb5c8b2cd629$var$createClassErrorUpdate(2);
                instance = $e229cb5c8b2cd629$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($e229cb5c8b2cd629$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $e229cb5c8b2cd629$var$markRootUpdated$1(instance, 2), $e229cb5c8b2cd629$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $e229cb5c8b2cd629$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $e229cb5c8b2cd629$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $e229cb5c8b2cd629$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $e229cb5c8b2cd629$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $e229cb5c8b2cd629$var$workInProgressRoot === root && ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus || 3 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 62914560) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && 300 > $e229cb5c8b2cd629$var$now() - $e229cb5c8b2cd629$var$globalMostRecentFallbackTime ? 0 === ($e229cb5c8b2cd629$var$executionContext & 2) && $e229cb5c8b2cd629$var$prepareFreshStack(root, 0) : $e229cb5c8b2cd629$var$workInProgressRootPingedLanes |= pingedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && ($e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = 0));
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
}
function $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $e229cb5c8b2cd629$var$claimNextRetryLane());
    boundaryFiber = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($e229cb5c8b2cd629$var$markRootUpdated$1(boundaryFiber, retryLane), $e229cb5c8b2cd629$var$ensureRootIsScheduled(boundaryFiber));
}
function $e229cb5c8b2cd629$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e229cb5c8b2cd629$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e229cb5c8b2cd629$var$scheduleCallback$1(priorityLevel, callback) {
    return $e229cb5c8b2cd629$var$scheduleCallback$3(priorityLevel, callback);
}
var $e229cb5c8b2cd629$var$firstScheduledRoot = null, $e229cb5c8b2cd629$var$lastScheduledRoot = null, $e229cb5c8b2cd629$var$didScheduleMicrotask = !1, $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !1, $e229cb5c8b2cd629$var$isFlushingWork = !1, $e229cb5c8b2cd629$var$currentEventTransitionLane = 0;
function $e229cb5c8b2cd629$var$ensureRootIsScheduled(root) {
    root !== $e229cb5c8b2cd629$var$lastScheduledRoot && null === root.next && (null === $e229cb5c8b2cd629$var$lastScheduledRoot ? $e229cb5c8b2cd629$var$firstScheduledRoot = $e229cb5c8b2cd629$var$lastScheduledRoot = root : $e229cb5c8b2cd629$var$lastScheduledRoot = $e229cb5c8b2cd629$var$lastScheduledRoot.next = root);
    $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !0;
    $e229cb5c8b2cd629$var$didScheduleMicrotask || ($e229cb5c8b2cd629$var$didScheduleMicrotask = !0, $e229cb5c8b2cd629$var$scheduleImmediateTask($e229cb5c8b2cd629$var$processRootScheduleInMicrotask));
}
function $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$e229cb5c8b2cd629$var$isFlushingWork && $e229cb5c8b2cd629$var$mightHavePendingSyncWork) {
        $e229cb5c8b2cd629$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $e229cb5c8b2cd629$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $e229cb5c8b2cd629$var$getNextLanes(root$172, root$172 === $e229cb5c8b2cd629$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $e229cb5c8b2cd629$var$isFlushingWork = !1;
    }
}
function $e229cb5c8b2cd629$var$processRootScheduleInMicrotask() {
    $e229cb5c8b2cd629$var$mightHavePendingSyncWork = $e229cb5c8b2cd629$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane && ($e229cb5c8b2cd629$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $e229cb5c8b2cd629$var$currentEventTransitionLane), $e229cb5c8b2cd629$var$currentEventTransitionLane = 0);
    for(var currentTime = $e229cb5c8b2cd629$var$now(), prev = null, root = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $e229cb5c8b2cd629$var$firstScheduledRoot = next : prev.next = next, null === next && ($e229cb5c8b2cd629$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $e229cb5c8b2cd629$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $e229cb5c8b2cd629$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $e229cb5c8b2cd629$var$workInProgressRoot;
    suspendedLanes = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes;
    suspendedLanes = $e229cb5c8b2cd629$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes);
        switch($e229cb5c8b2cd629$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $e229cb5c8b2cd629$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $e229cb5c8b2cd629$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $e229cb5c8b2cd629$var$IdlePriority;
                break;
            default:
                suspendedLanes = $e229cb5c8b2cd629$var$NormalPriority$1;
        }
        pingedLanes = $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $e229cb5c8b2cd629$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($e229cb5c8b2cd629$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $e229cb5c8b2cd629$var$getNextLanes(root, root === $e229cb5c8b2cd629$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $e229cb5c8b2cd629$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, $e229cb5c8b2cd629$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root, lanes) {
    if ($e229cb5c8b2cd629$var$flushPassiveEffects()) return null;
    $e229cb5c8b2cd629$var$performWorkOnRoot(root, lanes, !0);
}
function $e229cb5c8b2cd629$var$scheduleImmediateTask(cb) {
    $e229cb5c8b2cd629$var$scheduleMicrotask(function() {
        0 !== ($e229cb5c8b2cd629$var$executionContext & 6) ? $e229cb5c8b2cd629$var$scheduleCallback$3($e229cb5c8b2cd629$var$ImmediatePriority, cb) : cb();
    });
}
function $e229cb5c8b2cd629$var$requestTransitionLane() {
    0 === $e229cb5c8b2cd629$var$currentEventTransitionLane && ($e229cb5c8b2cd629$var$currentEventTransitionLane = $e229cb5c8b2cd629$var$claimNextTransitionLane());
    return $e229cb5c8b2cd629$var$currentEventTransitionLane;
}
function $e229cb5c8b2cd629$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $e229cb5c8b2cd629$var$sanitizeURL("" + actionProp);
}
function $e229cb5c8b2cd629$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $e229cb5c8b2cd629$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $e229cb5c8b2cd629$var$coerceFormActionProp((nativeEventTarget[$e229cb5c8b2cd629$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$e229cb5c8b2cd629$var$internalPropsKey] || null) ? $e229cb5c8b2cd629$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $e229cb5c8b2cd629$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane) {
                                var formData = submitter ? $e229cb5c8b2cd629$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $e229cb5c8b2cd629$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $e229cb5c8b2cd629$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $e229cb5c8b2cd629$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $e229cb5c8b2cd629$var$i$jscomp$inline_1439 = 0; $e229cb5c8b2cd629$var$i$jscomp$inline_1439 < $e229cb5c8b2cd629$var$simpleEventPluginEvents.length; $e229cb5c8b2cd629$var$i$jscomp$inline_1439++){
    var $e229cb5c8b2cd629$var$eventName$jscomp$inline_1440 = $e229cb5c8b2cd629$var$simpleEventPluginEvents[$e229cb5c8b2cd629$var$i$jscomp$inline_1439], $e229cb5c8b2cd629$var$domEventName$jscomp$inline_1441 = $e229cb5c8b2cd629$var$eventName$jscomp$inline_1440.toLowerCase(), $e229cb5c8b2cd629$var$capitalizedEvent$jscomp$inline_1442 = $e229cb5c8b2cd629$var$eventName$jscomp$inline_1440[0].toUpperCase() + $e229cb5c8b2cd629$var$eventName$jscomp$inline_1440.slice(1);
    $e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$domEventName$jscomp$inline_1441, "on" + $e229cb5c8b2cd629$var$capitalizedEvent$jscomp$inline_1442);
}
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_END, "onAnimationEnd");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_ITERATION, "onAnimationIteration");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_START, "onAnimationStart");
$e229cb5c8b2cd629$var$registerSimpleEvent("dblclick", "onDoubleClick");
$e229cb5c8b2cd629$var$registerSimpleEvent("focusin", "onFocus");
$e229cb5c8b2cd629$var$registerSimpleEvent("focusout", "onBlur");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_RUN, "onTransitionRun");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_START, "onTransitionStart");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_CANCEL, "onTransitionCancel");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_END, "onTransitionEnd");
$e229cb5c8b2cd629$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e229cb5c8b2cd629$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e229cb5c8b2cd629$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($e229cb5c8b2cd629$var$mediaEventTypes));
function $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e229cb5c8b2cd629$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e229cb5c8b2cd629$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $e229cb5c8b2cd629$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$e229cb5c8b2cd629$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$e229cb5c8b2cd629$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($e229cb5c8b2cd629$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $e229cb5c8b2cd629$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $e229cb5c8b2cd629$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $e229cb5c8b2cd629$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$e229cb5c8b2cd629$var$listeningMarker]) {
        rootContainerElement[$e229cb5c8b2cd629$var$listeningMarker] = !0;
        $e229cb5c8b2cd629$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($e229cb5c8b2cd629$var$nonDelegatedEvents.has(domEventName) || $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$e229cb5c8b2cd629$var$listeningMarker] || (ownerDocument[$e229cb5c8b2cd629$var$listeningMarker] = !0, $e229cb5c8b2cd629$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $e229cb5c8b2cd629$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($e229cb5c8b2cd629$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $e229cb5c8b2cd629$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $e229cb5c8b2cd629$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $e229cb5c8b2cd629$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$e229cb5c8b2cd629$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $e229cb5c8b2cd629$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $e229cb5c8b2cd629$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $e229cb5c8b2cd629$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticTouchEvent;
                        break;
                    case $e229cb5c8b2cd629$var$ANIMATION_END:
                    case $e229cb5c8b2cd629$var$ANIMATION_ITERATION:
                    case $e229cb5c8b2cd629$var$ANIMATION_START:
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticAnimationEvent;
                        break;
                    case $e229cb5c8b2cd629$var$TRANSITION_END:
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $e229cb5c8b2cd629$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($e229cb5c8b2cd629$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $e229cb5c8b2cd629$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($e229cb5c8b2cd629$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$e229cb5c8b2cd629$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $e229cb5c8b2cd629$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $e229cb5c8b2cd629$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $e229cb5c8b2cd629$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $e229cb5c8b2cd629$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $e229cb5c8b2cd629$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $e229cb5c8b2cd629$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $e229cb5c8b2cd629$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $e229cb5c8b2cd629$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $e229cb5c8b2cd629$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $e229cb5c8b2cd629$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $e229cb5c8b2cd629$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $e229cb5c8b2cd629$var$getParent(inCapturePhase);
                                reactEventName = $e229cb5c8b2cd629$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForChangeEvent;
                else if ($e229cb5c8b2cd629$var$isTextInputElement(reactName)) {
                    if ($e229cb5c8b2cd629$var$isInputEventSupported) getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $e229cb5c8b2cd629$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $e229cb5c8b2cd629$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForChangeEvent) : getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $e229cb5c8b2cd629$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($e229cb5c8b2cd629$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $e229cb5c8b2cd629$var$activeElement = handleEventFunc, $e229cb5c8b2cd629$var$activeElementInst = targetInst, $e229cb5c8b2cd629$var$lastSelection = null;
                    break;
                case "focusout":
                    $e229cb5c8b2cd629$var$lastSelection = $e229cb5c8b2cd629$var$activeElementInst = $e229cb5c8b2cd629$var$activeElement = null;
                    break;
                case "mousedown":
                    $e229cb5c8b2cd629$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e229cb5c8b2cd629$var$mouseDown = !1;
                    $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($e229cb5c8b2cd629$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($e229cb5c8b2cd629$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $e229cb5c8b2cd629$var$isComposing ? $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($e229cb5c8b2cd629$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($e229cb5c8b2cd629$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $e229cb5c8b2cd629$var$isComposing && (fallbackData = $e229cb5c8b2cd629$var$getData()) : ($e229cb5c8b2cd629$var$root = nativeEventTarget, $e229cb5c8b2cd629$var$startText = "value" in $e229cb5c8b2cd629$var$root ? $e229cb5c8b2cd629$var$root.value : $e229cb5c8b2cd629$var$root.textContent, $e229cb5c8b2cd629$var$isComposing = !0)), handleEventFunc = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $e229cb5c8b2cd629$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $e229cb5c8b2cd629$var$canUseTextInputEvent ? $e229cb5c8b2cd629$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $e229cb5c8b2cd629$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $e229cb5c8b2cd629$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $e229cb5c8b2cd629$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $e229cb5c8b2cd629$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $e229cb5c8b2cd629$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($e229cb5c8b2cd629$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $e229cb5c8b2cd629$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($e229cb5c8b2cd629$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $e229cb5c8b2cd629$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $e229cb5c8b2cd629$var$getListener(target, registrationName), null != stateNode && listeners.unshift($e229cb5c8b2cd629$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $e229cb5c8b2cd629$var$getListener(target, registrationName), null != stateNode && listeners.push($e229cb5c8b2cd629$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $e229cb5c8b2cd629$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $e229cb5c8b2cd629$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($e229cb5c8b2cd629$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($e229cb5c8b2cd629$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $e229cb5c8b2cd629$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(clientText);
    return $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $e229cb5c8b2cd629$var$noop$1() {}
function $e229cb5c8b2cd629$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $e229cb5c8b2cd629$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $e229cb5c8b2cd629$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $e229cb5c8b2cd629$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e229cb5c8b2cd629$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $e229cb5c8b2cd629$var$setProp(domElement, tag, "name", props.name, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($e229cb5c8b2cd629$var$setProp(domElement, tag, "encType", props.encType, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "method", props.method, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e229cb5c8b2cd629$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $e229cb5c8b2cd629$var$noop$1);
            break;
        case "onScroll":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $e229cb5c8b2cd629$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            $e229cb5c8b2cd629$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $e229cb5c8b2cd629$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $e229cb5c8b2cd629$var$aliases.get(key) || key, $e229cb5c8b2cd629$var$setValueForAttribute(domElement, key, value);
    }
}
function $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $e229cb5c8b2cd629$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $e229cb5c8b2cd629$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $e229cb5c8b2cd629$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $e229cb5c8b2cd629$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$e229cb5c8b2cd629$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$e229cb5c8b2cd629$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $e229cb5c8b2cd629$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $e229cb5c8b2cd629$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                    default:
                        $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $e229cb5c8b2cd629$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $e229cb5c8b2cd629$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $e229cb5c8b2cd629$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $e229cb5c8b2cd629$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $e229cb5c8b2cd629$var$track(domElement);
            return;
        case "select":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $e229cb5c8b2cd629$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(91));
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $e229cb5c8b2cd629$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $e229cb5c8b2cd629$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("cancel", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $e229cb5c8b2cd629$var$mediaEventTypes.length; hasSrc++)$e229cb5c8b2cd629$var$listenToNonDelegatedEvent($e229cb5c8b2cd629$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement), $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($e229cb5c8b2cd629$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $e229cb5c8b2cd629$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $e229cb5c8b2cd629$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $e229cb5c8b2cd629$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $e229cb5c8b2cd629$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, tag, !0) : $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $e229cb5c8b2cd629$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $e229cb5c8b2cd629$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($e229cb5c8b2cd629$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $e229cb5c8b2cd629$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $e229cb5c8b2cd629$var$eventsEnabled = null, $e229cb5c8b2cd629$var$selectionInformation = null;
function $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $e229cb5c8b2cd629$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $e229cb5c8b2cd629$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $e229cb5c8b2cd629$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = null;
function $e229cb5c8b2cd629$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $e229cb5c8b2cd629$var$currentPopstateTransitionEvent) return !1;
        $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $e229cb5c8b2cd629$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $e229cb5c8b2cd629$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $e229cb5c8b2cd629$var$localPromise = "function" === typeof Promise ? Promise : void 0, $e229cb5c8b2cd629$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e229cb5c8b2cd629$var$localPromise ? function(callback) {
    return $e229cb5c8b2cd629$var$localPromise.resolve(null).then(callback).catch($e229cb5c8b2cd629$var$handleErrorInNextTick);
} : $e229cb5c8b2cd629$var$scheduleTimeout;
function $e229cb5c8b2cd629$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $e229cb5c8b2cd629$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $e229cb5c8b2cd629$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $e229cb5c8b2cd629$var$retryIfBlockedOn(suspenseInstance);
}
function $e229cb5c8b2cd629$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $e229cb5c8b2cd629$var$clearContainerSparingly(node);
                $e229cb5c8b2cd629$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $e229cb5c8b2cd629$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$e229cb5c8b2cd629$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $e229cb5c8b2cd629$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $e229cb5c8b2cd629$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $e229cb5c8b2cd629$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $e229cb5c8b2cd629$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(451));
    }
}
var $e229cb5c8b2cd629$var$preloadPropsMap = new Map(), $e229cb5c8b2cd629$var$preconnectsSet = new Set();
function $e229cb5c8b2cd629$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $e229cb5c8b2cd629$var$previousDispatcher = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.d;
$e229cb5c8b2cd629$var$ReactDOMSharedInternals.d = {
    f: $e229cb5c8b2cd629$var$flushSyncWork,
    r: $e229cb5c8b2cd629$var$requestFormReset,
    D: $e229cb5c8b2cd629$var$prefetchDNS,
    C: $e229cb5c8b2cd629$var$preconnect,
    L: $e229cb5c8b2cd629$var$preload,
    m: $e229cb5c8b2cd629$var$preloadModule,
    X: $e229cb5c8b2cd629$var$preinitScript,
    S: $e229cb5c8b2cd629$var$preinitStyle,
    M: $e229cb5c8b2cd629$var$preinitModuleScript
};
function $e229cb5c8b2cd629$var$flushSyncWork() {
    var previousWasRendering = $e229cb5c8b2cd629$var$previousDispatcher.f(), wasRendering = $e229cb5c8b2cd629$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $e229cb5c8b2cd629$var$requestFormReset(form) {
    var formInst = $e229cb5c8b2cd629$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $e229cb5c8b2cd629$var$requestFormReset$1(formInst) : $e229cb5c8b2cd629$var$previousDispatcher.r(form);
}
var $e229cb5c8b2cd629$var$globalDocument = "undefined" === typeof document ? null : document;
function $e229cb5c8b2cd629$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $e229cb5c8b2cd629$var$preconnectsSet.has(limitedEscapedHref) || ($e229cb5c8b2cd629$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $e229cb5c8b2cd629$var$setInitialProperties(href, "link", rel), $e229cb5c8b2cd629$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $e229cb5c8b2cd629$var$prefetchDNS(href) {
    $e229cb5c8b2cd629$var$previousDispatcher.D(href);
    $e229cb5c8b2cd629$var$preconnectAs("dns-prefetch", href, null);
}
function $e229cb5c8b2cd629$var$preconnect(href, crossOrigin) {
    $e229cb5c8b2cd629$var$previousDispatcher.C(href, crossOrigin);
    $e229cb5c8b2cd629$var$preconnectAs("preconnect", href, crossOrigin);
}
function $e229cb5c8b2cd629$var$preload(href, as, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $e229cb5c8b2cd629$var$getStyleKey(href);
                break;
            case "script":
                key = $e229cb5c8b2cd629$var$getScriptKey(href);
        }
        $e229cb5c8b2cd629$var$preloadPropsMap.has(key) || (href = $e229cb5c8b2cd629$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $e229cb5c8b2cd629$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $e229cb5c8b2cd629$var$setInitialProperties(as, "link", href), $e229cb5c8b2cd629$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $e229cb5c8b2cd629$var$preloadModule(href, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.m(href, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $e229cb5c8b2cd629$var$getScriptKey(href);
        }
        if (!$e229cb5c8b2cd629$var$preloadPropsMap.has(key) && (href = $e229cb5c8b2cd629$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $e229cb5c8b2cd629$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $e229cb5c8b2cd629$var$setInitialProperties(as, "link", href);
            $e229cb5c8b2cd629$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $e229cb5c8b2cd629$var$preinitStyle(href, precedence, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $e229cb5c8b2cd629$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $e229cb5c8b2cd629$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $e229cb5c8b2cd629$var$markNodeAsHoistable(link);
                $e229cb5c8b2cd629$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $e229cb5c8b2cd629$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $e229cb5c8b2cd629$var$preinitScript(src, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.X(src, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e229cb5c8b2cd629$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)), resource || (src = $e229cb5c8b2cd629$var$assign({
            src: src,
            async: !0
        }, options), (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e229cb5c8b2cd629$var$markNodeAsHoistable(resource), $e229cb5c8b2cd629$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e229cb5c8b2cd629$var$preinitModuleScript(src, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.M(src, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e229cb5c8b2cd629$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)), resource || (src = $e229cb5c8b2cd629$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e229cb5c8b2cd629$var$markNodeAsHoistable(resource), $e229cb5c8b2cd629$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e229cb5c8b2cd629$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current) ? $e229cb5c8b2cd629$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $e229cb5c8b2cd629$var$getStyleKey(pendingProps.href), pendingProps = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $e229cb5c8b2cd629$var$getStyleKey(pendingProps.href);
                var styles$242 = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $e229cb5c8b2cd629$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $e229cb5c8b2cd629$var$preloadPropsMap.set(type, pendingProps), styles$242 || $e229cb5c8b2cd629$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $e229cb5c8b2cd629$var$getScriptKey(pendingProps), pendingProps = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(444, type));
    }
}
function $e229cb5c8b2cd629$var$getStyleKey(href) {
    return 'href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(rawProps) {
    return $e229cb5c8b2cd629$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $e229cb5c8b2cd629$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $e229cb5c8b2cd629$var$setInitialProperties(key, "link", preloadProps), $e229cb5c8b2cd629$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $e229cb5c8b2cd629$var$getScriptKey(src) {
    return '[src="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $e229cb5c8b2cd629$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $e229cb5c8b2cd629$var$markNodeAsHoistable(instance), instance;
            var styleProps = $e229cb5c8b2cd629$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
            $e229cb5c8b2cd629$var$setInitialProperties(instance, "style", styleProps);
            $e229cb5c8b2cd629$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $e229cb5c8b2cd629$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $e229cb5c8b2cd629$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(props);
            (styleProps = $e229cb5c8b2cd629$var$preloadPropsMap.get(styleProps)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e229cb5c8b2cd629$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $e229cb5c8b2cd629$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $e229cb5c8b2cd629$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $e229cb5c8b2cd629$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $e229cb5c8b2cd629$var$preloadPropsMap.get(instance$248)) instance = $e229cb5c8b2cd629$var$assign({}, props), $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(styleProps);
            $e229cb5c8b2cd629$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $e229cb5c8b2cd629$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $e229cb5c8b2cd629$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $e229cb5c8b2cd629$var$tagCaches = null;
function $e229cb5c8b2cd629$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $e229cb5c8b2cd629$var$tagCaches) {
        var cache = new Map();
        var caches = $e229cb5c8b2cd629$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $e229cb5c8b2cd629$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$e229cb5c8b2cd629$var$internalHoistableMarker] || node[$e229cb5c8b2cd629$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $e229cb5c8b2cd629$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $e229cb5c8b2cd629$var$suspendedState = null;
function $e229cb5c8b2cd629$var$noop() {}
function $e229cb5c8b2cd629$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $e229cb5c8b2cd629$var$suspendedState) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(475));
    var state = $e229cb5c8b2cd629$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $e229cb5c8b2cd629$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $e229cb5c8b2cd629$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(props);
            (key = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e229cb5c8b2cd629$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $e229cb5c8b2cd629$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $e229cb5c8b2cd629$var$waitForCommitToBeReady() {
    if (null === $e229cb5c8b2cd629$var$suspendedState) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(475));
    var state = $e229cb5c8b2cd629$var$suspendedState;
    state.stylesheets && 0 === state.count && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $e229cb5c8b2cd629$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $e229cb5c8b2cd629$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $e229cb5c8b2cd629$var$precedencesByRoot = null;
function $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $e229cb5c8b2cd629$var$precedencesByRoot = new Map(), resources.forEach($e229cb5c8b2cd629$var$insertStylesheetIntoRoot, state), $e229cb5c8b2cd629$var$precedencesByRoot = null, $e229cb5c8b2cd629$var$onUnsuspend.call(state));
}
function $e229cb5c8b2cd629$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $e229cb5c8b2cd629$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $e229cb5c8b2cd629$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $e229cb5c8b2cd629$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $e229cb5c8b2cd629$var$HostTransitionContext = {
    $$typeof: $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $e229cb5c8b2cd629$var$sharedNotPendingObject,
    _currentValue2: $e229cb5c8b2cd629$var$sharedNotPendingObject,
    _threadCount: 0
};
function $e229cb5c8b2cd629$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $e229cb5c8b2cd629$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e229cb5c8b2cd629$var$createLaneMap(0);
    this.hiddenUpdates = $e229cb5c8b2cd629$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $e229cb5c8b2cd629$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $e229cb5c8b2cd629$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $e229cb5c8b2cd629$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $e229cb5c8b2cd629$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $e229cb5c8b2cd629$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $e229cb5c8b2cd629$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $e229cb5c8b2cd629$var$emptyContextObject;
    parentComponent = $e229cb5c8b2cd629$var$emptyContextObject;
    return parentComponent;
}
function $e229cb5c8b2cd629$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $e229cb5c8b2cd629$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $e229cb5c8b2cd629$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $e229cb5c8b2cd629$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(element, rootFiber, lane), $e229cb5c8b2cd629$var$entangleTransitions(element, rootFiber, lane));
}
function $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane);
}
function $e229cb5c8b2cd629$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $e229cb5c8b2cd629$var$_enabled = !0;
function $e229cb5c8b2cd629$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2, $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 8, $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($e229cb5c8b2cd629$var$_enabled) {
        var blockedOn = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e229cb5c8b2cd629$var$return_targetInst, targetContainer), $e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($e229cb5c8b2cd629$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $e229cb5c8b2cd629$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $e229cb5c8b2cd629$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $e229cb5c8b2cd629$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $e229cb5c8b2cd629$var$ensureRootIsScheduled(fiber);
                                0 === ($e229cb5c8b2cd629$var$executionContext & 6) && ($e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = $e229cb5c8b2cd629$var$now() + 500, $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2), $e229cb5c8b2cd629$var$flushSyncWork$1(), $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e229cb5c8b2cd629$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $e229cb5c8b2cd629$var$getEventTarget(nativeEvent);
    return $e229cb5c8b2cd629$var$findInstanceBlockingTarget(nativeEvent);
}
var $e229cb5c8b2cd629$var$return_targetInst = null;
function $e229cb5c8b2cd629$var$findInstanceBlockingTarget(targetNode) {
    $e229cb5c8b2cd629$var$return_targetInst = null;
    targetNode = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $e229cb5c8b2cd629$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $e229cb5c8b2cd629$var$return_targetInst = targetNode;
    return null;
}
function $e229cb5c8b2cd629$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($e229cb5c8b2cd629$var$getCurrentPriorityLevel()){
                case $e229cb5c8b2cd629$var$ImmediatePriority:
                    return 2;
                case $e229cb5c8b2cd629$var$UserBlockingPriority:
                    return 8;
                case $e229cb5c8b2cd629$var$NormalPriority$1:
                case $e229cb5c8b2cd629$var$LowPriority:
                    return 32;
                case $e229cb5c8b2cd629$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !1, $e229cb5c8b2cd629$var$queuedFocus = null, $e229cb5c8b2cd629$var$queuedDrag = null, $e229cb5c8b2cd629$var$queuedMouse = null, $e229cb5c8b2cd629$var$queuedPointers = new Map(), $e229cb5c8b2cd629$var$queuedPointerCaptures = new Map(), $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets = [], $e229cb5c8b2cd629$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $e229cb5c8b2cd629$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $e229cb5c8b2cd629$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $e229cb5c8b2cd629$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $e229cb5c8b2cd629$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e229cb5c8b2cd629$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $e229cb5c8b2cd629$var$getInstanceFromNode(blockedOn), null !== blockedOn && $e229cb5c8b2cd629$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $e229cb5c8b2cd629$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $e229cb5c8b2cd629$var$queuedFocus = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $e229cb5c8b2cd629$var$queuedDrag = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $e229cb5c8b2cd629$var$queuedMouse = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $e229cb5c8b2cd629$var$queuedPointers.set(pointerId, $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $e229cb5c8b2cd629$var$queuedPointerCaptures.set(pointerId, $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $e229cb5c8b2cd629$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $e229cb5c8b2cd629$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $e229cb5c8b2cd629$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $e229cb5c8b2cd629$var$currentReplayingEvent = null;
        } else return targetContainers = $e229cb5c8b2cd629$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $e229cb5c8b2cd629$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $e229cb5c8b2cd629$var$replayUnblockedEvents() {
    $e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !1;
    null !== $e229cb5c8b2cd629$var$queuedFocus && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedFocus) && ($e229cb5c8b2cd629$var$queuedFocus = null);
    null !== $e229cb5c8b2cd629$var$queuedDrag && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedDrag) && ($e229cb5c8b2cd629$var$queuedDrag = null);
    null !== $e229cb5c8b2cd629$var$queuedMouse && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedMouse) && ($e229cb5c8b2cd629$var$queuedMouse = null);
    $e229cb5c8b2cd629$var$queuedPointers.forEach($e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap);
    $e229cb5c8b2cd629$var$queuedPointerCaptures.forEach($e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap);
}
function $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $e229cb5c8b2cd629$var$hasScheduledReplayAttempt || ($e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $e229cb5c8b2cd629$var$replayUnblockedEvents)));
}
var $e229cb5c8b2cd629$var$lastScheduledReplayQueue = null;
function $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $e229cb5c8b2cd629$var$lastScheduledReplayQueue !== formReplayingQueue && ($e229cb5c8b2cd629$var$lastScheduledReplayQueue = formReplayingQueue, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, function() {
        $e229cb5c8b2cd629$var$lastScheduledReplayQueue === formReplayingQueue && ($e229cb5c8b2cd629$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $e229cb5c8b2cd629$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $e229cb5c8b2cd629$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $e229cb5c8b2cd629$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $e229cb5c8b2cd629$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $e229cb5c8b2cd629$var$queuedFocus && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedFocus, unblocked);
    null !== $e229cb5c8b2cd629$var$queuedDrag && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedDrag, unblocked);
    null !== $e229cb5c8b2cd629$var$queuedMouse && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedMouse, unblocked);
    $e229cb5c8b2cd629$var$queuedPointers.forEach(unblock);
    $e229cb5c8b2cd629$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length && (i = $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$e229cb5c8b2cd629$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$e229cb5c8b2cd629$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $e229cb5c8b2cd629$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $e229cb5c8b2cd629$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.render = $e229cb5c8b2cd629$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(409));
    var current = root.current, lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    $e229cb5c8b2cd629$var$updateContainerImpl(current, lane, children, root, null, null);
};
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.unmount = $e229cb5c8b2cd629$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $e229cb5c8b2cd629$var$flushPassiveEffects();
        $e229cb5c8b2cd629$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $e229cb5c8b2cd629$var$flushSyncWork$1();
        container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = null;
    }
};
function $e229cb5c8b2cd629$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $e229cb5c8b2cd629$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[i].priority; i++);
        $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(target);
    }
};
var $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $bh6RR.version;
if ("19.0.0" !== $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(527, $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$e229cb5c8b2cd629$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $e229cb5c8b2cd629$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $e229cb5c8b2cd629$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $e229cb5c8b2cd629$var$ReactSharedInternals,
    findFiberByHostInstance: $e229cb5c8b2cd629$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e229cb5c8b2cd629$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e229cb5c8b2cd629$var$hook$jscomp$inline_2166.isDisabled && $e229cb5c8b2cd629$var$hook$jscomp$inline_2166.supportsFiber) try {
        $e229cb5c8b2cd629$var$rendererID = $e229cb5c8b2cd629$var$hook$jscomp$inline_2166.inject($e229cb5c8b2cd629$var$internals$jscomp$inline_2165), $e229cb5c8b2cd629$var$injectedHook = $e229cb5c8b2cd629$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$e229cb5c8b2cd629$export$882461b6382ed46c = function(container, options) {
    if (!$e229cb5c8b2cd629$var$isValidContainer(container)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e229cb5c8b2cd629$var$defaultOnUncaughtError, onCaughtError = $e229cb5c8b2cd629$var$defaultOnCaughtError, onRecoverableError = $e229cb5c8b2cd629$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $e229cb5c8b2cd629$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = options.current;
    $e229cb5c8b2cd629$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $e229cb5c8b2cd629$var$ReactDOMRoot(options);
};
$e229cb5c8b2cd629$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$e229cb5c8b2cd629$var$isValidContainer(container)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e229cb5c8b2cd629$var$defaultOnUncaughtError, onCaughtError = $e229cb5c8b2cd629$var$defaultOnCaughtError, onRecoverableError = $e229cb5c8b2cd629$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $e229cb5c8b2cd629$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $e229cb5c8b2cd629$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $e229cb5c8b2cd629$var$requestUpdateLane();
    identifierPrefix = $e229cb5c8b2cd629$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $e229cb5c8b2cd629$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $e229cb5c8b2cd629$var$markRootUpdated$1(initialChildren, isStrictMode);
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(initialChildren);
    container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = initialChildren.current;
    $e229cb5c8b2cd629$var$listenToAllSupportedEvents(container);
    return new $e229cb5c8b2cd629$var$ReactDOMHydrationRoot(initialChildren);
};
$e229cb5c8b2cd629$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4CW02"));

});
parcelRegister("4CW02", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $35e7b389374acc05$export$c4744153514ff05d; }, function (v) { return $35e7b389374acc05$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $35e7b389374acc05$export$3e506c1ccc9cc1a7; }, function (v) { return $35e7b389374acc05$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $35e7b389374acc05$export$e26fe2ed2fa76875; }, function (v) { return $35e7b389374acc05$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $35e7b389374acc05$export$502329bbf4b505b1; }, function (v) { return $35e7b389374acc05$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $35e7b389374acc05$export$6e3807111c4874c4; }, function (v) { return $35e7b389374acc05$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $35e7b389374acc05$export$c27134553091fb3a; }, function (v) { return $35e7b389374acc05$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $35e7b389374acc05$export$33ee1acdc04fd2a2; }, function (v) { return $35e7b389374acc05$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $35e7b389374acc05$export$b00a404bbd5edef2; }, function (v) { return $35e7b389374acc05$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $35e7b389374acc05$export$8352ce38b91d0c62; }, function (v) { return $35e7b389374acc05$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $35e7b389374acc05$export$d66a1c1c77bd778b; }, function (v) { return $35e7b389374acc05$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $35e7b389374acc05$export$d3dfb8e4810cb555; }, function (v) { return $35e7b389374acc05$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $35e7b389374acc05$export$839f9183b0465a69; }, function (v) { return $35e7b389374acc05$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $35e7b389374acc05$export$72fdf0e06517287b; }, function (v) { return $35e7b389374acc05$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $35e7b389374acc05$export$4b844e58a3e414b4; }, function (v) { return $35e7b389374acc05$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $35e7b389374acc05$export$816d2913ae6b83b1; }, function (v) { return $35e7b389374acc05$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $35e7b389374acc05$export$61bcfe829111a1d0; }, function (v) { return $35e7b389374acc05$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $35e7b389374acc05$export$7ee8c9beb337bc3f; }, function (v) { return $35e7b389374acc05$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $35e7b389374acc05$export$b5836b71941fa3ed; }, function (v) { return $35e7b389374acc05$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $35e7b389374acc05$export$cf845f2c119da08a; }, function (v) { return $35e7b389374acc05$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $35e7b389374acc05$export$c4744153514ff05d;
var $35e7b389374acc05$export$3e506c1ccc9cc1a7;
var $35e7b389374acc05$export$e26fe2ed2fa76875;
var $35e7b389374acc05$export$502329bbf4b505b1;
var $35e7b389374acc05$export$6e3807111c4874c4;
var $35e7b389374acc05$export$c27134553091fb3a;
var $35e7b389374acc05$export$33ee1acdc04fd2a2;
var $35e7b389374acc05$export$b00a404bbd5edef2;
var $35e7b389374acc05$export$8352ce38b91d0c62;
var $35e7b389374acc05$export$d66a1c1c77bd778b;
var $35e7b389374acc05$export$d3dfb8e4810cb555;
var $35e7b389374acc05$export$839f9183b0465a69;
var $35e7b389374acc05$export$72fdf0e06517287b;
var $35e7b389374acc05$export$4b844e58a3e414b4;
var $35e7b389374acc05$export$816d2913ae6b83b1;
var $35e7b389374acc05$export$61bcfe829111a1d0;
var $35e7b389374acc05$export$7ee8c9beb337bc3f;
var $35e7b389374acc05$export$b5836b71941fa3ed;
var $35e7b389374acc05$export$cf845f2c119da08a;
"use strict";
function $35e7b389374acc05$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $35e7b389374acc05$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $35e7b389374acc05$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $35e7b389374acc05$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $35e7b389374acc05$var$compare(left, last)) rightIndex < length && 0 > $35e7b389374acc05$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $35e7b389374acc05$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $35e7b389374acc05$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$35e7b389374acc05$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $35e7b389374acc05$var$localPerformance = performance;
    $35e7b389374acc05$export$c4744153514ff05d = function() {
        return $35e7b389374acc05$var$localPerformance.now();
    };
} else {
    var $35e7b389374acc05$var$localDate = Date, $35e7b389374acc05$var$initialTime = $35e7b389374acc05$var$localDate.now();
    $35e7b389374acc05$export$c4744153514ff05d = function() {
        return $35e7b389374acc05$var$localDate.now() - $35e7b389374acc05$var$initialTime;
    };
}
var $35e7b389374acc05$var$taskQueue = [], $35e7b389374acc05$var$timerQueue = [], $35e7b389374acc05$var$taskIdCounter = 1, $35e7b389374acc05$var$currentTask = null, $35e7b389374acc05$var$currentPriorityLevel = 3, $35e7b389374acc05$var$isPerformingWork = !1, $35e7b389374acc05$var$isHostCallbackScheduled = !1, $35e7b389374acc05$var$isHostTimeoutScheduled = !1, $35e7b389374acc05$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $35e7b389374acc05$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $35e7b389374acc05$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $35e7b389374acc05$var$advanceTimers(currentTime) {
    for(var timer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue); null !== timer;){
        if (null === timer.callback) $35e7b389374acc05$var$pop($35e7b389374acc05$var$timerQueue);
        else if (timer.startTime <= currentTime) $35e7b389374acc05$var$pop($35e7b389374acc05$var$timerQueue), timer.sortIndex = timer.expirationTime, $35e7b389374acc05$var$push($35e7b389374acc05$var$taskQueue, timer);
        else break;
        timer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue);
    }
}
function $35e7b389374acc05$var$handleTimeout(currentTime) {
    $35e7b389374acc05$var$isHostTimeoutScheduled = !1;
    $35e7b389374acc05$var$advanceTimers(currentTime);
    if (!$35e7b389374acc05$var$isHostCallbackScheduled) {
        if (null !== $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue)) $35e7b389374acc05$var$isHostCallbackScheduled = !0, $35e7b389374acc05$var$requestHostCallback();
        else {
            var firstTimer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue);
            null !== firstTimer && $35e7b389374acc05$var$requestHostTimeout($35e7b389374acc05$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $35e7b389374acc05$var$isMessageLoopRunning = !1, $35e7b389374acc05$var$taskTimeoutID = -1, $35e7b389374acc05$var$frameInterval = 5, $35e7b389374acc05$var$startTime = -1;
function $35e7b389374acc05$var$shouldYieldToHost() {
    return $35e7b389374acc05$export$c4744153514ff05d() - $35e7b389374acc05$var$startTime < $35e7b389374acc05$var$frameInterval ? !1 : !0;
}
function $35e7b389374acc05$var$performWorkUntilDeadline() {
    if ($35e7b389374acc05$var$isMessageLoopRunning) {
        var currentTime = $35e7b389374acc05$export$c4744153514ff05d();
        $35e7b389374acc05$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $35e7b389374acc05$var$isHostCallbackScheduled = !1;
                $35e7b389374acc05$var$isHostTimeoutScheduled && ($35e7b389374acc05$var$isHostTimeoutScheduled = !1, $35e7b389374acc05$var$localClearTimeout($35e7b389374acc05$var$taskTimeoutID), $35e7b389374acc05$var$taskTimeoutID = -1);
                $35e7b389374acc05$var$isPerformingWork = !0;
                var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
                try {
                    b: {
                        $35e7b389374acc05$var$advanceTimers(currentTime);
                        for($35e7b389374acc05$var$currentTask = $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue); null !== $35e7b389374acc05$var$currentTask && !($35e7b389374acc05$var$currentTask.expirationTime > currentTime && $35e7b389374acc05$var$shouldYieldToHost());){
                            var callback = $35e7b389374acc05$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $35e7b389374acc05$var$currentTask.callback = null;
                                $35e7b389374acc05$var$currentPriorityLevel = $35e7b389374acc05$var$currentTask.priorityLevel;
                                var continuationCallback = callback($35e7b389374acc05$var$currentTask.expirationTime <= currentTime);
                                currentTime = $35e7b389374acc05$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $35e7b389374acc05$var$currentTask.callback = continuationCallback;
                                    $35e7b389374acc05$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $35e7b389374acc05$var$currentTask === $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue) && $35e7b389374acc05$var$pop($35e7b389374acc05$var$taskQueue);
                                $35e7b389374acc05$var$advanceTimers(currentTime);
                            } else $35e7b389374acc05$var$pop($35e7b389374acc05$var$taskQueue);
                            $35e7b389374acc05$var$currentTask = $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue);
                        }
                        if (null !== $35e7b389374acc05$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue);
                            null !== firstTimer && $35e7b389374acc05$var$requestHostTimeout($35e7b389374acc05$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $35e7b389374acc05$var$currentTask = null, $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel, $35e7b389374acc05$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $35e7b389374acc05$var$schedulePerformWorkUntilDeadline() : $35e7b389374acc05$var$isMessageLoopRunning = !1;
        }
    }
}
var $35e7b389374acc05$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $35e7b389374acc05$var$localSetImmediate) $35e7b389374acc05$var$schedulePerformWorkUntilDeadline = function() {
    $35e7b389374acc05$var$localSetImmediate($35e7b389374acc05$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $35e7b389374acc05$var$channel = new MessageChannel(), $35e7b389374acc05$var$port = $35e7b389374acc05$var$channel.port2;
    $35e7b389374acc05$var$channel.port1.onmessage = $35e7b389374acc05$var$performWorkUntilDeadline;
    $35e7b389374acc05$var$schedulePerformWorkUntilDeadline = function() {
        $35e7b389374acc05$var$port.postMessage(null);
    };
} else $35e7b389374acc05$var$schedulePerformWorkUntilDeadline = function() {
    $35e7b389374acc05$var$localSetTimeout($35e7b389374acc05$var$performWorkUntilDeadline, 0);
};
function $35e7b389374acc05$var$requestHostCallback() {
    $35e7b389374acc05$var$isMessageLoopRunning || ($35e7b389374acc05$var$isMessageLoopRunning = !0, $35e7b389374acc05$var$schedulePerformWorkUntilDeadline());
}
function $35e7b389374acc05$var$requestHostTimeout(callback, ms) {
    $35e7b389374acc05$var$taskTimeoutID = $35e7b389374acc05$var$localSetTimeout(function() {
        callback($35e7b389374acc05$export$c4744153514ff05d());
    }, ms);
}
$35e7b389374acc05$export$3e506c1ccc9cc1a7 = 5;
$35e7b389374acc05$export$e26fe2ed2fa76875 = 1;
$35e7b389374acc05$export$502329bbf4b505b1 = 4;
$35e7b389374acc05$export$6e3807111c4874c4 = 3;
$35e7b389374acc05$export$c27134553091fb3a = null;
$35e7b389374acc05$export$33ee1acdc04fd2a2 = 2;
$35e7b389374acc05$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$35e7b389374acc05$export$8352ce38b91d0c62 = function() {
    $35e7b389374acc05$var$isHostCallbackScheduled || $35e7b389374acc05$var$isPerformingWork || ($35e7b389374acc05$var$isHostCallbackScheduled = !0, $35e7b389374acc05$var$requestHostCallback());
};
$35e7b389374acc05$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $35e7b389374acc05$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$35e7b389374acc05$export$d3dfb8e4810cb555 = function() {
    return $35e7b389374acc05$var$currentPriorityLevel;
};
$35e7b389374acc05$export$839f9183b0465a69 = function() {
    return $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue);
};
$35e7b389374acc05$export$72fdf0e06517287b = function(eventHandler) {
    switch($35e7b389374acc05$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    $35e7b389374acc05$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$35e7b389374acc05$export$4b844e58a3e414b4 = function() {};
$35e7b389374acc05$export$816d2913ae6b83b1 = function() {};
$35e7b389374acc05$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    $35e7b389374acc05$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$35e7b389374acc05$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $35e7b389374acc05$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $35e7b389374acc05$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $35e7b389374acc05$var$push($35e7b389374acc05$var$timerQueue, priorityLevel), null === $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue) && priorityLevel === $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue) && ($35e7b389374acc05$var$isHostTimeoutScheduled ? ($35e7b389374acc05$var$localClearTimeout($35e7b389374acc05$var$taskTimeoutID), $35e7b389374acc05$var$taskTimeoutID = -1) : $35e7b389374acc05$var$isHostTimeoutScheduled = !0, $35e7b389374acc05$var$requestHostTimeout($35e7b389374acc05$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $35e7b389374acc05$var$push($35e7b389374acc05$var$taskQueue, priorityLevel), $35e7b389374acc05$var$isHostCallbackScheduled || $35e7b389374acc05$var$isPerformingWork || ($35e7b389374acc05$var$isHostCallbackScheduled = !0, $35e7b389374acc05$var$requestHostCallback()));
    return priorityLevel;
};
$35e7b389374acc05$export$b5836b71941fa3ed = $35e7b389374acc05$var$shouldYieldToHost;
$35e7b389374acc05$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
        $35e7b389374acc05$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bjR3q"));

});

parcelRegister("6afFj", function(module, exports) {
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("41dBC"));

});
parcelRegister("41dBC", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0; }, function (v) { return $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $2ed1cf3ec43ffc9d$export$d39a5bbd09211389; }, function (v) { return $2ed1cf3ec43ffc9d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4; }, function (v) { return $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be; }, function (v) { return $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $2ed1cf3ec43ffc9d$export$7292efcadded39f3; }, function (v) { return $2ed1cf3ec43ffc9d$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $2ed1cf3ec43ffc9d$export$da407abadb9b8f86; }, function (v) { return $2ed1cf3ec43ffc9d$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $2ed1cf3ec43ffc9d$export$314cfea32580671c; }, function (v) { return $2ed1cf3ec43ffc9d$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $2ed1cf3ec43ffc9d$export$513ccb98c53b8039; }, function (v) { return $2ed1cf3ec43ffc9d$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $2ed1cf3ec43ffc9d$export$dbca993bc2d264a; }, function (v) { return $2ed1cf3ec43ffc9d$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $2ed1cf3ec43ffc9d$export$4797a8006f0655d0; }, function (v) { return $2ed1cf3ec43ffc9d$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1; }, function (v) { return $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6; }, function (v) { return $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e; }, function (v) { return $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $2ed1cf3ec43ffc9d$export$83d89fbfd8236492; }, function (v) { return $2ed1cf3ec43ffc9d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0;
var $2ed1cf3ec43ffc9d$export$d39a5bbd09211389;
var $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4;
var $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be;
var $2ed1cf3ec43ffc9d$export$7292efcadded39f3;
var $2ed1cf3ec43ffc9d$export$da407abadb9b8f86;
var $2ed1cf3ec43ffc9d$export$314cfea32580671c;
var $2ed1cf3ec43ffc9d$export$513ccb98c53b8039;
var $2ed1cf3ec43ffc9d$export$dbca993bc2d264a;
var $2ed1cf3ec43ffc9d$export$4797a8006f0655d0;
var $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1;
var $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6;
var $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e;
var $2ed1cf3ec43ffc9d$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $2ed1cf3ec43ffc9d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2ed1cf3ec43ffc9d$var$noop() {}
var $2ed1cf3ec43ffc9d$var$Internals = {
    d: {
        f: $2ed1cf3ec43ffc9d$var$noop,
        r: function() {
            throw Error($2ed1cf3ec43ffc9d$var$formatProdErrorMessage(522));
        },
        D: $2ed1cf3ec43ffc9d$var$noop,
        C: $2ed1cf3ec43ffc9d$var$noop,
        L: $2ed1cf3ec43ffc9d$var$noop,
        m: $2ed1cf3ec43ffc9d$var$noop,
        X: $2ed1cf3ec43ffc9d$var$noop,
        S: $2ed1cf3ec43ffc9d$var$noop,
        M: $2ed1cf3ec43ffc9d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $2ed1cf3ec43ffc9d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $2ed1cf3ec43ffc9d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2ed1cf3ec43ffc9d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $2ed1cf3ec43ffc9d$var$ReactSharedInternals = $bh6RR.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0 = $2ed1cf3ec43ffc9d$var$Internals;
$2ed1cf3ec43ffc9d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($2ed1cf3ec43ffc9d$var$formatProdErrorMessage(299));
    return $2ed1cf3ec43ffc9d$var$createPortal$1(children, container, null, key);
};
$2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $2ed1cf3ec43ffc9d$var$ReactSharedInternals.T, previousUpdatePriority = $2ed1cf3ec43ffc9d$var$Internals.p;
    try {
        if ($2ed1cf3ec43ffc9d$var$ReactSharedInternals.T = null, $2ed1cf3ec43ffc9d$var$Internals.p = 2, fn) return fn();
    } finally{
        $2ed1cf3ec43ffc9d$var$ReactSharedInternals.T = previousTransition, $2ed1cf3ec43ffc9d$var$Internals.p = previousUpdatePriority, $2ed1cf3ec43ffc9d$var$Internals.d.f();
    }
};
$2ed1cf3ec43ffc9d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $2ed1cf3ec43ffc9d$var$Internals.d.C(href, options));
};
$2ed1cf3ec43ffc9d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $2ed1cf3ec43ffc9d$var$Internals.d.D(href);
};
$2ed1cf3ec43ffc9d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $2ed1cf3ec43ffc9d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $2ed1cf3ec43ffc9d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$2ed1cf3ec43ffc9d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $2ed1cf3ec43ffc9d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $2ed1cf3ec43ffc9d$var$Internals.d.M(href);
    }
};
$2ed1cf3ec43ffc9d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $2ed1cf3ec43ffc9d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$2ed1cf3ec43ffc9d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $2ed1cf3ec43ffc9d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $2ed1cf3ec43ffc9d$var$Internals.d.m(href);
    }
};
$2ed1cf3ec43ffc9d$export$4797a8006f0655d0 = function(form) {
    $2ed1cf3ec43ffc9d$var$Internals.d.r(form);
};
$2ed1cf3ec43ffc9d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $2ed1cf3ec43ffc9d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e = function() {
    return $2ed1cf3ec43ffc9d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$2ed1cf3ec43ffc9d$export$83d89fbfd8236492 = "19.0.0";

});



var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("kyM0p"));


parcelRequire("bh6RR");
var $6fc264ec92100d3a$exports = {};
"use strict";
function $6fc264ec92100d3a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6fc264ec92100d3a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6fc264ec92100d3a$var$checkDCE();

$6fc264ec92100d3a$exports = (parcelRequire("jpRqs"));




var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
const $6531107febf5e71a$export$4812e460280c6ef2 = (arr)=>{
    return arr[Math.floor(Math.random() * arr.length)];
};
const $6531107febf5e71a$export$d02631cccf789723 = (start, end, step = 1)=>{
    let output = [];
    if (typeof end === "undefined") {
        end = start;
        start = 0;
    }
    for(let i = start; i < end; i += step)output.push(i);
    return output;
};




var $bh6RR = parcelRequire("bh6RR");

parcelRequire("bh6RR");
var $ccf7f5abc608fcbf$exports = {};
$ccf7f5abc608fcbf$exports = new URL("bug.6faf8eea.svg", import.meta.url).toString();


var $7dbf82526e9c4065$exports = {};
$7dbf82526e9c4065$exports = new URL("dark.8bc30bce.svg", import.meta.url).toString();


var $83d7f6fdd0a06b79$exports = {};
$83d7f6fdd0a06b79$exports = new URL("dragon.d4af5e08.svg", import.meta.url).toString();


var $997d6560980d8946$exports = {};
$997d6560980d8946$exports = new URL("electric.bd428d9b.svg", import.meta.url).toString();


var $101b4f5b31def46b$exports = {};
$101b4f5b31def46b$exports = new URL("fairy.299d8f1d.svg", import.meta.url).toString();


var $7f421e794686dc69$exports = {};
$7f421e794686dc69$exports = new URL("fighting.9c02ca4c.svg", import.meta.url).toString();


var $19bde693424c6ee1$exports = {};
$19bde693424c6ee1$exports = new URL("fire.489dbe6e.svg", import.meta.url).toString();


var $897ce9b9c4b55d8e$exports = {};
$897ce9b9c4b55d8e$exports = new URL("flying.fcdef7c2.svg", import.meta.url).toString();


var $d92a4b263127ef83$exports = {};
$d92a4b263127ef83$exports = new URL("ghost.6958c727.svg", import.meta.url).toString();


var $4d8cfe6318c78367$exports = {};
$4d8cfe6318c78367$exports = new URL("grass.e9c9f6fe.svg", import.meta.url).toString();


var $6fd87752f4aa76bf$exports = {};
$6fd87752f4aa76bf$exports = new URL("ground.59f160ef.svg", import.meta.url).toString();


var $d3250f3f7b2b267d$exports = {};
$d3250f3f7b2b267d$exports = new URL("ice.c039ae21.svg", import.meta.url).toString();


var $6765eaf6bca96037$exports = {};
$6765eaf6bca96037$exports = new URL("normal.e46214df.svg", import.meta.url).toString();


var $607dc5d73fba9e81$exports = {};
$607dc5d73fba9e81$exports = new URL("poison.2bc9058f.svg", import.meta.url).toString();


var $811305c1ece9b628$exports = {};
$811305c1ece9b628$exports = new URL("psychic.ac39bc34.svg", import.meta.url).toString();


var $ef0a6d9d0524572d$exports = {};
$ef0a6d9d0524572d$exports = new URL("rock.62035363.svg", import.meta.url).toString();


var $3d351901386d5ba4$exports = {};
$3d351901386d5ba4$exports = new URL("steel.00b8f038.svg", import.meta.url).toString();


var $1bc9dd048568138f$exports = {};
$1bc9dd048568138f$exports = new URL("water.5709d703.svg", import.meta.url).toString();


// Type icon mapping
const $653dbffadcea7caf$var$typeIcons = {
    bug: (0, (/*@__PURE__*/$parcel$interopDefault($ccf7f5abc608fcbf$exports))),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($7dbf82526e9c4065$exports))),
    dragon: (0, (/*@__PURE__*/$parcel$interopDefault($83d7f6fdd0a06b79$exports))),
    electric: (0, (/*@__PURE__*/$parcel$interopDefault($997d6560980d8946$exports))),
    fairy: (0, (/*@__PURE__*/$parcel$interopDefault($101b4f5b31def46b$exports))),
    fighting: (0, (/*@__PURE__*/$parcel$interopDefault($7f421e794686dc69$exports))),
    fire: (0, (/*@__PURE__*/$parcel$interopDefault($19bde693424c6ee1$exports))),
    flying: (0, (/*@__PURE__*/$parcel$interopDefault($897ce9b9c4b55d8e$exports))),
    ghost: (0, (/*@__PURE__*/$parcel$interopDefault($d92a4b263127ef83$exports))),
    grass: (0, (/*@__PURE__*/$parcel$interopDefault($4d8cfe6318c78367$exports))),
    ground: (0, (/*@__PURE__*/$parcel$interopDefault($6fd87752f4aa76bf$exports))),
    ice: (0, (/*@__PURE__*/$parcel$interopDefault($d3250f3f7b2b267d$exports))),
    normal: (0, (/*@__PURE__*/$parcel$interopDefault($6765eaf6bca96037$exports))),
    poison: (0, (/*@__PURE__*/$parcel$interopDefault($607dc5d73fba9e81$exports))),
    psychic: (0, (/*@__PURE__*/$parcel$interopDefault($811305c1ece9b628$exports))),
    rock: (0, (/*@__PURE__*/$parcel$interopDefault($ef0a6d9d0524572d$exports))),
    steel: (0, (/*@__PURE__*/$parcel$interopDefault($3d351901386d5ba4$exports))),
    water: (0, (/*@__PURE__*/$parcel$interopDefault($1bc9dd048568138f$exports)))
};
// Type color mapping (matching existing CSS type badge colors)
const $653dbffadcea7caf$var$typeColors = {
    bug: {
        bg: "#9FB93C",
        text: "#000000"
    },
    dark: {
        bg: "#3A2F6B",
        text: "#FFFFFF"
    },
    dragon: {
        bg: "#D6AF3F",
        text: "#000000"
    },
    electric: {
        bg: "#F6D64A",
        text: "#000000"
    },
    fairy: {
        bg: "#F0A8C0",
        text: "#000000"
    },
    fighting: {
        bg: "#4A3F3F",
        text: "#FFFFFF"
    },
    fire: {
        bg: "#F0802A",
        text: "#000000"
    },
    flying: {
        bg: "#7DB6D6",
        text: "#000000"
    },
    ghost: {
        bg: "#7A64A8",
        text: "#FFFFFF"
    },
    grass: {
        bg: "#6FC24A",
        text: "#000000"
    },
    ground: {
        bg: "#B0813A",
        text: "#FFFFFF"
    },
    ice: {
        bg: "#6BC7C7",
        text: "#000000"
    },
    normal: {
        bg: "#9A9AA0",
        text: "#000000"
    },
    poison: {
        bg: "#9B4AA3",
        text: "#FFFFFF"
    },
    psychic: {
        bg: "#453075",
        text: "#FFFFFF"
    },
    rock: {
        bg: "#6B5555",
        text: "#FFFFFF"
    },
    steel: {
        bg: "#C4C6DD",
        text: "#000000"
    },
    water: {
        bg: "#2B63C6",
        text: "#FFFFFF"
    }
};
/**
 * TypeBadge Component
 * @param {string} type - The Pokemon type name
 * @param {string} variant - 'full' (icon + text), 'mini' (icon only), 'circular' (small circular icon)
 * @param {string} size - 'small', 'medium', 'large' (for different icon sizes)
 */ function $653dbffadcea7caf$var$TypeBadge({ type: type, variant: variant = "full", size: size = "medium" }) {
    const typeInfo = $653dbffadcea7caf$var$typeColors[type.toLowerCase()];
    const icon = $653dbffadcea7caf$var$typeIcons[type.toLowerCase()];
    if (!typeInfo || !icon) {
        console.warn(`Unknown type: ${type}`);
        return null;
    }
    const iconSizes = {
        small: "12px",
        medium: "16px",
        large: "20px"
    };
    const iconSize = iconSizes[size];
    if (variant === "circular") return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "type-badge-circular",
        style: {
            backgroundColor: typeInfo.bg,
            width: iconSize === "12px" ? "18px" : iconSize === "16px" ? "24px" : "30px",
            height: iconSize === "12px" ? "18px" : iconSize === "16px" ? "24px" : "30px",
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2px"
        },
        title: type.charAt(0).toUpperCase() + type.slice(1),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: icon,
            alt: type,
            style: {
                width: iconSize,
                height: iconSize,
                filter: typeInfo.text === "#000000" ? "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)" : "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)"
            }
        })
    });
    if (variant === "mini") return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
        className: "type-badge-mini",
        style: {
            backgroundColor: typeInfo.bg,
            color: typeInfo.text,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px",
            borderRadius: "6px",
            minWidth: iconSize === "12px" ? "20px" : iconSize === "16px" ? "26px" : "32px",
            height: iconSize === "12px" ? "20px" : iconSize === "16px" ? "26px" : "32px"
        },
        title: type.charAt(0).toUpperCase() + type.slice(1),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: icon,
            alt: type,
            style: {
                width: iconSize,
                height: iconSize,
                filter: typeInfo.text === "#000000" ? "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)" : "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)"
            }
        })
    });
    // Full variant - icon + text
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
        className: "type-badge-full",
        style: {
            backgroundColor: typeInfo.bg,
            color: typeInfo.text,
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            padding: "4px 8px",
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: "600",
            textTransform: "capitalize"
        },
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: icon,
                alt: type,
                style: {
                    width: iconSize,
                    height: iconSize,
                    filter: typeInfo.text === "#000000" ? "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)" : "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)"
                }
            }),
            type
        ]
    });
}
var $653dbffadcea7caf$export$2e2bcd8739ae039 = $653dbffadcea7caf$var$TypeBadge;




var $f4c4337c26d2b8c9$exports = {};
$f4c4337c26d2b8c9$exports = new URL("pokeball.c2056cd9.svg", import.meta.url).toString();


var $2609244a3cbe5545$exports = {};
$2609244a3cbe5545$exports = new URL("arrow-up.ea242b2e.svg", import.meta.url).toString();


// Sound Manager for Squirtle Wordle
var $2b1455e58ae6cd61$exports = {};
$2b1455e58ae6cd61$exports = new URL("button-hover.14a2f169.mp3", import.meta.url).toString();


var $34b8bfd900326d9e$exports = {};
$34b8bfd900326d9e$exports = new URL("button-click.eea41c69.mp3", import.meta.url).toString();


var $01e67e0c30fe5079$exports = {};
$01e67e0c30fe5079$exports = new URL("button-click-2.8e976cea.mp3", import.meta.url).toString();


var $223a76e332b08900$exports = {};
$223a76e332b08900$exports = new URL("button-click-3.01fc2c2f.mp3", import.meta.url).toString();


var $959c6d796cc93d16$exports = {};
$959c6d796cc93d16$exports = new URL("click.2e9bd1e0.mp3", import.meta.url).toString();


var $dc8bdc10054df79e$exports = {};
$dc8bdc10054df79e$exports = new URL("click2.cf3bd378.mp3", import.meta.url).toString();


var $c135dde059acf366$exports = {};
$c135dde059acf366$exports = new URL("input-hover.0d6597e2.mp3", import.meta.url).toString();


var $7b7ffb4c1ad90765$exports = {};
$7b7ffb4c1ad90765$exports = new URL("input-click.38b544f7.mp3", import.meta.url).toString();


var $6b3de025782687f8$exports = {};
$6b3de025782687f8$exports = new URL("bubble-hover.0aa30f47.mp3", import.meta.url).toString();


var $f02809fd68e1da98$exports = {};
$f02809fd68e1da98$exports = new URL("grid-click.da1ab500.mp3", import.meta.url).toString();


var $3b317dc6bc2061f9$exports = {};
$3b317dc6bc2061f9$exports = new URL("slider-on.c41da418.mp3", import.meta.url).toString();


var $300287ff78e50831$exports = {};
$300287ff78e50831$exports = new URL("slider-off.b29caee4.mp3", import.meta.url).toString();


var $1642c32cf2b24097$exports = {};
$1642c32cf2b24097$exports = new URL("guess-success.3fd245a2.mp3", import.meta.url).toString();


var $f9545120b7262c1a$exports = {};
$f9545120b7262c1a$exports = new URL("guess-wrong.6ac24946.mp3", import.meta.url).toString();


var $e064171eaff16570$exports = {};
$e064171eaff16570$exports = new URL("guess-lost.1ec76cfe.mp3", import.meta.url).toString();


var $a8ed052851ed8295$exports = {};
$a8ed052851ed8295$exports = new URL("caught-a-pokemon.89f79be1.mp3", import.meta.url).toString();


var $8ea42f2ed1e9cda1$exports = {};
$8ea42f2ed1e9cda1$exports = new URL("pokemon-runaway.5e95afcc.mp3", import.meta.url).toString();


var $5ceb0915630f01de$exports = {};
$5ceb0915630f01de$exports = new URL("pokedex-open-after-catch.ea87b5da.mp3", import.meta.url).toString();


var $387719f52c88c499$exports = {};
$387719f52c88c499$exports = new URL("victory-beat.15cdfa6a.mp3", import.meta.url).toString();


var $998ed7abd0ae1e98$exports = {};
$998ed7abd0ae1e98$exports = new URL("gameboy-sound.89da7408.mp3", import.meta.url).toString();


class $5832135ea2ff6ecf$var$SoundManager {
    constructor(){
        this.sounds = {
            buttonHover: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($2b1455e58ae6cd61$exports)))),
            buttonClick: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($34b8bfd900326d9e$exports)))),
            buttonClick2: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($01e67e0c30fe5079$exports)))),
            buttonClick3: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($223a76e332b08900$exports)))),
            click: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($959c6d796cc93d16$exports)))),
            click2: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($dc8bdc10054df79e$exports)))),
            inputHover: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($c135dde059acf366$exports)))),
            inputClick: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($7b7ffb4c1ad90765$exports)))),
            bubbleHover: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($6b3de025782687f8$exports)))),
            gridClick: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($f02809fd68e1da98$exports)))),
            sliderOn: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($3b317dc6bc2061f9$exports)))),
            sliderOff: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($300287ff78e50831$exports)))),
            guessSuccess: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($1642c32cf2b24097$exports)))),
            guessWrong: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($f9545120b7262c1a$exports)))),
            guessLost: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($e064171eaff16570$exports)))),
            caughtAPokemon: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($a8ed052851ed8295$exports)))),
            pokemonRunaway: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($8ea42f2ed1e9cda1$exports)))),
            pokedexOpenAfterCatch: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($5ceb0915630f01de$exports)))),
            victoryBeat: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($387719f52c88c499$exports)))),
            gameboySound: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($998ed7abd0ae1e98$exports))))
        };
        // Set volumes for better balance
        this.sounds.buttonHover.volume = 1;
        this.sounds.buttonClick.volume = 0.25;
        this.sounds.buttonClick2.volume = 0.4;
        this.sounds.buttonClick3.volume = 0.4;
        this.sounds.click.volume = 0.1;
        this.sounds.click2.volume = 0.4;
        this.sounds.inputHover.volume = 0.3;
        this.sounds.inputClick.volume = 0.35;
        this.sounds.bubbleHover.volume = 0.3;
        this.sounds.gridClick.volume = 0.3;
        this.sounds.sliderOn.volume = 0.4;
        this.sounds.sliderOff.volume = 0.4;
        this.sounds.guessSuccess.volume = 0.7;
        this.sounds.guessWrong.volume = 1;
        this.sounds.guessLost.volume = 0.25;
        this.sounds.caughtAPokemon.volume = 0.8;
        this.sounds.pokemonRunaway.volume = 0.7;
        this.sounds.pokedexOpenAfterCatch.volume = 0.6;
        this.sounds.victoryBeat.volume = 0.7;
        this.sounds.gameboySound.volume = 0.2;
        // Loop victory beat
        this.sounds.victoryBeat.loop = true;
        this.isMuted = this.loadMutedState();
        this.classicSoundsEnabled = true;
        this.currentBgMusic = null;
    }
    loadMutedState() {
        try {
            const stored = localStorage.getItem("sound-muted");
            return stored === "true";
        } catch  {
            return false;
        }
    }
    saveMutedState() {
        try {
            localStorage.setItem("sound-muted", this.isMuted.toString());
        } catch  {
        // Ignore localStorage errors
        }
    }
    toggleMute() {
        this.isMuted = !this.isMuted;
        this.saveMutedState();
        // Stop any currently playing background music if muting
        if (this.isMuted && this.currentBgMusic) this.stopBackgroundMusic();
        return this.isMuted;
    }
    setClassicSounds(enabled) {
        this.classicSoundsEnabled = enabled;
    }
    play(soundName, options = {}) {
        if (this.isMuted) return;
        const sound = this.sounds[soundName];
        if (!sound) return;
        // Stop and reset the sound
        sound.currentTime = 0;
        // Play the sound
        const playPromise = sound.play();
        // Handle play promise (some browsers require user interaction first)
        if (playPromise !== undefined) playPromise.catch((error)=>{
            // Auto-play was prevented, which is normal on first load
            console.log("Sound play prevented:", error);
        });
        return playPromise;
    }
    playSequence(soundNames, delay = 500) {
        if (this.isMuted) return;
        soundNames.forEach((soundName, index)=>{
            setTimeout(()=>{
                this.play(soundName);
            }, index * delay);
        });
    }
    playBackgroundMusic(soundName) {
        if (this.isMuted) return;
        // Stop any current background music
        this.stopBackgroundMusic();
        this.currentBgMusic = soundName;
        const sound = this.sounds[soundName];
        if (sound) {
            sound.currentTime = 0;
            const playPromise = sound.play();
            if (playPromise !== undefined) playPromise.catch((error)=>{
                console.log("Background music play prevented:", error);
            });
        }
    }
    stopBackgroundMusic() {
        if (this.currentBgMusic) {
            const sound = this.sounds[this.currentBgMusic];
            if (sound) {
                sound.pause();
                sound.currentTime = 0;
            }
            this.currentBgMusic = null;
        }
    }
    stop(soundName) {
        const sound = this.sounds[soundName];
        if (sound) {
            sound.pause();
            sound.currentTime = 0;
        }
    }
    // Convenience methods for specific game events
    playButtonHover() {
        this.play("buttonHover");
    }
    playButtonClick() {
        this.play("buttonClick");
    }
    playModalDismiss() {
        this.play("buttonClick2");
    }
    playFilterHover() {
        this.play("click");
    }
    playFilterClick() {
        this.play("click2");
    }
    playInputHover() {
        this.play("inputHover");
    }
    playInputClick() {
        this.play("inputClick");
    }
    playButtonClick3() {
        this.play("buttonClick3");
    }
    playSliderOn() {
        this.play("sliderOn");
    }
    playSliderOff() {
        this.play("sliderOff");
    }
    playBubbleHover() {
        this.play("bubbleHover");
    }
    playGridClick() {
        this.play("gridClick");
    }
    playCorrectGuess() {
        this.play("guessSuccess");
    }
    playWrongGuess() {
        this.play("guessWrong");
    }
    playGameLost() {
        this.play("guessLost");
    }
    playPokemonCaught() {
        // Only play if classic sounds are enabled
        if (this.classicSoundsEnabled) // Play after a short delay to let guess-success finish
        setTimeout(()=>{
            this.playPokemonCaughtSound();
        }, 800);
    }
    playPokemonRunaway() {
        // Play during the Pokemon shaking/fading animation (2.5s after game over)
        setTimeout(()=>{
            this.play("pokemonRunaway");
        }, 2500);
    }
    playPokemonCaughtSound() {
        // Direct sound play for when pokemon is caught, used within timeouts
        if (this.classicSoundsEnabled) this.play("caughtAPokemon");
    }
    playPokedexOpenSound() {
        // Direct sound play for when pokedex opens, used within timeouts
        if (this.classicSoundsEnabled && !this.currentBgMusic) this.play("pokedexOpenAfterCatch");
        else this.playGridClick(); // Fallback sound if pokedex open sound is not played
    }
    playPokedexOpen() {
        // Legacy method - kept for compatibility but should not set its own timeout
        // Use playPokedexOpenSound() directly in timeout callbacks instead
        if (this.classicSoundsEnabled && !this.currentBgMusic) this.play("pokedexOpenAfterCatch");
    }
    playVictoryBeat() {
        this.playBackgroundMusic("victoryBeat");
    }
    stopVictoryBeat() {
        if (this.currentBgMusic === "victoryBeat") this.stopBackgroundMusic();
    }
    playGameboySound() {
        this.play("gameboySound");
    }
}
// Create singleton instance
const $5832135ea2ff6ecf$var$soundManager = new $5832135ea2ff6ecf$var$SoundManager();
var $5832135ea2ff6ecf$export$2e2bcd8739ae039 = $5832135ea2ff6ecf$var$soundManager;


function $6ec98fc3683ca416$var$GuessInput({ onGuess: onGuess, gameIsOver: gameIsOver, answerLength: answerLength, pokemonTypes: pokemonTypes, isLoadingHint: isLoadingHint }) {
    const [pendingGuess, setPendingGuess] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    function handleSubmit(event) {
        event.preventDefault();
        // Only require at least one letter, allow partial guesses
        if (pendingGuess.length === 0) return; // Don't submit empty guesses
        console.log("Guess:", pendingGuess);
        setPendingGuess("");
        onGuess(pendingGuess);
    }
    function handleInputChange(e) {
        const value = e.target.value.toLocaleUpperCase().trim().slice(0, answerLength);
        setPendingGuess(value);
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("form", {
        className: "guess-input-wrapper",
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("label", {
                htmlFor: "guess-input",
                children: "Guess the Pok\xe9mon:"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "guess-input-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                        id: "guess-input",
                        type: "text",
                        value: pendingGuess,
                        autoComplete: "off",
                        autoFocus: true,
                        onChange: handleInputChange,
                        onFocus: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playInputClick(),
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playInputHover(),
                        pattern: `[A-Za-z]{1,${answerLength}}`,
                        disabled: gameIsOver
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        type: "submit",
                        className: "guess-submit-button",
                        disabled: pendingGuess.length === 0 || gameIsOver,
                        onClick: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick3(),
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                        title: "Submit guess (or press Enter)",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2609244a3cbe5545$exports))),
                            alt: "Submit",
                            style: {
                                width: "20px",
                                height: "20px",
                                filter: "brightness(0) invert(1)"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "type-hint",
                children: [
                    "Guess the ",
                    answerLength,
                    "-letter",
                    isLoadingHint ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "mini-pokeball-loader",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f4c4337c26d2b8c9$exports))),
                            alt: "Loading...",
                            className: "mini-pokeball-icon"
                        })
                    }) : pokemonTypes && pokemonTypes.length > 0 ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "type-badges inline",
                        children: pokemonTypes.map((typeInfo, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $653dbffadcea7caf$export$2e2bcd8739ae039), {
                                type: typeInfo.name,
                                variant: "full",
                                size: "medium"
                            }, index))
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "type-badge unknown",
                        children: "unknown type"
                    }),
                    "Pok\xe9mon"
                ]
            })
        ]
    });
}
var $6ec98fc3683ca416$export$2e2bcd8739ae039 = $6ec98fc3683ca416$var$GuessInput;



parcelRequire("bh6RR");
const $41f8a5367d186866$export$5c6373d26cb292a9 = 6;




function $1468913028eb270f$var$GuessDisplay({ guesses: guesses, answerLength: answerLength }) {
    function getDescForLetterStatus(status) {
        switch(status){
            case "correct":
                return "Nailed it.";
            case "misplaced":
                return "Right letter, wrong spot.";
            case "incorrect":
                return "Not in the word.";
            default:
                return "";
        }
    }
    // Use the actual answer length if provided, otherwise default to 5
    const wordLength = answerLength || 5;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "guess-results",
        children: (0, $6531107febf5e71a$export$d02631cccf789723)(0, (0, $41f8a5367d186866$export$5c6373d26cb292a9)).map((index)=>{
            const guess = guesses[index];
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "guess",
                children: (0, $6531107febf5e71a$export$d02631cccf789723)(0, wordLength).map((i)=>{
                    const letter = guess?.letters[i];
                    const helpText = letter ? getDescForLetterStatus(letter.status) : "";
                    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        title: helpText,
                        className: `cell ${letter?.status}`,
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                        children: letter?.letter || ""
                    }, i);
                })
            }, index);
        })
    });
}
var $1468913028eb270f$export$2e2bcd8739ae039 = $1468913028eb270f$var$GuessDisplay;




var $bh6RR = parcelRequire("bh6RR");
var $f8deddc759b115bb$exports = {};
$f8deddc759b115bb$exports = new URL("refresh.e075aec8.svg", import.meta.url).toString();



var $e24ec61e52fbfcb2$exports = {};
$e24ec61e52fbfcb2$exports = new URL("pokeball-open.ac59824d.svg", import.meta.url).toString();



function $6f6cf86d14dadb4e$var$GameResult({ answer: answer, gameIsWon: gameIsWon, guessCount: guessCount, reset: reset, pokemonId: pokemonId, pokemonName: pokemonName, isNewDiscovery: isNewDiscovery, onOpenPokedex: onOpenPokedex, onClose: onClose, catchCount: catchCount }, ref) {
    const [animationKey, setAnimationKey] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [pokemonCry, setPokemonCry] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [isLoadingCry, setIsLoadingCry] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const playAgainButtonRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    // Expose focus method via ref so parent can restore focus when Pokedex closes
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useImperativeHandle(ref, ()=>({
            focus: ()=>{
                playAgainButtonRef.current?.focus();
            }
        }));
    // Auto-focus play again button when result is shown
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        playAgainButtonRef.current?.focus();
    }, []);
    // Handle Enter key press to play again
    const handleKeyPress = (e)=>{
        if (e.key === "Enter" && playAgainButtonRef.current === document.activeElement) {
            e.preventDefault();
            (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick3();
            reset();
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        window.addEventListener("keydown", handleKeyPress);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, [
        reset
    ]);
    const handlePokeballClick = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick3();
        setAnimationKey((prev)=>prev + 1);
    };
    // Function to fetch and cache Pokemon cry
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (pokemonId) fetchPokemonCry(pokemonId);
        else {
            // Clean up audio when no Pokemon ID
            if (pokemonCry) {
                pokemonCry.pause();
                pokemonCry.src = "";
                pokemonCry.load();
            }
            setPokemonCry(null);
            setIsLoadingCry(false);
        }
        // Cleanup function
        return ()=>{
            if (pokemonCry) {
                pokemonCry.pause();
                pokemonCry.src = "";
                pokemonCry.load();
            }
        };
    }, [
        pokemonId
    ]);
    const fetchPokemonCry = async (id)=>{
        if (isLoadingCry) return; // Don't fetch if already loading
        // Clean up previous audio
        if (pokemonCry) {
            pokemonCry.pause();
            pokemonCry.src = "";
            pokemonCry.load();
        }
        setIsLoadingCry(true);
        setPokemonCry(null);
        try {
            const cryUrl = `https://raw.githubusercontent.com/PokeAPI/cries/main/cries/pokemon/latest/${id}.ogg`;
            const audio = new Audio();
            audio.crossOrigin = "anonymous";
            audio.preload = "auto";
            audio.volume = 0.2; // Set Pokemon cry volume to 50%
            // Wait for audio to be ready
            await new Promise((resolve, reject)=>{
                const timeout = setTimeout(()=>{
                    reject(new Error("Audio load timeout"));
                }, 5000);
                const cleanup = ()=>{
                    clearTimeout(timeout);
                    audio.removeEventListener("canplaythrough", onLoad);
                    audio.removeEventListener("loadeddata", onLoad);
                    audio.removeEventListener("error", onError);
                };
                const onLoad = ()=>{
                    cleanup();
                    resolve();
                };
                const onError = (e)=>{
                    cleanup();
                    reject(new Error(`Audio load failed: ${e.type}`));
                };
                audio.addEventListener("canplaythrough", onLoad, {
                    once: true
                });
                audio.addEventListener("loadeddata", onLoad, {
                    once: true
                });
                audio.addEventListener("error", onError, {
                    once: true
                });
                // Set source after event listeners are attached
                audio.src = cryUrl;
            });
            setPokemonCry(audio);
        } catch (error) {
            console.warn(`Failed to load Pokemon cry for ID ${id}:`, error);
            setPokemonCry(null);
        } finally{
            setIsLoadingCry(false);
        }
    };
    const handlePokemonImageClick = ()=>{
        if (pokemonCry && !isLoadingCry) {
            // Reset audio to beginning and play
            pokemonCry.currentTime = 0;
            pokemonCry.play().catch((error)=>{
                console.warn("Failed to play Pokemon cry:", error);
            });
        }
    };
    const getPokemonImageTitle = ()=>{
        if (isLoadingCry) return "Loading Pok\xe9mon cry...";
        if (pokemonCry) return "Click to hear this Pok\xe9mon's cry!";
        return "Pok\xe9mon cry unavailable";
    };
    if (gameIsWon) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "happy banner",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                className: "close-banner-button",
                onClick: ()=>{
                    (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
                    onClose();
                },
                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                children: "\xd7"
            }),
            pokemonId && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${pokemonId}.svg`,
                alt: answer,
                className: `pokemon-result-image ${pokemonCry && !isLoadingCry ? "clickable-pokemon" : ""}`,
                onClick: handlePokemonImageClick,
                title: getPokemonImageTitle(),
                style: {
                    cursor: pokemonCry && !isLoadingCry ? "pointer" : "default"
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "caught-message-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "pokeball-wrapper success",
                        title: "Click to play pokeball animation again",
                        onClick: handlePokeballClick,
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "pokeball-animation-container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f4c4337c26d2b8c9$exports))),
                                    alt: "Pokeball",
                                    className: "pokeball-catch-animation"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "pokeball-catch-circle"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                    className: "pokeball-checkmark",
                                    width: "8",
                                    height: "8",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "white",
                                    strokeWidth: "4",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polyline", {
                                        points: "20,6 9,17 4,12"
                                    })
                                })
                            ]
                        }, `success-${animationKey}`)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        className: "caught-pokemon-message",
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("strong", {
                            children: [
                                "You caught a ",
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    className: "results-pokemon-name",
                                    children: pokemonName || answer
                                }),
                                " in ",
                                guessCount,
                                " guess",
                                guessCount !== 1 ? "es" : "",
                                "!"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                className: "pokedex-link-message",
                children: [
                    catchCount > 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                        children: [
                            "You've caught ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                className: "results-pokemon-name",
                                children: pokemonName || answer
                            }),
                            " ",
                            catchCount,
                            " times."
                        ]
                    }),
                    " ",
                    isNewDiscovery ? "It's been added to your" : "View it in your",
                    " ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        className: "pokedex-link",
                        onClick: ()=>{
                            (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playGridClick();
                            onOpenPokedex && onOpenPokedex(pokemonId);
                        },
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                        type: "button",
                        children: "pok\xe9dex"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                className: "play-again-button",
                ref: playAgainButtonRef,
                onClick: reset,
                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f8deddc759b115bb$exports))),
                        alt: "Refresh",
                        style: {
                            width: "16px",
                            height: "16px",
                            marginRight: "8px"
                        }
                    }),
                    "Play again"
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "sad banner",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                className: "close-banner-button",
                onClick: ()=>{
                    (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
                    onClose();
                },
                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                children: "\xd7"
            }),
            pokemonId && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${pokemonId}.svg`,
                alt: answer,
                className: `pokemon-result-image sad-pokemon-image ${pokemonCry && !isLoadingCry ? "clickable-pokemon" : ""}`,
                onClick: handlePokemonImageClick,
                title: getPokemonImageTitle(),
                style: {
                    cursor: pokemonCry && !isLoadingCry ? "pointer" : "default"
                }
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "failed-message-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "pokeball-wrapper failure",
                        title: "Click to play pokeball animation again",
                        onClick: handlePokeballClick,
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "pokeball-animation-container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f4c4337c26d2b8c9$exports))),
                                    alt: "Pokeball",
                                    className: "pokeball-fail-animation"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e24ec61e52fbfcb2$exports))),
                                    alt: "Open Pokeball",
                                    className: "pokeball-open-animation"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "pokeball-explosion-ring"
                                })
                            ]
                        }, `fail-${animationKey}`)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        children: [
                            "Sorry, the correct answer is ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                children: answer
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                className: "play-again-button",
                ref: playAgainButtonRef,
                onClick: reset,
                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f8deddc759b115bb$exports))),
                        alt: "Refresh",
                        style: {
                            width: "16px",
                            height: "16px",
                            marginRight: "8px"
                        }
                    }),
                    "Play again"
                ]
            })
        ]
    });
}
var $6f6cf86d14dadb4e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef($6f6cf86d14dadb4e$var$GameResult);


/**
 * Thanks to Github user dylano for supplying a more-accurate
 * solving algorithm!
 */ function $b3882d45a1952fce$export$6e90f449c7e09a62(guess, answer) {
    // This constant is a placeholder that indicates we've successfully
    // dealt with this character (it's correct, or misplaced).
    const SOLVED_CHAR = "\u2713";
    if (!guess) return null;
    const guessChars = guess.toUpperCase().split("");
    const answerChars = answer.split("");
    const result = [];
    // Step 1: Look for correct letters.
    for(let i = 0; i < guessChars.length; i++)if (guessChars[i] === answerChars[i]) {
        result[i] = {
            letter: guessChars[i],
            status: "correct"
        };
        answerChars[i] = SOLVED_CHAR;
        guessChars[i] = SOLVED_CHAR;
    }
    // Step 2: look for misplaced letters. If it's not misplaced,
    // it must be incorrect.
    for(let i = 0; i < guessChars.length; i++){
        if (guessChars[i] === SOLVED_CHAR) continue;
        let status = "incorrect";
        const misplacedIndex = answerChars.findIndex((char)=>char === guessChars[i]);
        if (misplacedIndex >= 0) {
            status = "misplaced";
            answerChars[misplacedIndex] = SOLVED_CHAR;
        }
        result[i] = {
            letter: guessChars[i],
            status: status
        };
    }
    return result;
}





// Cache for Pokemon data
let $64dda4da0336267f$var$cachedPokemon = null;
async function $64dda4da0336267f$var$fetchPokemonList() {
    if ($64dda4da0336267f$var$cachedPokemon) return $64dda4da0336267f$var$cachedPokemon;
    // Check localStorage cache first
    const CACHE_KEY = "pokemon-list-cache";
    const CACHE_DURATION = 86400000; // 24 hours in milliseconds
    try {
        const cachedData = localStorage.getItem(CACHE_KEY);
        if (cachedData) {
            const { data: data, timestamp: timestamp } = JSON.parse(cachedData);
            const now = Date.now();
            // Check if cache is still valid (less than 24 hours old)
            if (now - timestamp < CACHE_DURATION) {
                // Check if the cached data has the expected structure with types
                if (data && data.length > 0 && data[0].types) {
                    $64dda4da0336267f$var$cachedPokemon = data;
                    return data;
                } else {
                    // Old cache format detected, clear it
                    console.log("Old cache format detected, clearing cache for compatibility...");
                    localStorage.removeItem(CACHE_KEY);
                    // Also clear the old types cache to start fresh
                    localStorage.removeItem("pokemon-types-cache");
                }
            }
        }
    } catch (error) {
        console.warn("Failed to read from localStorage cache:", error);
        // Clear potentially corrupted cache
        localStorage.removeItem(CACHE_KEY);
        localStorage.removeItem("pokemon-types-cache");
    }
    // Cache is empty or expired, fetch from API
    try {
        const response = await fetch("https://pokeapi.co/api/v2/pokemon-species?limit=151");
        const data = await response.json();
        // Extract basic Pokemon data
        const pokemonBasicData = data.results.map((pokemon, index)=>({
                name: pokemon.name.toUpperCase().replace("-", ""),
                originalName: pokemon.name,
                id: index + 1 // Pokemon IDs are 1-indexed
            }));
        // Try to get existing types from the old cache
        const oldTypesCache = localStorage.getItem("pokemon-types-cache");
        let existingTypes = {};
        if (oldTypesCache) try {
            const { data: typesData } = JSON.parse(oldTypesCache);
            existingTypes = typesData || {};
        } catch (error) {
            console.warn("Failed to parse existing types cache:", error);
        }
        // Fetch types for Pokemon that don't have cached types
        const pokemonData = await Promise.all(pokemonBasicData.map(async (pokemon)=>{
            let types = existingTypes[pokemon.id];
            if (!types) // Fetch types for this Pokemon
            try {
                const typeResponse = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemon.id}`);
                const typeData = await typeResponse.json();
                types = typeData.types.map((typeInfo)=>({
                        name: typeInfo.type.name,
                        slot: typeInfo.slot
                    }));
                // Add a small delay to avoid overwhelming the API
                await new Promise((resolve)=>setTimeout(resolve, 50));
            } catch (error) {
                console.warn(`Failed to fetch types for ${pokemon.name}:`, error);
                types = [
                    {
                        name: "normal",
                        slot: 1
                    }
                ]; // fallback
            }
            return {
                ...pokemon,
                types: types
            };
        }));
        // Cache the complete data with timestamp
        try {
            const cacheData = {
                data: pokemonData,
                timestamp: Date.now()
            };
            localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
            // Also update the types cache with the new data
            const typesCache = {
                data: pokemonData.reduce((acc, pokemon)=>{
                    acc[pokemon.id] = pokemon.types;
                    return acc;
                }, {}),
                timestamp: Date.now()
            };
            localStorage.setItem("pokemon-types-cache", JSON.stringify(typesCache));
        } catch (error) {
            console.warn("Failed to save to localStorage cache:", error);
        }
        $64dda4da0336267f$var$cachedPokemon = pokemonData;
        return pokemonData;
    } catch (error) {
        console.error("Failed to fetch Pokemon:", error);
        // Fallback to some hardcoded Pokemon names
        $64dda4da0336267f$var$cachedPokemon = [
            {
                name: "PIKACHU",
                originalName: "pikachu",
                id: 25,
                types: [
                    {
                        name: "electric",
                        slot: 1
                    }
                ]
            },
            {
                name: "CHARIZARD",
                originalName: "charizard",
                id: 6,
                types: [
                    {
                        name: "fire",
                        slot: 1
                    },
                    {
                        name: "flying",
                        slot: 2
                    }
                ]
            },
            {
                name: "BLASTOISE",
                originalName: "blastoise",
                id: 9,
                types: [
                    {
                        name: "water",
                        slot: 1
                    }
                ]
            },
            {
                name: "VENUSAUR",
                originalName: "venusaur",
                id: 3,
                types: [
                    {
                        name: "grass",
                        slot: 1
                    },
                    {
                        name: "poison",
                        slot: 2
                    }
                ]
            }
        ];
        return $64dda4da0336267f$var$cachedPokemon;
    }
}
async function $64dda4da0336267f$var$fetchPokemonTypes(pokemonId, originalName) {
    const CACHE_KEY = "pokemon-types-cache";
    const CACHE_DURATION = 86400000; // 24 hours
    try {
        // Check if we already have cached types for this Pokemon
        const cachedTypes = localStorage.getItem(CACHE_KEY);
        if (cachedTypes) {
            const { data: data, timestamp: timestamp } = JSON.parse(cachedTypes);
            const now = Date.now();
            if (now - timestamp < CACHE_DURATION && data[pokemonId]) return data[pokemonId];
        }
        // Fetch types from API
        const response = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemonId}`);
        const data = await response.json();
        const types = data.types.map((typeInfo)=>({
                name: typeInfo.type.name,
                slot: typeInfo.slot
            }));
        // Update cache
        try {
            const existingCache = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
            const cacheData = {
                data: {
                    ...existingCache.data,
                    [pokemonId]: types
                },
                timestamp: Date.now()
            };
            localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
        } catch (error) {
            console.warn("Failed to save types to cache:", error);
        }
        return types;
    } catch (error) {
        console.error(`Failed to fetch types for ${originalName}:`, error);
        return [
            {
                name: "normal",
                slot: 1
            }
        ]; // fallback
    }
}
async function $64dda4da0336267f$var$fetchPokemonDescription(originalName) {
    try {
        const response = await fetch(`https://pokeapi.co/api/v2/pokemon-species/${originalName}/`);
        const data = await response.json();
        // Get the first English flavor text entry
        if (data.flavor_text_entries && data.flavor_text_entries.length > 0) {
            const englishEntry = data.flavor_text_entries.find((entry)=>entry.language.name === "en");
            if (englishEntry) // Clean up the text (remove form feeds and newlines, normalize spacing)
            return englishEntry.flavor_text.replace(/\f/g, " ").replace(/\n/g, " ").replace(/\s+/g, " ").trim();
        }
        return "A mysterious Pokemon.";
    } catch (error) {
        console.error("Failed to fetch Pokemon description:", error);
        return "A mysterious Pokemon.";
    }
}
// Helper function to get all unique types from the Pokemon list
function $64dda4da0336267f$export$cd75e89a26d85a6e(pokemonList) {
    const typesSet = new Set();
    pokemonList.forEach((pokemon)=>{
        if (pokemon.types) pokemon.types.forEach((typeInfo)=>{
            typesSet.add(typeInfo.name);
        });
    });
    return Array.from(typesSet).sort();
}
const $64dda4da0336267f$var$Game = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function Game({ onPokemonDiscovered: onPokemonDiscovered, onPokemonListLoaded: onPokemonListLoaded, onOpenPokedex: onOpenPokedex, gameResultRef: gameResultRef, settings: settings }, ref) {
    const [pokemonList, setPokemonList] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [answer, setAnswer] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [currentPokemon, setCurrentPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [pokemonTypes, setPokemonTypes] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [pokemonDescription, setPokemonDescription] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [guesses, setGuesses] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [gameIsOver, setGameIsOver] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [gameIsWon, setGameIsWon] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(true);
    const [isLoadingHint, setIsLoadingHint] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [isNewDiscovery, setIsNewDiscovery] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [catchCount, setCatchCount] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [showBanner, setShowBanner] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(true);
    const [consecutiveRepeats, setConsecutiveRepeats] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const pokedexTimeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
    // Function to select a new Pokemon and get its description
    async function selectNewPokemon(pokemonList) {
        const discoveredPokemon = JSON.parse(localStorage.getItem("discovered-pokemon") || "[]");
        let selectedPokemon;
        // SPECIAL CASE: Force Pikachu (#25) as the first Pokemon for new players
        if (discoveredPokemon.length === 0) {
            selectedPokemon = pokemonList.find((pokemon)=>pokemon.id === 25); // Pikachu
            if (!selectedPokemon) // Fallback if Pikachu not found in list
            selectedPokemon = (0, $6531107febf5e71a$export$4812e460280c6ef2)(pokemonList);
        } else if (settings?.noRepeatPokemon) {
            const uncaughtPokemon = pokemonList.filter((pokemon)=>!discoveredPokemon.includes(pokemon.id));
            if (uncaughtPokemon.length > 0) selectedPokemon = (0, $6531107febf5e71a$export$4812e460280c6ef2)(uncaughtPokemon);
            else // If all Pokemon are caught and no repeat is on, just pick randomly
            selectedPokemon = (0, $6531107febf5e71a$export$4812e460280c6ef2)(pokemonList);
        } else if (consecutiveRepeats >= 3) {
            const uncaughtPokemon = pokemonList.filter((pokemon)=>!discoveredPokemon.includes(pokemon.id));
            if (uncaughtPokemon.length > 0) selectedPokemon = (0, $6531107febf5e71a$export$4812e460280c6ef2)(uncaughtPokemon);
            else // Fallback if all Pokemon are caught
            selectedPokemon = (0, $6531107febf5e71a$export$4812e460280c6ef2)(pokemonList);
        } else selectedPokemon = (0, $6531107febf5e71a$export$4812e460280c6ef2)(pokemonList);
        setCurrentPokemon(selectedPokemon);
        setAnswer(selectedPokemon.name);
        // Check if this Pokemon was previously caught
        const isPreviouslyCaught = discoveredPokemon.includes(selectedPokemon.id);
        // Update consecutive repeat counter (only when no-repeat is disabled)
        if (!settings?.noRepeatPokemon) {
            if (isPreviouslyCaught) setConsecutiveRepeats((prev)=>prev + 1);
            else setConsecutiveRepeats(0); // Reset counter when we get a new Pokemon
        } else setConsecutiveRepeats(0); // Always reset when no-repeat is enabled
        // Load current catch count for this Pokemon
        const catchCounts = JSON.parse(localStorage.getItem("pokemon-catch-counts") || "{}");
        let currentCount = catchCounts[selectedPokemon.id] || 0;
        // If Pokemon has been discovered but no count exists, default to 1
        if (currentCount === 0 && isPreviouslyCaught) currentCount = 1;
        setCatchCount(currentCount);
        // Fetch the description
        const description = await $64dda4da0336267f$var$fetchPokemonDescription(selectedPokemon.originalName);
        setPokemonDescription(description);
        // Fetch types for the selected Pokemon
        setIsLoadingHint(true);
        const types = await $64dda4da0336267f$var$fetchPokemonTypes(selectedPokemon.id, selectedPokemon.originalName);
        setPokemonTypes(types);
        setIsLoadingHint(false);
    }
    // Load Pokemon data on component mount
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        async function loadPokemon() {
            setIsLoading(true);
            const pokemon = await $64dda4da0336267f$var$fetchPokemonList();
            setPokemonList(pokemon);
            if (onPokemonListLoaded) onPokemonListLoaded(pokemon);
            await selectNewPokemon(pokemon);
            setIsLoading(false);
        }
        loadPokemon();
    }, []); // Empty dependency array to only run on mount
    // Update sound manager when settings change
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (settings) (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).setClassicSounds(settings.classicSounds);
    }, [
        settings?.classicSounds
    ]);
    console.info("answer:", answer);
    // Expose handleNewGuess to parent component
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useImperativeHandle(ref, ()=>({
            submitGuess: (guess)=>{
                if (!gameIsOver) handleNewGuess(guess.toUpperCase());
            },
            isGameActive: !gameIsOver
        }));
    function handleNewGuess(newGuess) {
        const letters = (0, $b3882d45a1952fce$export$6e90f449c7e09a62)(newGuess, answer);
        const newGuesses = [
            ...guesses,
            {
                id: crypto.randomUUID(),
                word: newGuess,
                letters: letters
            }
        ];
        setGuesses(newGuesses);
        if (newGuess === answer) {
            (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playCorrectGuess();
            setGameIsOver(true);
            setGameIsWon(true);
            if (currentPokemon) {
                // Check if this was a single guess (first try)
                const wasSingleGuess = newGuesses.length === 1;
                // Get current catch counts
                const catchCounts = JSON.parse(localStorage.getItem("pokemon-catch-counts") || "{}");
                const currentCount = catchCounts[currentPokemon.id] || 0;
                const newCount = currentCount + 1;
                // Update catch count
                catchCounts[currentPokemon.id] = newCount;
                localStorage.setItem("pokemon-catch-counts", JSON.stringify(catchCounts));
                setCatchCount(newCount);
                // Play pokemon caught sound
                (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playPokemonCaught();
                // Check if this is a new discovery
                const discoveredPokemon = JSON.parse(localStorage.getItem("discovered-pokemon") || "[]");
                const wasAlreadyDiscovered = discoveredPokemon.includes(currentPokemon.id);
                setIsNewDiscovery(!wasAlreadyDiscovered);
                if (onPokemonDiscovered) onPokemonDiscovered(currentPokemon.id, wasSingleGuess);
                // Auto-open Pokedex for new discoveries after 3 seconds (if setting is enabled)
                if (!wasAlreadyDiscovered && onOpenPokedex && settings?.autoOpenPokedex) pokedexTimeoutRef.current = setTimeout(()=>{
                    onOpenPokedex(currentPokemon.id);
                    // Only play sound when pokedex actually opens automatically
                    (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playPokedexOpenSound();
                }, 3000); // Wait 3 seconds to let user read the success message
            }
        } else if (newGuesses.length >= 6) {
            (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playGameLost();
            (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playPokemonRunaway();
            setGameIsOver(true);
        } else (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playWrongGuess();
    }
    function resetGame() {
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
        // Cancel pending Pokedex auto-open
        if (pokedexTimeoutRef.current) {
            clearTimeout(pokedexTimeoutRef.current);
            pokedexTimeoutRef.current = null;
        }
        if (pokemonList.length > 0) {
            selectNewPokemon(pokemonList);
            setGuesses([]);
            setGameIsOver(false);
            setGameIsWon(false);
            setIsNewDiscovery(false);
            setCatchCount(0);
            setShowBanner(true);
            setConsecutiveRepeats(0); // Reset consecutive repeat counter
        }
    }
    function closeBanner() {
        // Cancel pending Pokedex auto-open when banner is dismissed
        if (pokedexTimeoutRef.current) {
            clearTimeout(pokedexTimeoutRef.current);
            pokedexTimeoutRef.current = null;
        }
        setShowBanner(false);
    }
    if (isLoading) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: "pokeball-loader",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f4c4337c26d2b8c9$exports))),
            alt: "Loading...",
            className: "pokeball-icon"
        })
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            pokemonDescription && !settings?.hideHints && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "pokemon-hint",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                        children: "Hint:"
                    }),
                    " ",
                    pokemonDescription
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1468913028eb270f$export$2e2bcd8739ae039), {
                guesses: guesses,
                answerLength: answer.length
            }),
            gameIsOver && showBanner && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6f6cf86d14dadb4e$export$2e2bcd8739ae039), {
                ref: gameResultRef,
                answer: answer,
                gameIsWon: gameIsWon,
                guessCount: guesses.length,
                reset: resetGame,
                onClose: closeBanner,
                pokemonId: currentPokemon?.id,
                pokemonName: currentPokemon?.originalName,
                isNewDiscovery: isNewDiscovery,
                onOpenPokedex: onOpenPokedex,
                catchCount: catchCount
            }),
            gameIsOver ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "play-again-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                    className: "primary-button",
                    onClick: resetGame,
                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f8deddc759b115bb$exports))),
                            alt: "Refresh",
                            width: "16",
                            height: "16"
                        }),
                        "Play Again"
                    ]
                })
            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6ec98fc3683ca416$export$2e2bcd8739ae039), {
                onGuess: handleNewGuess,
                gameIsOver: gameIsOver,
                answerLength: answer.length,
                pokemonTypes: pokemonTypes,
                isLoadingHint: isLoadingHint
            })
        ]
    });
});
var $64dda4da0336267f$export$2e2bcd8739ae039 = $64dda4da0336267f$var$Game;






var $bh6RR = parcelRequire("bh6RR");
var $9bfac66bbe4cd983$exports = {};
$9bfac66bbe4cd983$exports = new URL("squirtle.4e7ed10d.png", import.meta.url).toString();


var $938a1d22b1c9462b$exports = {};
$938a1d22b1c9462b$exports = new URL("trainer-scene.60272a68.png", import.meta.url).toString();




var $25c098755f8978e9$exports = {};
$25c098755f8978e9$exports = new URL("elip.7f2a179d.svg", import.meta.url).toString();


var $608c048c830de551$exports = {};
$608c048c830de551$exports = new URL("info.ea2676ac.svg", import.meta.url).toString();


var $14c1cc57e40f25c6$exports = {};
$14c1cc57e40f25c6$exports = new URL("cog.e66e805e.svg", import.meta.url).toString();


var $de07198849c442ae$exports = {};
$de07198849c442ae$exports = new URL("external-link.703a97ab.svg", import.meta.url).toString();


var $94b966749011848c$exports = {};
$94b966749011848c$exports = new URL("volume-on.05b0e7db.svg", import.meta.url).toString();


var $6e8e252235677fad$exports = {};
$6e8e252235677fad$exports = new URL("volume-mute.066deb5c.svg", import.meta.url).toString();



function $02ce57c81a0104d3$var$Header({ onReset: onReset, onOpenPokedex: onOpenPokedex, discoveredCount: discoveredCount, totalCount: totalCount, isMaster: isMaster, isLegend: isLegend, trophyIcon: trophyIcon }) {
    const [showMoreDropdown, setShowMoreDropdown] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [showAboutModal, setShowAboutModal] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [showCreditsScreen, setShowCreditsScreen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [showSettingsModal, setShowSettingsModal] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [showConfirmModal, setShowConfirmModal] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [isMuted, setIsMuted] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState((0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).isMuted);
    const [settings, setSettings] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(()=>{
        try {
            const stored = localStorage.getItem("squirtle-wordle-settings");
            return stored ? JSON.parse(stored) : {
                hideHints: false,
                noRepeatPokemon: false,
                classicSounds: true,
                autoOpenPokedex: true
            };
        } catch  {
            return {
                hideHints: false,
                noRepeatPokemon: false,
                classicSounds: true,
                autoOpenPokedex: true
            };
        }
    });
    const handlePokedexClick = (event)=>{
        event.preventDefault();
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
        if (onOpenPokedex) onOpenPokedex();
    };
    const handleResetClick = (event)=>{
        event.preventDefault();
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
        if (onReset) onReset();
    };
    const handleMoreClick = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
        setShowMoreDropdown(!showMoreDropdown);
    };
    const handleVolumeClick = (event)=>{
        event.preventDefault();
        const newMutedState = (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).toggleMute();
        setIsMuted(newMutedState);
        // Play click sound if we just unmuted
        if (!newMutedState) (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
    };
    const handleAboutClick = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playGameboySound();
        setShowMoreDropdown(false);
        setShowAboutModal(true);
    };
    const handleSettingsClick = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
        setShowMoreDropdown(false);
        setShowSettingsModal(true);
    };
    const handleSettingToggle = (key)=>{
        const newValue = !settings[key];
        // Play appropriate slider sound based on whether turning on or off
        if (newValue) (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playSliderOn();
        else (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playSliderOff();
        const newSettings = {
            ...settings,
            [key]: newValue
        };
        setSettings(newSettings);
        localStorage.setItem("squirtle-wordle-settings", JSON.stringify(newSettings));
        // Dispatch custom event to notify other components
        window.dispatchEvent(new CustomEvent("settingsChanged", {
            detail: newSettings
        }));
    };
    const handleClearData = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
        setShowSettingsModal(false);
        setShowConfirmModal(true);
    };
    const handleConfirmClear = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
        localStorage.removeItem("discovered-pokemon");
        localStorage.removeItem("single-guess-pokemon");
        localStorage.removeItem("pokemon-catch-counts");
        // Keep settings: localStorage.removeItem('squirtle-wordle-settings');
        setShowConfirmModal(false);
        window.location.reload();
    };
    // Close dropdown when clicking outside
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const handleClickOutside = (event)=>{
            if (!event.target.closest(".more-menu-container")) setShowMoreDropdown(false);
        };
        if (showMoreDropdown) {
            document.addEventListener("click", handleClickOutside);
            return ()=>document.removeEventListener("click", handleClickOutside);
        }
    }, [
        showMoreDropdown
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("header", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "side"
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9bfac66bbe4cd983$exports))),
                        alt: "Squirtle"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                        className: "app-name",
                        children: "Squirtle Wordle"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "header-buttons",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "pokemon-count",
                                title: isLegend ? "Pokemon Legend. Guessed all 151 with 1 guess." : `You've caught ${discoveredCount} out of ${totalCount} Pok\xe9mon`,
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                    className: isMaster ? "header-trophy" : "",
                                    style: isLegend ? {
                                        background: "linear-gradient(135deg, #fbbf24, #f59e0b)",
                                        color: "white"
                                    } : {},
                                    children: [
                                        discoveredCount,
                                        "/",
                                        totalCount,
                                        isMaster && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                            src: trophyIcon,
                                            alt: "Pok\xe9mon Master",
                                            className: "trophy-icon"
                                        })
                                    ]
                                })
                            }),
                            onOpenPokedex && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                type: "button",
                                className: "pokedex-button",
                                onClick: handlePokedexClick,
                                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f4c4337c26d2b8c9$exports))),
                                        alt: "Open Pok\xe9dex"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "tooltip",
                                        children: "Open Pok\xe9dex"
                                    })
                                ]
                            }),
                            onReset && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                type: "button",
                                className: "reset-button",
                                onClick: handleResetClick,
                                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f8deddc759b115bb$exports))),
                                        alt: "Reset game"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "tooltip",
                                        children: "Guess a different Pokemon"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                type: "button",
                                className: "volume-button",
                                onClick: handleVolumeClick,
                                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                        src: isMuted ? (0, (/*@__PURE__*/$parcel$interopDefault($6e8e252235677fad$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($94b966749011848c$exports))),
                                        alt: isMuted ? "Unmute sounds" : "Mute sounds"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "tooltip",
                                        children: isMuted ? "Unmute sounds" : "Mute sounds"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "more-menu-container",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                        type: "button",
                                        className: "more-button",
                                        onClick: handleMoreClick,
                                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($25c098755f8978e9$exports))),
                                                alt: "More options"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                className: "tooltip",
                                                children: "More..."
                                            })
                                        ]
                                    }),
                                    showMoreDropdown && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        className: "more-dropdown",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                                onClick: handleAboutClick,
                                                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($608c048c830de551$exports))),
                                                        alt: ""
                                                    }),
                                                    "About"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                                onClick: handleSettingsClick,
                                                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($14c1cc57e40f25c6$exports))),
                                                        alt: ""
                                                    }),
                                                    "Settings"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "side"
            }),
            showAboutModal && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>{
                    (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
                    setShowAboutModal(false);
                    setShowCreditsScreen(false);
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "modal-content about-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: !showCreditsScreen ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "About Squirtle Wordle"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($938a1d22b1c9462b$exports))),
                                alt: "Pokemon Trainer Scene",
                                className: "about-image"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "about-text",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                        children: [
                                            'A Pok\xe9mon guessing game based on Wordle. Inspired by a project from the course "',
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                                href: "https://www.joyofreact.com/",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "Joy of React"
                                            }),
                                            '".'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                                        children: "Catch as many Pokemon as you can, and even better, try to get them in one guess. Use your Pok\xe9dex to track progress."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                className: "primary-button modal-button",
                                onClick: ()=>{
                                    (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
                                    setShowAboutModal(false);
                                    setShowCreditsScreen(false);
                                },
                                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                                children: "Done"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "about-footer",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        className: "built-by-line",
                                        children: [
                                            "Created by ",
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                                href: "https://coryfugate.com",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "Cory Fugate"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($de07198849c442ae$exports))),
                                                alt: "",
                                                className: "about-footer-icon"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "credits-line",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                            className: "credits-link",
                                            onClick: ()=>{
                                                (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                                setShowCreditsScreen(true);
                                            },
                                            children: [
                                                "Sound Credits",
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "chevron",
                                                    children: "\u203A"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                className: "credits-back-button",
                                onClick: ()=>{
                                    (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                    setShowCreditsScreen(false);
                                },
                                children: "\u2039 Back"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                                children: "Sound Credits"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "credits-content",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "credits-intro",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                                            children: "Special thanks to these talented creators from Pixabay.com for their amazing sound effects:"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "credits-list",
                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "skyscraper_seven"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "Universfield"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "FREESOUND-COMMUNITY"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "Viacheslav Starostin"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "Poradovskyi"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "CFL_TurningPages"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "Feora, Lucas Cooper"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "Alphix"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "SoundReality"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "Flora phonic"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                                    children: "R0T0R"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "credits-buttons",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "primary-button modal-button",
                                    onClick: ()=>{
                                        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
                                        setShowAboutModal(false);
                                        setShowCreditsScreen(false);
                                    },
                                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                                    children: "Done"
                                })
                            })
                        ]
                    })
                })
            }),
            showSettingsModal && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>{
                    (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
                    setShowSettingsModal(false);
                },
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "modal-content settings-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h2", {
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($14c1cc57e40f25c6$exports))),
                                    alt: "",
                                    style: {
                                        width: "24px",
                                        height: "24px",
                                        marginRight: "8px",
                                        verticalAlign: "middle"
                                    }
                                }),
                                "Settings"
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "settings-list",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "setting-item",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "setting-label-container",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "setting-label",
                                                    children: "Hide Hints"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "setting-description",
                                                    children: "Hard mode. If turned on, pok\xe9mon description hints won't be given."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            className: "toggle-switch",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: settings.hideHints,
                                                    onChange: ()=>handleSettingToggle("hideHints")
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "slider"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "setting-item",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "setting-label-container",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "setting-label",
                                                    children: "No Repeat Pok\xe9mon"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "setting-description",
                                                    children: "If turned on, you'll only guess Pok\xe9mon you haven't caught yet."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            className: "toggle-switch",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: settings.noRepeatPokemon,
                                                    onChange: ()=>handleSettingToggle("noRepeatPokemon")
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "slider"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "setting-item",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "setting-label-container",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "setting-label",
                                                    children: "Classic Sounds"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "setting-description",
                                                    children: "Play old school pok\xe9mon sounds"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            className: "toggle-switch",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: settings.classicSounds,
                                                    onChange: ()=>handleSettingToggle("classicSounds")
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "slider"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "setting-item",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "setting-label-container",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "setting-label",
                                                    children: "Auto Open Pokedex"
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "setting-description",
                                                    children: "Automatically opens the pokedex when a new pokemon is caught"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("label", {
                                            className: "toggle-switch",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: settings.autoOpenPokedex,
                                                    onChange: ()=>handleSettingToggle("autoOpenPokedex")
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                    className: "slider"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "settings-danger-zone",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "danger-zone-item",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        className: "setting-label-container",
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                className: "setting-label",
                                                children: "Clear All Data"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                className: "setting-description",
                                                children: "Remove all Pok\xe9mon progress and statistics."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                        className: "danger-button",
                                        onClick: handleClearData,
                                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                        children: "Clear data"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: "modal-button primary-button",
                            onClick: ()=>{
                                (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
                                setShowSettingsModal(false);
                            },
                            onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                            children: "Done"
                        })
                    ]
                })
            }),
            showConfirmModal && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "modal-overlay",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "modal-content confirm-modal",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                            children: "Clear All Data"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                            children: "Are you sure you want to delete all progress? This cannot be undone."
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "modal-buttons",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "cancel-button",
                                    onClick: ()=>{
                                        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
                                        setShowConfirmModal(false);
                                    },
                                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                    className: "delete-button",
                                    onClick: handleConfirmClear,
                                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                    children: "Delete"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $02ce57c81a0104d3$export$2e2bcd8739ae039 = $02ce57c81a0104d3$var$Header;






var $bh6RR = parcelRequire("bh6RR");



var $3509963a71bdf3b0$exports = {};
$3509963a71bdf3b0$exports = new URL("search.5f4ae9e4.svg", import.meta.url).toString();


var $7dde8f59b3f46c3f$exports = {};
$7dde8f59b3f46c3f$exports = new URL("share.25d67bb6.svg", import.meta.url).toString();



function $1bb815d3b481b534$var$Pokedex({ isOpen: isOpen, onClose: onClose, pokemonList: pokemonList, discoveredPokemon: discoveredPokemon, singleGuessPokemon: singleGuessPokemon, highlightPokemonId: highlightPokemonId, isMaster: isMaster, trophyIcon: trophyIcon, onSubmitGuess: onSubmitGuess }) {
    const [searchTerm, setSearchTerm] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [pokemonDescriptions, setPokemonDescriptions] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState({});
    const [pokemonTypes, setPokemonTypes] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState({});
    const [selectedPokemon, setSelectedPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [activeFilter, setActiveFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("all");
    const [typeFilter, setTypeFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("all");
    const [hasAutoScrolled, setHasAutoScrolled] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    // Handle closing pokedex with sound cleanup
    const handleClose = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).stop("pokedexOpenAfterCatch");
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
        onClose();
    };
    const [sortBy, setSortBy] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("pokemon id");
    const [showSortDropdown, setShowSortDropdown] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [showTypeDropdown, setShowTypeDropdown] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [catchCounts, setCatchCounts] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState({});
    const [showScrollButton, setShowScrollButton] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [hoveredShareButton, setHoveredShareButton] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [pokemonCry, setPokemonCry] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [isLoadingCry, setIsLoadingCry] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [isMobile, setIsMobile] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [lastTapTime, setLastTapTime] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [lastTappedPokemon, setLastTappedPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const searchInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef();
    const sortDropdownRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef();
    const typeDropdownRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef();
    // Mobile detection
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const checkMobile = ()=>{
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return ()=>window.removeEventListener("resize", checkMobile);
    }, []);
    // Auto-focus search input on desktop when Pokedex opens
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (isOpen && !isMobile && searchInputRef.current) setTimeout(()=>{
            searchInputRef.current.focus();
        }, 300); // Wait for drawer animation
    }, [
        isOpen,
        isMobile
    ]);
    // Close dropdowns when clicking outside
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const handleClickOutside = (event)=>{
            if (sortDropdownRef.current && !sortDropdownRef.current.contains(event.target)) setShowSortDropdown(false);
            if (typeDropdownRef.current && !typeDropdownRef.current.contains(event.target)) setShowTypeDropdown(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    // Scroll to top when search/filter/sort changes
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (isOpen) scrollToTop();
    }, [
        searchTerm,
        activeFilter,
        typeFilter,
        sortBy,
        isOpen
    ]);
    // Function to fetch and cache Pokemon types
    const fetchTypes = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(async (pokemon)=>{
        if (pokemonTypes[pokemon.id]) return;
        const CACHE_KEY = "pokemon-types-cache";
        const CACHE_DURATION = 86400000; // 24 hours
        try {
            // Check if we already have cached types for this Pokemon
            const cachedTypes = localStorage.getItem(CACHE_KEY);
            if (cachedTypes) {
                const { data: data, timestamp: timestamp } = JSON.parse(cachedTypes);
                const now = Date.now();
                if (now - timestamp < CACHE_DURATION && data[pokemon.id]) {
                    setPokemonTypes((prev)=>({
                            ...prev,
                            [pokemon.id]: data[pokemon.id]
                        }));
                    return;
                }
            }
            // Fetch types from API
            const response = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemon.id}`);
            const pokemonData = await response.json();
            const types = pokemonData.types.map((typeInfo)=>({
                    name: typeInfo.type.name,
                    slot: typeInfo.slot
                }));
            // Update cache
            try {
                const existingCache = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
                const cacheData = {
                    data: {
                        ...existingCache.data,
                        [pokemon.id]: types
                    },
                    timestamp: Date.now()
                };
                localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
            } catch (error) {
                console.warn("Failed to save types to cache:", error);
            }
            setPokemonTypes((prev)=>({
                    ...prev,
                    [pokemon.id]: types
                }));
        } catch (error) {
            console.error(`Failed to fetch types for ${pokemon.name}:`, error);
        }
    }, [
        pokemonTypes
    ]);
    // Function to fetch and cache Pokemon descriptions
    const fetchDescription = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(async (pokemon)=>{
        if (pokemonDescriptions[pokemon.id]) return;
        try {
            const response = await fetch(`https://pokeapi.co/api/v2/pokemon-species/${pokemon.originalName}/`);
            const data = await response.json();
            const englishEntry = data.flavor_text_entries?.find((entry)=>entry.language.name === "en");
            const description = englishEntry ? englishEntry.flavor_text.replace(/\f/g, " ").replace(/\n/g, " ").replace(/\s+/g, " ").trim() : "A mysterious Pokemon.";
            setPokemonDescriptions((prev)=>({
                    ...prev,
                    [pokemon.id]: description
                }));
        } catch (error) {
            console.error("Failed to fetch description:", error);
        }
    }, [
        pokemonDescriptions
    ]);
    // Load catch counts from localStorage
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const counts = JSON.parse(localStorage.getItem("pokemon-catch-counts") || "{}");
        setCatchCounts(counts);
    }, [
        isOpen
    ]);
    // Handle scroll events to show/hide scroll-to-top button
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const pokedexContent = document.querySelector(".pokedex-content");
        if (!pokedexContent || !isOpen) return;
        const handleScroll = ()=>{
            const scrollTop = pokedexContent.scrollTop;
            setShowScrollButton(scrollTop > 200);
        };
        pokedexContent.addEventListener("scroll", handleScroll);
        // Initial check
        handleScroll();
        return ()=>{
            pokedexContent.removeEventListener("scroll", handleScroll);
        };
    }, [
        isOpen
    ]);
    // Scroll to highlighted Pokemon when Pokedx opens (only once)
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (isOpen && highlightPokemonId && !hasAutoScrolled) {
            // Clear filters and search to ensure highlighted pokemon is visible
            setSearchTerm("");
            setActiveFilter("all");
            setTypeFilter("all");
            const highlightedPokemon = pokemonList.find((p)=>p.id === highlightPokemonId);
            if (highlightedPokemon) {
                setSelectedPokemon(highlightedPokemon);
                fetchDescription(highlightedPokemon);
                fetchTypes(highlightedPokemon);
            }
            const timer = setTimeout(()=>{
                const element = document.getElementById(`pokemon-${highlightPokemonId}`);
                if (element) element.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                setHasAutoScrolled(true);
            }, 300); // Wait for drawer animation to complete
            return ()=>clearTimeout(timer);
        }
    }, [
        isOpen,
        highlightPokemonId,
        pokemonList,
        fetchDescription,
        fetchTypes,
        hasAutoScrolled
    ]);
    // Reset auto-scroll flag when Pokedex closes
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (!isOpen) setHasAutoScrolled(false);
    }, [
        isOpen
    ]);
    // Load Pokemon cry when selectedPokemon changes
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (selectedPokemon && discoveredPokemon.includes(selectedPokemon.id)) fetchPokemonCry(selectedPokemon.id);
        else {
            // Clean up audio when no Pokemon is selected or Pokemon is undiscovered
            if (pokemonCry) {
                pokemonCry.pause();
                pokemonCry.src = "";
                pokemonCry.load();
            }
            setPokemonCry(null);
            setIsLoadingCry(false);
        }
        // Cleanup function
        return ()=>{
            if (pokemonCry) {
                pokemonCry.pause();
                pokemonCry.src = "";
                pokemonCry.load();
            }
        };
    }, [
        selectedPokemon,
        discoveredPokemon
    ]);
    const fetchPokemonCry = async (pokemonId)=>{
        if (isLoadingCry) return; // Don't fetch if already loading
        // Clean up previous audio
        if (pokemonCry) {
            pokemonCry.pause();
            pokemonCry.src = "";
            pokemonCry.load();
        }
        setIsLoadingCry(true);
        setPokemonCry(null);
        try {
            const cryUrl = `https://raw.githubusercontent.com/PokeAPI/cries/main/cries/pokemon/latest/${pokemonId}.ogg`;
            const audio = new Audio();
            audio.crossOrigin = "anonymous";
            audio.preload = "auto";
            audio.volume = 0.20;
            // Wait for audio to be ready
            await new Promise((resolve, reject)=>{
                const timeout = setTimeout(()=>{
                    reject(new Error("Audio load timeout"));
                }, 5000);
                const cleanup = ()=>{
                    clearTimeout(timeout);
                    audio.removeEventListener("canplaythrough", onLoad);
                    audio.removeEventListener("loadeddata", onLoad);
                    audio.removeEventListener("error", onError);
                };
                const onLoad = ()=>{
                    cleanup();
                    resolve();
                };
                const onError = (e)=>{
                    cleanup();
                    reject(new Error(`Audio load failed: ${e.type}`));
                };
                audio.addEventListener("canplaythrough", onLoad, {
                    once: true
                });
                audio.addEventListener("loadeddata", onLoad, {
                    once: true
                });
                audio.addEventListener("error", onError, {
                    once: true
                });
                // Set source after event listeners are attached
                audio.src = cryUrl;
            });
            setPokemonCry(audio);
        } catch (error) {
            console.warn(`Failed to load Pokemon cry for ID ${pokemonId}:`, error);
            setPokemonCry(null);
        } finally{
            setIsLoadingCry(false);
        }
    };
    const handlePokemonImageClick = ()=>{
        if (pokemonCry && !isLoadingCry) {
            // Reset audio to beginning and play
            pokemonCry.currentTime = 0;
            pokemonCry.play().catch((error)=>{
                console.warn("Failed to play Pokemon cry:", error);
            });
        }
    // Click is always responsive, even if audio isn't ready
    };
    const getPokemonImageTitle = ()=>{
        if (!selectedPokemon || !discoveredPokemon.includes(selectedPokemon.id)) return selectedPokemon ? selectedPokemon.name : "";
        if (isLoadingCry) return `Click to hear ${selectedPokemon.name}'s cry (loading...)`;
        if (pokemonCry) return `Click to hear ${selectedPokemon.name}'s cry!`;
        return `Click to hear ${selectedPokemon.name}'s cry (unavailable)`;
    };
    // Function to highlight matching tokens in pokemon names
    const highlightSearchTerms = (name, searchTerms)=>{
        if (!searchTerms || searchTerms.length === 0) return name;
        // Create a list of all matches with their positions
        const matches = [];
        searchTerms.forEach((token)=>{
            if (token.length === 0) return;
            const regex = new RegExp(token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi");
            let match;
            while((match = regex.exec(name)) !== null)matches.push({
                start: match.index,
                end: match.index + match[0].length,
                text: match[0]
            });
        });
        // Sort matches by start position
        matches.sort((a, b)=>a.start - b.start);
        // Merge overlapping matches
        const mergedMatches = [];
        for (const match of matches)if (mergedMatches.length === 0) mergedMatches.push(match);
        else {
            const last = mergedMatches[mergedMatches.length - 1];
            if (match.start <= last.end) {
                // Overlapping or adjacent - merge them
                last.end = Math.max(last.end, match.end);
                last.text = name.substring(last.start, last.end);
            } else mergedMatches.push(match);
        }
        // Build highlighted string from end to beginning to preserve indices
        let result = name;
        for(let i = mergedMatches.length - 1; i >= 0; i--){
            const match = mergedMatches[i];
            const before = result.substring(0, match.start);
            const highlighted = `<span class="search-highlight-no-spacing">${match.text}</span>`;
            const after = result.substring(match.end);
            result = before + highlighted + after;
        }
        return result;
    };
    // Parse search term into tokens
    const searchTokens = searchTerm.trim().toLowerCase().split(/\s+/).filter((token)=>token.length > 0);
    const filteredPokemon = pokemonList.filter((pokemon)=>{
        // Multi-token search: pokemon name must contain ALL tokens
        const nameMatch = searchTokens.length === 0 || searchTokens.every((token)=>pokemon.name.toLowerCase().includes(token));
        const idMatch = searchTerm === "" || pokemon.id.toString().includes(searchTerm);
        const matchesSearch = nameMatch || idMatch;
        const isDiscovered = discoveredPokemon.includes(pokemon.id);
        const matchesFilter = activeFilter === "all" || activeFilter === "caught" && isDiscovered || activeFilter === "uncaught" && !isDiscovered;
        // Type filtering
        const matchesType = typeFilter === "all" || pokemon.types && pokemon.types.some((type)=>type.name === typeFilter);
        return matchesSearch && matchesFilter && matchesType;
    }).sort((a, b)=>{
        if (sortBy === "pokemon id") return a.id - b.id;
        else if (sortBy === "times caught") {
            const aCount = catchCounts[a.id] || 0;
            const bCount = catchCounts[b.id] || 0;
            return bCount - aCount; // Descending order (most caught first)
        }
        return 0;
    });
    // Get all unique types for the filter dropdown
    const allTypes = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
        return (0, $64dda4da0336267f$export$cd75e89a26d85a6e)(pokemonList);
    }, [
        pokemonList
    ]);
    const CheckIcon = ()=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "#10B981",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: "check-icon",
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polyline", {
                points: "20,6 9,17 4,12"
            })
        });
    const handleOverlayClick = (e)=>{
        if (e.target === e.currentTarget) handleClose();
    };
    // Handle pokemon card clicks with double-tap detection for mobile
    const handlePokemonClick = (pokemon)=>{
        const currentTime = Date.now();
        const isDoubleTap = isMobile && onSubmitGuess && lastTappedPokemon === pokemon.id && currentTime - lastTapTime < 300; // 300ms double-tap threshold
        if (isDoubleTap) {
            // Double tap on mobile - submit as guess
            (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
            onSubmitGuess(pokemon.name);
            handleClose(); // Close Pokedex after submitting guess
        } else {
            // Single tap - normal behavior (show pokemon details)
            (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playGridClick();
            setSelectedPokemon(pokemon);
            if (discoveredPokemon.includes(pokemon.id)) {
                fetchDescription(pokemon);
                fetchTypes(pokemon);
            }
            // Update last tap tracking
            setLastTapTime(currentTime);
            setLastTappedPokemon(pokemon.id);
        }
    };
    const scrollToTop = ()=>{
        const pokedexContent = document.querySelector(".pokedex-content");
        if (pokedexContent) pokedexContent.scrollTo({
            top: 0
        });
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        className: `pokedex-overlay ${isOpen ? "open" : ""}`,
        onClick: handleOverlayClick,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
            className: "pokedex-drawer",
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "pokedex-header",
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: "close-button",
                            onClick: handleClose,
                            onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                            children: "\xd7"
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h2", {
                            className: "pokedex-title",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f4c4337c26d2b8c9$exports))),
                                    alt: "Open Pok\xe9dex"
                                }),
                                "Pok\xe9dex"
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "progress-container",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "progress-text",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                        children: "Caught:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "progress-bar",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                        className: "progress-fill",
                                        style: {
                                            width: `${discoveredPokemon.length / 151 * 100}%`
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "progress-text",
                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                        className: isMaster ? "header-trophy" : "",
                                        children: [
                                            discoveredPokemon.length,
                                            "/151 (",
                                            Math.round(discoveredPokemon.length / 151 * 100),
                                            "%)",
                                            isMaster && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                src: trophyIcon,
                                                alt: "Pok\xe9mon Master",
                                                className: "trophy-icon pokedex-trophy"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "search-sort-row",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "search-container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3509963a71bdf3b0$exports))),
                                            alt: "Search",
                                            className: "search-icon"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("input", {
                                            ref: searchInputRef,
                                            type: "text",
                                            placeholder: "Search pok\xe9mon...",
                                            value: searchTerm,
                                            onChange: (e)=>setSearchTerm(e.target.value),
                                            onFocus: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playInputClick(),
                                            onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playInputHover(),
                                            className: "pokedex-search",
                                            title: "Tip: You can search for multiple distinct letters by separating with spaces. For example: 'B S R' will find 'Bulbasaur'"
                                        }),
                                        searchTerm && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                            className: "clear-search-button",
                                            onClick: ()=>setSearchTerm(""),
                                            "aria-label": "Clear search",
                                            children: "\xd7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "sort-filter-container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "type-filter-container",
                                            ref: typeDropdownRef,
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                    className: `type-filter-button ${isMobile ? "mobile" : ""}`,
                                                    onClick: ()=>{
                                                        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                                        setShowTypeDropdown(!showTypeDropdown);
                                                    },
                                                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterHover(),
                                                    children: isMobile ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                                        children: [
                                                            typeFilter === "all" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 24 24",
                                                                fill: "currentColor",
                                                                stroke: "none",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                                                    d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                                                })
                                                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $653dbffadcea7caf$export$2e2bcd8739ae039), {
                                                                type: typeFilter,
                                                                variant: "circular",
                                                                size: "small"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                className: "type-filter-caret",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polyline", {
                                                                    points: "6,9 12,15 18,9"
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                                        children: [
                                                            typeFilter === "all" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                                                        width: "16",
                                                                        height: "16",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "currentColor",
                                                                        stroke: "none",
                                                                        style: {
                                                                            color: "#fbbf24"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                                                            d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                                        children: "All Types"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $653dbffadcea7caf$export$2e2bcd8739ae039), {
                                                                type: typeFilter,
                                                                variant: "mini",
                                                                size: "small"
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                className: "type-filter-caret",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polyline", {
                                                                    points: "6,9 12,15 18,9"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                showTypeDropdown && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "type-filter-dropdown",
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                                            onClick: ()=>{
                                                                (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                                                setTypeFilter("all");
                                                                setShowTypeDropdown(false);
                                                            },
                                                            onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterHover(),
                                                            className: typeFilter === "all" ? "active" : "",
                                                            children: [
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                                                    width: "16",
                                                                    height: "16",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "currentColor",
                                                                    stroke: "none",
                                                                    style: {
                                                                        color: "#fbbf24"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                                                        d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                                                    children: "All Types"
                                                                })
                                                            ]
                                                        }),
                                                        allTypes.map((type)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                                onClick: ()=>{
                                                                    (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                                                    setTypeFilter(type);
                                                                    setShowTypeDropdown(false);
                                                                },
                                                                onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterHover(),
                                                                className: typeFilter === type ? "active" : "",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $653dbffadcea7caf$export$2e2bcd8739ae039), {
                                                                    type: type,
                                                                    variant: "full",
                                                                    size: "small"
                                                                })
                                                            }, type))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "sort-container",
                                            ref: sortDropdownRef,
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                    className: `sort-button ${isMobile ? "mobile" : ""}`,
                                                    onClick: ()=>{
                                                        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                                        setShowSortDropdown(!showSortDropdown);
                                                    },
                                                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterHover(),
                                                    children: isMobile ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                                                    d: "M3 6h18M7 12h10m-7 6h4"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                className: "sort-caret",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polyline", {
                                                                    points: "6,9 12,15 18,9"
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                                                    d: "M3 6h18M7 12h10m-7 6h4"
                                                                })
                                                            }),
                                                            sortBy === "pokemon id" ? "Id" : "# Caught",
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                className: "sort-caret",
                                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polyline", {
                                                                    points: "6,9 12,15 18,9"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                showSortDropdown && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "sort-dropdown",
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            onClick: ()=>{
                                                                (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                                                setSortBy("pokemon id");
                                                                setShowSortDropdown(false);
                                                            },
                                                            onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterHover(),
                                                            className: sortBy === "pokemon id" ? "active" : "",
                                                            children: "Pokemon ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            onClick: ()=>{
                                                                (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                                                setSortBy("times caught");
                                                                setShowSortDropdown(false);
                                                            },
                                                            onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterHover(),
                                                            className: sortBy === "times caught" ? "active" : "",
                                                            children: "Times Caught"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "filter-tabs",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                    className: `filter-tab ${activeFilter === "all" ? "active" : ""}`,
                                    onClick: ()=>{
                                        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                        setActiveFilter("all");
                                    },
                                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterHover(),
                                    children: [
                                        "All (",
                                        pokemonList.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                    className: `filter-tab ${activeFilter === "caught" ? "active" : ""}`,
                                    onClick: ()=>{
                                        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                        setActiveFilter("caught");
                                    },
                                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterHover(),
                                    children: [
                                        "Caught (",
                                        discoveredPokemon.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("button", {
                                    className: `filter-tab ${activeFilter === "uncaught" ? "active" : ""}`,
                                    onClick: ()=>{
                                        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterClick();
                                        setActiveFilter("uncaught");
                                    },
                                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playFilterHover(),
                                    children: [
                                        "Uncaught (",
                                        pokemonList.length - discoveredPokemon.length,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "pokedex-content",
                    children: [
                        (searchTerm || typeFilter !== "all") && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "search-results-counter",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("em", {
                                children: [
                                    filteredPokemon.length,
                                    " Pok\xe9mon ",
                                    searchTerm ? "matching search" : "found"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "pokemon-grid",
                            children: filteredPokemon.length > 0 ? filteredPokemon.map((pokemon)=>{
                                const isDiscovered = discoveredPokemon.includes(pokemon.id);
                                const isHighlighted = highlightPokemonId === pokemon.id;
                                return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    id: `pokemon-${pokemon.id}`,
                                    className: `pokemon-card ${isDiscovered ? "discovered" : "undiscovered"} ${isHighlighted ? "highlighted" : ""}`,
                                    onClick: ()=>handlePokemonClick(pokemon),
                                    onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonHover(),
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                            src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${pokemon.id}.png`,
                                            alt: pokemon.name,
                                            className: "pokemon-image",
                                            onError: (e)=>{
                                                e.target.src = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${pokemon.id}.png`;
                                            }
                                        }),
                                        isDiscovered && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "discovery-badge",
                                            title: "You've caught this Pok\xe9mon"
                                        }),
                                        isDiscovered && singleGuessPokemon && singleGuessPokemon.includes(pokemon.id) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "single-guess-badge",
                                            title: "Caught in a single guess",
                                            children: "\u2605"
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "pokemon-number",
                                            children: [
                                                "#",
                                                pokemon.id.toString().padStart(3, "0")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "pokemon-name-container",
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "pokemon-name",
                                                    dangerouslySetInnerHTML: {
                                                        __html: highlightSearchTerms(pokemon.name, searchTokens)
                                                    }
                                                }),
                                                onSubmitGuess && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "pokemon-share-container",
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                                                            className: "pokemon-share-button",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playButtonClick();
                                                                onSubmitGuess(pokemon.name);
                                                                handleClose(); // Close Pokedex after submitting guess
                                                            },
                                                            onMouseEnter: ()=>{
                                                                (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover();
                                                                setHoveredShareButton(pokemon.id);
                                                            },
                                                            onMouseLeave: ()=>setHoveredShareButton(null),
                                                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7dde8f59b3f46c3f$exports))),
                                                                alt: "Submit guess",
                                                                className: "share-icon"
                                                            })
                                                        }),
                                                        hoveredShareButton === pokemon.id && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                            className: "share-tooltip",
                                                            children: [
                                                                "Submit ",
                                                                pokemon.name,
                                                                " as your guess"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                            className: "pokemon-card-bottom",
                                            children: [
                                                pokemon.types && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "pokemon-type-icons",
                                                    children: pokemon.types.map((type, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $653dbffadcea7caf$export$2e2bcd8739ae039), {
                                                            type: type.name,
                                                            variant: "circular",
                                                            size: "small"
                                                        }, index))
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                    className: "pokemon-catch-count",
                                                    style: {
                                                        opacity: isDiscovered && catchCounts[pokemon.id] ? 1 : 0
                                                    },
                                                    title: isDiscovered && catchCounts[pokemon.id] ? `You've caught ${catchCounts[pokemon.id]} ${pokemon.name}` : "",
                                                    children: [
                                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f4c4337c26d2b8c9$exports))),
                                                            alt: "Pokeball",
                                                            className: "catch-count-icon"
                                                        }),
                                                        catchCounts[pokemon.id] || 0
                                                    ]
                                                })
                                            ]
                                        }),
                                        "                                "
                                    ]
                                }, pokemon.id);
                            }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "pokedex-empty-state",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f4c4337c26d2b8c9$exports))),
                                        alt: "Pokeball",
                                        className: "empty-state-icon"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                        className: "empty-state-message",
                                        children: [
                                            activeFilter === "caught" && "No pokemon caught, yet.",
                                            activeFilter === "uncaught" && "Caught 'em all!",
                                            activeFilter === "all" && "No pokemon found."
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: `scroll-to-top-button ${showScrollButton ? "visible" : ""}`,
                            onClick: scrollToTop,
                            "aria-label": "Scroll to top",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("polyline", {
                                    points: "18,15 12,9 6,15"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "pokemon-description-panel",
                    children: [
                        selectedPokemon ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "description-content",
                            children: [
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                    className: "description-image-container",
                                    children: [
                                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                            src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${selectedPokemon.id}.png`,
                                            alt: selectedPokemon.name,
                                            className: `description-pokemon-image ${discoveredPokemon.includes(selectedPokemon.id) ? "discovered clickable-pokemon" : "undiscovered"}`,
                                            onClick: discoveredPokemon.includes(selectedPokemon.id) ? handlePokemonImageClick : undefined,
                                            title: getPokemonImageTitle(),
                                            onError: (e)=>{
                                                e.target.src = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${selectedPokemon.id}.png`;
                                            }
                                        }),
                                        discoveredPokemon.includes(selectedPokemon.id) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                            className: "description-discovery-badge"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "description-info",
                                    children: discoveredPokemon.includes(selectedPokemon.id) ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                className: "description-header",
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("strong", {
                                                        children: [
                                                            "#",
                                                            selectedPokemon.id.toString().padStart(3, "0"),
                                                            " ",
                                                            selectedPokemon.name
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                        className: "desc-header-detail",
                                                        children: [
                                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                                className: "type-badges",
                                                                children: pokemonTypes[selectedPokemon.id]?.map((typeInfo, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $653dbffadcea7caf$export$2e2bcd8739ae039), {
                                                                        type: typeInfo.name,
                                                                        variant: "full",
                                                                        size: "medium"
                                                                    }, index))
                                                            }),
                                                            catchCounts[selectedPokemon.id] && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                                                className: "description-catch-count",
                                                                title: `You've caught ${catchCounts[selectedPokemon.id]} ${selectedPokemon.name}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f4c4337c26d2b8c9$exports))),
                                                                        alt: "Pokeball",
                                                                        className: "description-catch-icon"
                                                                    }),
                                                                    catchCounts[selectedPokemon.id]
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                className: "description-text",
                                                children: pokemonDescriptions[selectedPokemon.id] || "Loading description..."
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                className: "description-header",
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("strong", {
                                                    children: [
                                                        "#",
                                                        selectedPokemon.id.toString().padStart(3, "0"),
                                                        " ???"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                className: "description-text undiscovered-text",
                                                children: "Catch this Pok\xe9mon to learn more"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "description-content",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "description-placeholder",
                                children: "Click a Pok\xe9mon to learn more"
                            })
                        }),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                            className: "pokedex-close-button",
                            onClick: handleClose,
                            onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                            children: "Close Pok\xe9dex"
                        })
                    ]
                })
            ]
        })
    });
}
var $1bb815d3b481b534$export$2e2bcd8739ae039 = $1bb815d3b481b534$var$Pokedex;






var $bh6RR = parcelRequire("bh6RR");
var $0e1a4ec686581db9$exports = {};
$0e1a4ec686581db9$exports = new URL("pokemon-master.6b47ce1a.png", import.meta.url).toString();


var $b79aeaec2dded28f$exports = {};
$b79aeaec2dded28f$exports = new URL("pokemon-progress.f5a323ba.png", import.meta.url).toString();


var $4127f74ac3f08a4d$exports = {};
$4127f74ac3f08a4d$exports = new URL("trophy-star.7f38dfc2.svg", import.meta.url).toString();


var $a68c09bb7338c477$exports = {};
$a68c09bb7338c477$exports = new URL("trophy.3203088e.svg", import.meta.url).toString();



function $955e7bd6140e907d$var$Celebrations({ showMasterCelebration: showMasterCelebration, showProgressCelebration: showProgressCelebration, showLegendCelebration: showLegendCelebration, showFirstPokemonCelebration: showFirstPokemonCelebration, progressCount: progressCount, onDismissMaster: onDismissMaster, onDismissProgress: onDismissProgress, onDismissLegend: onDismissLegend, onDismissFirstPokemon: onDismissFirstPokemon, onHoorayClick: onHoorayClick, onLegendHoorayClick: onLegendHoorayClick, meetPikaImage: meetPikaImage }) {
    const [confettiKey, setConfettiKey] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [hoorayFireworks, setHoorayFireworks] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [isFadingOut, setIsFadingOut] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    // Create confetti animation
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        if (showMasterCelebration || showProgressCelebration || showLegendCelebration || showFirstPokemonCelebration) {
            setConfettiKey((prev)=>prev + 1);
            setIsFadingOut(false);
            // Play victory beat for progress, master, and legend celebrations
            if (showProgressCelebration || showMasterCelebration || showLegendCelebration) (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playVictoryBeat();
        }
    }, [
        showMasterCelebration,
        showProgressCelebration,
        showLegendCelebration,
        showFirstPokemonCelebration
    ]);
    const handleHoorayClick = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
        // Trigger more fireworks immediately
        setHoorayFireworks(true);
        setConfettiKey((prev)=>prev + 1);
        // Start fade out animation
        setIsFadingOut(true);
        // Stop victory music and reset fireworks and dismiss after fade completes
        setTimeout(()=>{
            (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).stopVictoryBeat();
            setHoorayFireworks(false);
            onHoorayClick();
        }, 2000);
    };
    const handleLegendHoorayClick = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
        // Trigger more fireworks immediately
        setHoorayFireworks(true);
        setConfettiKey((prev)=>prev + 1);
        // Start fade out animation
        setIsFadingOut(true);
        // Stop victory music and reset fireworks and dismiss after fade completes
        setTimeout(()=>{
            (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).stopVictoryBeat();
            setHoorayFireworks(false);
            onLegendHoorayClick();
        }, 2000);
    };
    const handleProgressDismiss = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).stopVictoryBeat();
        // Start fade out animation
        setIsFadingOut(true);
        // Dismiss after fade completes
        setTimeout(()=>{
            onDismissProgress();
        }, 800);
    };
    const handleFirstPokemonDismiss = ()=>{
        (0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playModalDismiss();
        // Start fade out animation
        setIsFadingOut(true);
        // Dismiss after fade completes
        setTimeout(()=>{
            onDismissFirstPokemon();
        }, 800);
    };
    if (showFirstPokemonCelebration) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: `celebration-overlay first-pokemon-celebration ${isFadingOut ? "fade-out" : ""}`,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "confetti-container",
                children: [
                    ...Array(30)
                ].map((_, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "confetti-piece",
                        style: {
                            left: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 2}s`,
                            backgroundColor: [
                                "#FFD700",
                                "#FF6B9D",
                                "#4ECDC4",
                                "#45B7D1",
                                "#FFA07A"
                            ][Math.floor(Math.random() * 5)]
                        }
                    }, i))
            }, `first-${confettiKey}`),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "celebration-content first-pokemon-content",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                        className: "celebration-title first-pokemon-title",
                        children: "Welcome!"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: meetPikaImage,
                        alt: "Meet Pikachu",
                        className: "celebration-image first-pokemon-image",
                        style: {
                            maxWidth: "500px",
                            width: "100%"
                        }
                    }, "first-pokemon-celebration-image"),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        className: "celebration-message first-pokemon-message",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                children: "Congratulations on your first Pok\xe9mon!"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            "You caught Pikachu! You're on your way to becoming a Pok\xe9mon master."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        className: "celebration-button first-pokemon-button",
                        onClick: handleFirstPokemonDismiss,
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                        children: "Let's catch 'em all!"
                    })
                ]
            })
        ]
    });
    if (showLegendCelebration) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: `celebration-overlay legend-celebration ${isFadingOut ? "fade-out" : ""}`,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "confetti-container",
                children: [
                    [
                        ...Array(100)
                    ].map((_, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "confetti-piece",
                            style: {
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 3}s`,
                                backgroundColor: [
                                    "#FFD700",
                                    "#FFA500",
                                    "#FF6347",
                                    "#FF69B4",
                                    "#00CED1"
                                ][Math.floor(Math.random() * 5)]
                            }
                        }, i)),
                    hoorayFireworks && [
                        ...Array(200)
                    ].map((_, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "confetti-piece hooray-confetti",
                            style: {
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 0.3}s`,
                                backgroundColor: [
                                    "#FFD700",
                                    "#FFA500",
                                    "#FF6347",
                                    "#32CD32",
                                    "#FF1493"
                                ][Math.floor(Math.random() * 5)]
                            }
                        }, `hooray-${i}`))
                ]
            }, `legend-${confettiKey}`),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "celebration-content legend-content",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                        className: "celebration-title legend-title",
                        children: "LEGEND."
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "celebration-progress-container",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "celebration-progress-bar",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "celebration-progress-fill legend-progress-fill",
                                    style: {
                                        width: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "celebration-progress-text",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        children: "151/151 Single Guesses"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4127f74ac3f08a4d$exports))),
                                        alt: "Trophy Star",
                                        style: {
                                            width: "20px",
                                            height: "20px",
                                            marginLeft: "4px",
                                            filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.3))"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0e1a4ec686581db9$exports))),
                        alt: "Pokemon Legend",
                        className: "celebration-image legend-image",
                        style: {
                            filter: "sepia(1) saturate(2) hue-rotate(40deg)"
                        }
                    }, "legend-celebration-image"),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        className: "celebration-message legend-message",
                        children: [
                            "You've caught every pokemon with 1 guess. Incredible! ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            "There are few Pokemon masters, even fewer ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                children: "legends"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        className: "celebration-button legend-button",
                        onClick: handleLegendHoorayClick,
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                        children: "Legendary!"
                    })
                ]
            })
        ]
    });
    if (showMasterCelebration) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: `celebration-overlay master-celebration ${isFadingOut ? "fade-out" : ""}`,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "confetti-container",
                children: [
                    [
                        ...Array(50)
                    ].map((_, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "confetti-piece",
                            style: {
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 3}s`,
                                backgroundColor: [
                                    "#FF6B9D",
                                    "#4ECDC4",
                                    "#45B7D1",
                                    "#FFA07A",
                                    "#98D8C8"
                                ][Math.floor(Math.random() * 5)]
                            }
                        }, i)),
                    hoorayFireworks && [
                        ...Array(100)
                    ].map((_, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                            className: "confetti-piece hooray-confetti",
                            style: {
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 0.5}s`,
                                backgroundColor: [
                                    "#FFD700",
                                    "#FF69B4",
                                    "#00CED1",
                                    "#FF4500",
                                    "#32CD32"
                                ][Math.floor(Math.random() * 5)]
                            }
                        }, `hooray-${i}`))
                ]
            }, `master-${confettiKey}`),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "celebration-content master-content",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("h1", {
                        className: "celebration-title",
                        children: "You've caught 'em all!"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "celebration-progress-container",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "celebration-progress-bar",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "celebration-progress-fill master-progress-fill",
                                    style: {
                                        width: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "celebration-progress-text",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                        children: "151/151 (100%)"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a68c09bb7338c477$exports))),
                                        alt: "Trophy",
                                        style: {
                                            width: "20px",
                                            height: "20px",
                                            marginLeft: "4px",
                                            filter: "sepia(1) saturate(3) hue-rotate(40deg) brightness(1.2)"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0e1a4ec686581db9$exports))),
                        alt: "Pokemon Master",
                        className: "celebration-image master-image"
                    }, "master-celebration-image"),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        className: "celebration-message master-message",
                        children: [
                            "151, baby! Amazing. ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                            " You have officially earned the rank of ",
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                children: "Pok\xe9mon Master"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        className: "celebration-button hooray-button",
                        onClick: handleHoorayClick,
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                        children: "Hooray!"
                    })
                ]
            })
        ]
    });
    if (showProgressCelebration) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: `celebration-overlay progress-celebration ${isFadingOut ? "fade-out" : ""}`,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "confetti-container",
                children: [
                    ...Array(20)
                ].map((_, i)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "confetti-piece",
                        style: {
                            left: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 2}s`,
                            backgroundColor: [
                                "#FF6B9D",
                                "#4ECDC4",
                                "#45B7D1",
                                "#FFA07A",
                                "#98D8C8"
                            ][Math.floor(Math.random() * 5)]
                        }
                    }, i))
            }, `progress-${confettiKey}`),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "celebration-content progress-content",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("h2", {
                        className: "celebration-title progress-title",
                        children: [
                            "You've caught ",
                            progressCount,
                            "!"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "celebration-progress-container",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "celebration-progress-bar",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "celebration-progress-fill",
                                    style: {
                                        "--target-width": `${progressCount / 151 * 100}%`,
                                        width: `${progressCount / 151 * 100}%`
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "celebration-progress-text",
                                children: [
                                    progressCount,
                                    "/151 (",
                                    Math.round(progressCount / 151 * 100),
                                    "%)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        className: "celebration-message progress-message",
                        children: "Congrats on catching so many Pok\xe9mon. Keep it going!"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b79aeaec2dded28f$exports))),
                        alt: "Pokemon Progress",
                        className: "celebration-image progress-image"
                    }, "progress-celebration-image"),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("button", {
                        className: "celebration-button progress-button",
                        onClick: handleProgressDismiss,
                        onMouseEnter: ()=>(0, $5832135ea2ff6ecf$export$2e2bcd8739ae039).playBubbleHover(),
                        children: "Let's go!"
                    })
                ]
            })
        ]
    });
    return null;
}
var $955e7bd6140e907d$export$2e2bcd8739ae039 = $955e7bd6140e907d$var$Celebrations;






var $13c4a850d99b1205$exports = {};
$13c4a850d99b1205$exports = new URL("meet-pika.c1168535.png", import.meta.url).toString();


// Helper functions for localStorage management
const $5c4c715ef872aa13$var$getDiscoveredPokemon = ()=>{
    try {
        const stored = localStorage.getItem("discovered-pokemon");
        return stored ? JSON.parse(stored) : [];
    } catch (error) {
        console.warn("Failed to read discovered Pokemon from localStorage:", error);
        return [];
    }
};
const $5c4c715ef872aa13$var$saveDiscoveredPokemon = (discoveredList)=>{
    try {
        localStorage.setItem("discovered-pokemon", JSON.stringify(discoveredList));
    } catch (error) {
        console.warn("Failed to save discovered Pokemon to localStorage:", error);
    }
};
// Helper functions for single-guess catches
const $5c4c715ef872aa13$var$getSingleGuessPokemon = ()=>{
    try {
        const stored = localStorage.getItem("single-guess-pokemon");
        return stored ? JSON.parse(stored) : [];
    } catch (error) {
        console.warn("Failed to read single-guess Pokemon from localStorage:", error);
        return [];
    }
};
const $5c4c715ef872aa13$var$saveSingleGuessPokemon = (singleGuessList)=>{
    try {
        localStorage.setItem("single-guess-pokemon", JSON.stringify(singleGuessList));
    } catch (error) {
        console.warn("Failed to save single-guess Pokemon to localStorage:", error);
    }
};
function $5c4c715ef872aa13$var$App() {
    const [gameKey, setGameKey] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [isPokedexOpen, setIsPokedexOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [highlightPokemonId, setHighlightPokemonId] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [pokemonList, setPokemonList] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [discoveredPokemon, setDiscoveredPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState($5c4c715ef872aa13$var$getDiscoveredPokemon());
    const [singleGuessPokemon, setSingleGuessPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState($5c4c715ef872aa13$var$getSingleGuessPokemon());
    const [showMasterCelebration, setShowMasterCelebration] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [showProgressCelebration, setShowProgressCelebration] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [showLegendCelebration, setShowLegendCelebration] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [showFirstPokemonCelebration, setShowFirstPokemonCelebration] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [progressCount, setProgressCount] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(0);
    const [isMaster, setIsMaster] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [isLegend, setIsLegend] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    const [settings, setSettings] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(()=>{
        try {
            const stored = localStorage.getItem("squirtle-wordle-settings");
            return stored ? JSON.parse(stored) : {
                hideHints: false,
                noRepeatPokemon: false,
                classicSounds: true,
                autoOpenPokedex: true
            };
        } catch  {
            return {
                hideHints: false,
                noRepeatPokemon: false,
                classicSounds: true,
                autoOpenPokedex: true
            };
        }
    });
    const gameRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef();
    const gameResultRef = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef();
    function handleReset() {
        setGameKey((prevKey)=>prevKey + 1);
    }
    function handleOpenPokedex(pokemonIdToHighlight = null) {
        setHighlightPokemonId(pokemonIdToHighlight);
        setIsPokedexOpen(true);
    }
    function handleClosePokedex() {
        setIsPokedexOpen(false);
        setHighlightPokemonId(null);
        // Restore focus to play again button when Pokedex closes
        gameResultRef.current?.focus();
    }
    function handlePokemonDiscovered(pokemonId, wasSingleGuess = false) {
        if (!discoveredPokemon.includes(pokemonId)) {
            const newDiscovered = [
                ...discoveredPokemon,
                pokemonId
            ];
            const newCount = newDiscovered.length;
            setDiscoveredPokemon(newDiscovered);
            $5c4c715ef872aa13$var$saveDiscoveredPokemon(newDiscovered);
            // Check for legend celebration (all 151 caught with single guesses) - delay to let pokeball animation finish
            if (wasSingleGuess && !singleGuessPokemon.includes(pokemonId)) {
                const newSingleGuess = [
                    ...singleGuessPokemon,
                    pokemonId
                ];
                setSingleGuessPokemon(newSingleGuess);
                $5c4c715ef872aa13$var$saveSingleGuessPokemon(newSingleGuess);
                // Check if user has become a legend (all 151 with single guesses)
                if (newSingleGuess.length === 151) {
                    setTimeout(()=>{
                        setIsLegend(true);
                        setShowLegendCelebration(true);
                    }, 1500);
                    return; // Exit early to show legend celebration instead of master
                }
            }
            // Special case: First Pokemon celebration
            if (newCount === 1) setTimeout(()=>{
                setShowFirstPokemonCelebration(true);
            }, 1500);
            else if (newCount === 151) setTimeout(()=>{
                setIsMaster(true);
                setShowMasterCelebration(true);
            }, 1500);
            else if (newCount % 10 === 0 && newCount >= 10) setTimeout(()=>{
                setProgressCount(newCount);
                setShowProgressCelebration(true);
            }, 1500);
        }
    }
    function handlePokemonListLoaded(list) {
        setPokemonList(list);
    }
    function handleDismissMaster() {
        setShowMasterCelebration(false);
    }
    function handleDismissProgress() {
        setShowProgressCelebration(false);
    }
    function handleDismissLegend() {
        setShowLegendCelebration(false);
    }
    function handleDismissFirstPokemon() {
        setShowFirstPokemonCelebration(false);
    }
    function handleLegendHoorayClick() {
        setShowLegendCelebration(false);
    }
    function handleSubmitGuess(pokemonName) {
        if (gameRef.current && gameRef.current.isGameActive) gameRef.current.submitGuess(pokemonName);
    }
    function handleHoorayClick() {
        setShowMasterCelebration(false);
    }
    // Check if user is already a master or legend on load
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        setIsMaster(discoveredPokemon.length === 151);
        setIsLegend(singleGuessPokemon.length === 151);
    }, [
        discoveredPokemon.length,
        singleGuessPokemon.length
    ]);
    // Listen for settings changes from localStorage
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const handleStorageChange = ()=>{
            try {
                const stored = localStorage.getItem("squirtle-wordle-settings");
                if (stored) setSettings(JSON.parse(stored));
            } catch  {
            // Keep current settings on parse error
            }
        };
        // Listen for custom settings change events
        const handleSettingsChange = ()=>{
            handleStorageChange();
        };
        // Poll for localStorage changes (in case same-tab changes aren't triggering events)
        const pollInterval = setInterval(handleStorageChange, 1000);
        window.addEventListener("storage", handleStorageChange);
        window.addEventListener("settingsChanged", handleSettingsChange);
        return ()=>{
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("settingsChanged", handleSettingsChange);
            clearInterval(pollInterval);
        };
    }, []);
    // Add event listeners for test functions
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const handleTestMaster = ()=>{
            setShowMasterCelebration(true);
        };
        const handleTestLegend = ()=>{
            setShowLegendCelebration(true);
        };
        const handleTestProgress = (event)=>{
            const count = event.detail?.count || 50;
            setProgressCount(count);
            setShowProgressCelebration(true);
        };
        window.addEventListener("testMasterCelebration", handleTestMaster);
        window.addEventListener("testLegendCelebration", handleTestLegend);
        window.addEventListener("testProgressCelebration", handleTestProgress);
        // Add test function to window for legend celebration
        window.testLegendCelebration = ()=>{
            setShowLegendCelebration(true);
        };
        return ()=>{
            window.removeEventListener("testMasterCelebration", handleTestMaster);
            window.removeEventListener("testLegendCelebration", handleTestLegend);
            window.removeEventListener("testProgressCelebration", handleTestProgress);
            delete window.testLegendCelebration;
        };
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "wrapper",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02ce57c81a0104d3$export$2e2bcd8739ae039), {
                onReset: handleReset,
                onOpenPokedex: handleOpenPokedex,
                discoveredCount: discoveredPokemon.length,
                totalCount: pokemonList.length,
                isMaster: isMaster,
                isLegend: isLegend,
                trophyIcon: isLegend ? (0, (/*@__PURE__*/$parcel$interopDefault($4127f74ac3f08a4d$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($a68c09bb7338c477$exports)))
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "game-wrapper",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $64dda4da0336267f$export$2e2bcd8739ae039), {
                    ref: gameRef,
                    gameResultRef: gameResultRef,
                    onPokemonDiscovered: handlePokemonDiscovered,
                    onPokemonListLoaded: handlePokemonListLoaded,
                    onOpenPokedex: handleOpenPokedex,
                    settings: settings
                }, gameKey)
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1bb815d3b481b534$export$2e2bcd8739ae039), {
                isOpen: isPokedexOpen,
                onClose: handleClosePokedex,
                pokemonList: pokemonList,
                discoveredPokemon: discoveredPokemon,
                singleGuessPokemon: singleGuessPokemon,
                highlightPokemonId: highlightPokemonId,
                isMaster: isMaster,
                trophyIcon: (0, (/*@__PURE__*/$parcel$interopDefault($a68c09bb7338c477$exports))),
                onSubmitGuess: handleSubmitGuess
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $955e7bd6140e907d$export$2e2bcd8739ae039), {
                showMasterCelebration: showMasterCelebration,
                showProgressCelebration: showProgressCelebration,
                showLegendCelebration: showLegendCelebration,
                showFirstPokemonCelebration: showFirstPokemonCelebration,
                progressCount: progressCount,
                onDismissMaster: handleDismissMaster,
                onDismissProgress: handleDismissProgress,
                onDismissLegend: handleDismissLegend,
                onDismissFirstPokemon: handleDismissFirstPokemon,
                onHoorayClick: handleHoorayClick,
                onLegendHoorayClick: handleLegendHoorayClick,
                meetPikaImage: (0, (/*@__PURE__*/$parcel$interopDefault($13c4a850d99b1205$exports)))
            })
        ]
    });
}
var $5c4c715ef872aa13$export$2e2bcd8739ae039 = $5c4c715ef872aa13$var$App;






const $1f0dc3b9307be026$var$root = (0, $6fc264ec92100d3a$exports.createRoot)(document.querySelector("#root"));
$1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5c4c715ef872aa13$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.1d93ad64.js.map
